[
  {
    "code": "US-SC-001",
    "name": "Abbeville"
  },
  {
    "code": "US-LA-001",
    "name": "Acadia"
  },
  {
    "code": "US-VA-001",
    "name": "Accomack"
  },
  {
    "code": "US-ID-001",
    "name": "Ada"
  },
  {
    "code": "US-IA-001",
    "name": "Adair"
  },
  {
    "code": "US-MO-001",
    "name": "Adair"
  },
  {
    "code": "US-KY-001",
    "name": "Adair"
  },
  {
    "code": "US-OK-001",
    "name": "Adair"
  },
  {
    "code": "US-ND-001",
    "name": "Adams"
  },
  {
    "code": "US-NE-001",
    "name": "Adams"
  },
  {
    "code": "US-PA-001",
    "name": "Adams"
  },
  {
    "code": "US-IA-003",
    "name": "Adams"
  },
  {
    "code": "US-ID-003",
    "name": "Adams"
  },
  {
    "code": "US-OH-001",
    "name": "Adams"
  },
  {
    "code": "US-IL-001",
    "name": "Adams"
  },
  {
    "code": "US-CO-001",
    "name": "Adams"
  },
  {
    "code": "US-IN-001",
    "name": "Adams"
  },
  {
    "code": "US-MS-001",
    "name": "Adams"
  },
  {
    "code": "US-WA-001",
    "name": "Adams"
  },
  {
    "code": "US-WI-001",
    "name": "Adams"
  },
  {
    "code": "US-VT-001",
    "name": "Addison"
  },
  {
    "code": "US-SC-003",
    "name": "Aiken"
  },
  {
    "code": "US-MN-001",
    "name": "Aitkin"
  },
  {
    "code": "US-FL-001",
    "name": "Alachua"
  },
  {
    "code": "US-NC-001",
    "name": "Alamance"
  },
  {
    "code": "US-CA-001",
    "name": "Alameda"
  },
  {
    "code": "US-CO-003",
    "name": "Alamosa"
  },
  {
    "code": "US-WY-001",
    "name": "Albany"
  },
  {
    "code": "US-NY-001",
    "name": "Albany"
  },
  {
    "code": "US-VA-003",
    "name": "Albemarle"
  },
  {
    "code": "US-MI-001",
    "name": "Alcona"
  },
  {
    "code": "US-MS-003",
    "name": "Alcorn"
  },
  {
    "code": "US-AK-013",
    "name": "Aleutians East Borough"
  },
  {
    "code": "US-AK-016",
    "name": "Aleutians West Census Area"
  },
  {
    "code": "US-NC-003",
    "name": "Alexander"
  },
  {
    "code": "US-IL-003",
    "name": "Alexander"
  },
  {
    "code": "US-VA-510",
    "name": "Alexandria"
  },
  {
    "code": "US-OK-003",
    "name": "Alfalfa"
  },
  {
    "code": "US-MI-003",
    "name": "Alger"
  },
  {
    "code": "US-IA-005",
    "name": "Allamakee"
  },
  {
    "code": "US-MI-005",
    "name": "Allegan"
  },
  {
    "code": "US-NY-003",
    "name": "Allegany"
  },
  {
    "code": "US-MD-001",
    "name": "Allegany"
  },
  {
    "code": "US-VA-005",
    "name": "Alleghany"
  },
  {
    "code": "US-NC-005",
    "name": "Alleghany"
  },
  {
    "code": "US-PA-003",
    "name": "Allegheny"
  },
  {
    "code": "US-KS-001",
    "name": "Allen"
  },
  {
    "code": "US-OH-003",
    "name": "Allen"
  },
  {
    "code": "US-KY-003",
    "name": "Allen"
  },
  {
    "code": "US-IN-003",
    "name": "Allen"
  },
  {
    "code": "US-LA-003",
    "name": "Allen"
  },
  {
    "code": "US-SC-005",
    "name": "Allendale"
  },
  {
    "code": "US-MI-007",
    "name": "Alpena"
  },
  {
    "code": "US-CA-003",
    "name": "Alpine"
  },
  {
    "code": "US-CA-005",
    "name": "Amador"
  },
  {
    "code": "US-VA-007",
    "name": "Amelia"
  },
  {
    "code": "US-VA-009",
    "name": "Amherst"
  },
  {
    "code": "US-MS-005",
    "name": "Amite"
  },
  {
    "code": "US-AK-020",
    "name": "Anchorage Municipality"
  },
  {
    "code": "US-TX-001",
    "name": "Anderson"
  },
  {
    "code": "US-SC-007",
    "name": "Anderson"
  },
  {
    "code": "US-KS-003",
    "name": "Anderson"
  },
  {
    "code": "US-TN-001",
    "name": "Anderson"
  },
  {
    "code": "US-KY-005",
    "name": "Anderson"
  },
  {
    "code": "US-MO-003",
    "name": "Andrew"
  },
  {
    "code": "US-TX-003",
    "name": "Andrews"
  },
  {
    "code": "US-ME-001",
    "name": "Androscoggin"
  },
  {
    "code": "US-TX-005",
    "name": "Angelina"
  },
  {
    "code": "US-MD-003",
    "name": "Anne Arundel"
  },
  {
    "code": "US-MN-003",
    "name": "Anoka"
  },
  {
    "code": "US-NC-007",
    "name": "Anson"
  },
  {
    "code": "US-NE-003",
    "name": "Antelope"
  },
  {
    "code": "US-MI-009",
    "name": "Antrim"
  },
  {
    "code": "US-AZ-001",
    "name": "Apache"
  },
  {
    "code": "US-IA-007",
    "name": "Appanoose"
  },
  {
    "code": "US-GA-001",
    "name": "Appling"
  },
  {
    "code": "US-VA-011",
    "name": "Appomattox"
  },
  {
    "code": "US-TX-007",
    "name": "Aransas"
  },
  {
    "code": "US-CO-005",
    "name": "Arapahoe"
  },
  {
    "code": "US-TX-009",
    "name": "Archer"
  },
  {
    "code": "US-CO-007",
    "name": "Archuleta"
  },
  {
    "code": "US-MI-011",
    "name": "Arenac"
  },
  {
    "code": "US-AR-001",
    "name": "Arkansas"
  },
  {
    "code": "US-VA-013",
    "name": "Arlington"
  },
  {
    "code": "US-TX-011",
    "name": "Armstrong"
  },
  {
    "code": "US-PA-005",
    "name": "Armstrong"
  },
  {
    "code": "US-ME-003",
    "name": "Aroostook"
  },
  {
    "code": "US-NE-005",
    "name": "Arthur"
  },
  {
    "code": "US-LA-005",
    "name": "Ascension"
  },
  {
    "code": "US-NC-009",
    "name": "Ashe"
  },
  {
    "code": "US-OH-005",
    "name": "Ashland"
  },
  {
    "code": "US-WI-003",
    "name": "Ashland"
  },
  {
    "code": "US-AR-003",
    "name": "Ashley"
  },
  {
    "code": "US-OH-007",
    "name": "Ashtabula"
  },
  {
    "code": "US-WA-003",
    "name": "Asotin"
  },
  {
    "code": "US-LA-007",
    "name": "Assumption"
  },
  {
    "code": "US-TX-013",
    "name": "Atascosa"
  },
  {
    "code": "US-KS-005",
    "name": "Atchison"
  },
  {
    "code": "US-MO-005",
    "name": "Atchison"
  },
  {
    "code": "US-OH-009",
    "name": "Athens"
  },
  {
    "code": "US-GA-003",
    "name": "Atkinson"
  },
  {
    "code": "US-NJ-001",
    "name": "Atlantic"
  },
  {
    "code": "US-OK-005",
    "name": "Atoka"
  },
  {
    "code": "US-MS-007",
    "name": "Attala"
  },
  {
    "code": "US-MO-007",
    "name": "Audrain"
  },
  {
    "code": "US-IA-009",
    "name": "Audubon"
  },
  {
    "code": "US-OH-011",
    "name": "Auglaize"
  },
  {
    "code": "US-VA-015",
    "name": "Augusta"
  },
  {
    "code": "US-SD-003",
    "name": "Aurora"
  },
  {
    "code": "US-TX-015",
    "name": "Austin"
  },
  {
    "code": "US-AL-001",
    "name": "Autauga"
  },
  {
    "code": "US-NC-011",
    "name": "Avery"
  },
  {
    "code": "US-LA-009",
    "name": "Avoyelles"
  },
  {
    "code": "US-CO-009",
    "name": "Baca"
  },
  {
    "code": "US-GA-005",
    "name": "Bacon"
  },
  {
    "code": "US-TX-017",
    "name": "Bailey"
  },
  {
    "code": "US-OR-001",
    "name": "Baker"
  },
  {
    "code": "US-FL-003",
    "name": "Baker"
  },
  {
    "code": "US-GA-007",
    "name": "Baker"
  },
  {
    "code": "US-AL-003",
    "name": "Baldwin"
  },
  {
    "code": "US-GA-009",
    "name": "Baldwin"
  },
  {
    "code": "US-KY-007",
    "name": "Ballard"
  },
  {
    "code": "US-MD-005",
    "name": "Baltimore"
  },
  {
    "code": "US-SC-009",
    "name": "Bamberg"
  },
  {
    "code": "US-TX-019",
    "name": "Bandera"
  },
  {
    "code": "US-GA-011",
    "name": "Banks"
  },
  {
    "code": "US-NE-007",
    "name": "Banner"
  },
  {
    "code": "US-ID-005",
    "name": "Bannock"
  },
  {
    "code": "US-MI-013",
    "name": "Baraga"
  },
  {
    "code": "US-KS-007",
    "name": "Barber"
  },
  {
    "code": "US-WV-001",
    "name": "Barbour"
  },
  {
    "code": "US-AL-005",
    "name": "Barbour"
  },
  {
    "code": "US-ND-003",
    "name": "Barnes"
  },
  {
    "code": "US-MA-001",
    "name": "Barnstable"
  },
  {
    "code": "US-SC-011",
    "name": "Barnwell"
  },
  {
    "code": "US-KY-009",
    "name": "Barren"
  },
  {
    "code": "US-WI-005",
    "name": "Barron"
  },
  {
    "code": "US-GA-013",
    "name": "Barrow"
  },
  {
    "code": "US-MI-015",
    "name": "Barry"
  },
  {
    "code": "US-MO-009",
    "name": "Barry"
  },
  {
    "code": "US-IN-005",
    "name": "Bartholomew"
  },
  {
    "code": "US-KS-009",
    "name": "Barton"
  },
  {
    "code": "US-MO-011",
    "name": "Barton"
  },
  {
    "code": "US-GA-015",
    "name": "Bartow"
  },
  {
    "code": "US-TX-021",
    "name": "Bastrop"
  },
  {
    "code": "US-MO-013",
    "name": "Bates"
  },
  {
    "code": "US-VA-017",
    "name": "Bath"
  },
  {
    "code": "US-KY-011",
    "name": "Bath"
  },
  {
    "code": "US-AR-005",
    "name": "Baxter"
  },
  {
    "code": "US-MI-017",
    "name": "Bay"
  },
  {
    "code": "US-FL-005",
    "name": "Bay"
  },
  {
    "code": "US-WI-007",
    "name": "Bayfield"
  },
  {
    "code": "US-TX-023",
    "name": "Baylor"
  },
  {
    "code": "US-SD-005",
    "name": "Beadle"
  },
  {
    "code": "US-ID-007",
    "name": "Bear Lake"
  },
  {
    "code": "US-SC-013",
    "name": "Beaufort"
  },
  {
    "code": "US-NC-013",
    "name": "Beaufort"
  },
  {
    "code": "US-LA-011",
    "name": "Beauregard"
  },
  {
    "code": "US-PA-007",
    "name": "Beaver"
  },
  {
    "code": "US-UT-001",
    "name": "Beaver"
  },
  {
    "code": "US-OK-007",
    "name": "Beaver"
  },
  {
    "code": "US-MT-001",
    "name": "Beaverhead"
  },
  {
    "code": "US-MN-005",
    "name": "Becker"
  },
  {
    "code": "US-OK-009",
    "name": "Beckham"
  },
  {
    "code": "US-PA-009",
    "name": "Bedford"
  },
  {
    "code": "US-VA-019",
    "name": "Bedford"
  },
  {
    "code": "US-TN-003",
    "name": "Bedford"
  },
  {
    "code": "US-TX-025",
    "name": "Bee"
  },
  {
    "code": "US-NH-001",
    "name": "Belknap"
  },
  {
    "code": "US-TX-027",
    "name": "Bell"
  },
  {
    "code": "US-KY-013",
    "name": "Bell"
  },
  {
    "code": "US-OH-013",
    "name": "Belmont"
  },
  {
    "code": "US-MN-007",
    "name": "Beltrami"
  },
  {
    "code": "US-GA-017",
    "name": "Ben Hill"
  },
  {
    "code": "US-ID-009",
    "name": "Benewah"
  },
  {
    "code": "US-SD-007",
    "name": "Bennett"
  },
  {
    "code": "US-VT-003",
    "name": "Bennington"
  },
  {
    "code": "US-ND-005",
    "name": "Benson"
  },
  {
    "code": "US-CO-011",
    "name": "Bent"
  },
  {
    "code": "US-AR-007",
    "name": "Benton"
  },
  {
    "code": "US-OR-003",
    "name": "Benton"
  },
  {
    "code": "US-IA-011",
    "name": "Benton"
  },
  {
    "code": "US-MN-009",
    "name": "Benton"
  },
  {
    "code": "US-MO-015",
    "name": "Benton"
  },
  {
    "code": "US-TN-005",
    "name": "Benton"
  },
  {
    "code": "US-IN-007",
    "name": "Benton"
  },
  {
    "code": "US-MS-009",
    "name": "Benton"
  },
  {
    "code": "US-WA-005",
    "name": "Benton"
  },
  {
    "code": "US-MI-019",
    "name": "Benzie"
  },
  {
    "code": "US-NJ-003",
    "name": "Bergen"
  },
  {
    "code": "US-SC-015",
    "name": "Berkeley"
  },
  {
    "code": "US-WV-003",
    "name": "Berkeley"
  },
  {
    "code": "US-PA-011",
    "name": "Berks"
  },
  {
    "code": "US-MA-003",
    "name": "Berkshire"
  },
  {
    "code": "US-NM-001",
    "name": "Bernalillo"
  },
  {
    "code": "US-MI-021",
    "name": "Berrien"
  },
  {
    "code": "US-GA-019",
    "name": "Berrien"
  },
  {
    "code": "US-NC-015",
    "name": "Bertie"
  },
  {
    "code": "US-AK-050",
    "name": "Bethel Census Area"
  },
  {
    "code": "US-TX-029",
    "name": "Bexar"
  },
  {
    "code": "US-AL-007",
    "name": "Bibb"
  },
  {
    "code": "US-GA-021",
    "name": "Bibb"
  },
  {
    "code": "US-LA-013",
    "name": "Bienville"
  },
  {
    "code": "US-MT-003",
    "name": "Big Horn"
  },
  {
    "code": "US-WY-003",
    "name": "Big Horn"
  },
  {
    "code": "US-MN-011",
    "name": "Big Stone"
  },
  {
    "code": "US-ND-007",
    "name": "Billings"
  },
  {
    "code": "US-ID-011",
    "name": "Bingham"
  },
  {
    "code": "US-IA-013",
    "name": "Black Hawk"
  },
  {
    "code": "US-IN-009",
    "name": "Blackford"
  },
  {
    "code": "US-NC-017",
    "name": "Bladen"
  },
  {
    "code": "US-MT-005",
    "name": "Blaine"
  },
  {
    "code": "US-NE-009",
    "name": "Blaine"
  },
  {
    "code": "US-ID-013",
    "name": "Blaine"
  },
  {
    "code": "US-OK-011",
    "name": "Blaine"
  },
  {
    "code": "US-PA-013",
    "name": "Blair"
  },
  {
    "code": "US-TX-031",
    "name": "Blanco"
  },
  {
    "code": "US-VA-021",
    "name": "Bland"
  },
  {
    "code": "US-GA-023",
    "name": "Bleckley"
  },
  {
    "code": "US-TN-007",
    "name": "Bledsoe"
  },
  {
    "code": "US-AL-009",
    "name": "Blount"
  },
  {
    "code": "US-TN-009",
    "name": "Blount"
  },
  {
    "code": "US-MN-013",
    "name": "Blue Earth"
  },
  {
    "code": "US-ID-015",
    "name": "Boise"
  },
  {
    "code": "US-MS-011",
    "name": "Bolivar"
  },
  {
    "code": "US-MO-017",
    "name": "Bollinger"
  },
  {
    "code": "US-SD-009",
    "name": "Bon Homme"
  },
  {
    "code": "US-IL-005",
    "name": "Bond"
  },
  {
    "code": "US-ID-017",
    "name": "Bonner"
  },
  {
    "code": "US-ID-019",
    "name": "Bonneville"
  },
  {
    "code": "US-AR-009",
    "name": "Boone"
  },
  {
    "code": "US-NE-011",
    "name": "Boone"
  },
  {
    "code": "US-WV-005",
    "name": "Boone"
  },
  {
    "code": "US-IA-015",
    "name": "Boone"
  },
  {
    "code": "US-MO-019",
    "name": "Boone"
  },
  {
    "code": "US-IL-007",
    "name": "Boone"
  },
  {
    "code": "US-IN-011",
    "name": "Boone"
  },
  {
    "code": "US-KY-015",
    "name": "Boone"
  },
  {
    "code": "US-TX-033",
    "name": "Borden"
  },
  {
    "code": "US-TX-035",
    "name": "Bosque"
  },
  {
    "code": "US-LA-015",
    "name": "Bossier"
  },
  {
    "code": "US-VA-023",
    "name": "Botetourt"
  },
  {
    "code": "US-ND-009",
    "name": "Bottineau"
  },
  {
    "code": "US-CO-013",
    "name": "Boulder"
  },
  {
    "code": "US-ID-021",
    "name": "Boundary"
  },
  {
    "code": "US-KS-011",
    "name": "Bourbon"
  },
  {
    "code": "US-KY-017",
    "name": "Bourbon"
  },
  {
    "code": "US-TX-037",
    "name": "Bowie"
  },
  {
    "code": "US-ND-011",
    "name": "Bowman"
  },
  {
    "code": "US-NE-013",
    "name": "Box Butte"
  },
  {
    "code": "US-UT-003",
    "name": "Box Elder"
  },
  {
    "code": "US-NE-015",
    "name": "Boyd"
  },
  {
    "code": "US-KY-019",
    "name": "Boyd"
  },
  {
    "code": "US-KY-021",
    "name": "Boyle"
  },
  {
    "code": "US-KY-023",
    "name": "Bracken"
  },
  {
    "code": "US-FL-007",
    "name": "Bradford"
  },
  {
    "code": "US-PA-015",
    "name": "Bradford"
  },
  {
    "code": "US-AR-011",
    "name": "Bradley"
  },
  {
    "code": "US-TN-011",
    "name": "Bradley"
  },
  {
    "code": "US-MI-023",
    "name": "Branch"
  },
  {
    "code": "US-GA-025",
    "name": "Brantley"
  },
  {
    "code": "US-WV-007",
    "name": "Braxton"
  },
  {
    "code": "US-TX-039",
    "name": "Brazoria"
  },
  {
    "code": "US-TX-041",
    "name": "Brazos"
  },
  {
    "code": "US-KY-025",
    "name": "Breathitt"
  },
  {
    "code": "US-KY-027",
    "name": "Breckinridge"
  },
  {
    "code": "US-IA-017",
    "name": "Bremer"
  },
  {
    "code": "US-FL-009",
    "name": "Brevard"
  },
  {
    "code": "US-TX-043",
    "name": "Brewster"
  },
  {
    "code": "US-TX-045",
    "name": "Briscoe"
  },
  {
    "code": "US-RI-001",
    "name": "Bristol"
  },
  {
    "code": "US-VA-520",
    "name": "Bristol"
  },
  {
    "code": "US-MA-005",
    "name": "Bristol"
  },
  {
    "code": "US-AK-060",
    "name": "Bristol Bay Borough"
  },
  {
    "code": "US-MT-007",
    "name": "Broadwater"
  },
  {
    "code": "US-NY-005",
    "name": "Bronx"
  },
  {
    "code": "US-WV-009",
    "name": "Brooke"
  },
  {
    "code": "US-SD-011",
    "name": "Brookings"
  },
  {
    "code": "US-TX-047",
    "name": "Brooks"
  },
  {
    "code": "US-GA-027",
    "name": "Brooks"
  },
  {
    "code": "US-NY-007",
    "name": "Broome"
  },
  {
    "code": "US-CO-014",
    "name": "Broomfield"
  },
  {
    "code": "US-FL-011",
    "name": "Broward"
  },
  {
    "code": "US-TX-049",
    "name": "Brown"
  },
  {
    "code": "US-NE-017",
    "name": "Brown"
  },
  {
    "code": "US-MN-015",
    "name": "Brown"
  },
  {
    "code": "US-KS-013",
    "name": "Brown"
  },
  {
    "code": "US-OH-015",
    "name": "Brown"
  },
  {
    "code": "US-IL-009",
    "name": "Brown"
  },
  {
    "code": "US-IN-013",
    "name": "Brown"
  },
  {
    "code": "US-SD-013",
    "name": "Brown"
  },
  {
    "code": "US-WI-009",
    "name": "Brown"
  },
  {
    "code": "US-SD-015",
    "name": "Brule"
  },
  {
    "code": "US-VA-025",
    "name": "Brunswick"
  },
  {
    "code": "US-NC-019",
    "name": "Brunswick"
  },
  {
    "code": "US-OK-013",
    "name": "Bryan"
  },
  {
    "code": "US-GA-029",
    "name": "Bryan"
  },
  {
    "code": "US-IA-019",
    "name": "Buchanan"
  },
  {
    "code": "US-MO-021",
    "name": "Buchanan"
  },
  {
    "code": "US-VA-027",
    "name": "Buchanan"
  },
  {
    "code": "US-VA-029",
    "name": "Buckingham"
  },
  {
    "code": "US-PA-017",
    "name": "Bucks"
  },
  {
    "code": "US-IA-021",
    "name": "Buena Vista"
  },
  {
    "code": "US-VA-530",
    "name": "Buena Vista"
  },
  {
    "code": "US-NE-019",
    "name": "Buffalo"
  },
  {
    "code": "US-SD-017",
    "name": "Buffalo"
  },
  {
    "code": "US-WI-011",
    "name": "Buffalo"
  },
  {
    "code": "US-KY-029",
    "name": "Bullitt"
  },
  {
    "code": "US-GA-031",
    "name": "Bulloch"
  },
  {
    "code": "US-AL-011",
    "name": "Bullock"
  },
  {
    "code": "US-NC-021",
    "name": "Buncombe"
  },
  {
    "code": "US-IL-011",
    "name": "Bureau"
  },
  {
    "code": "US-ND-013",
    "name": "Burke"
  },
  {
    "code": "US-NC-023",
    "name": "Burke"
  },
  {
    "code": "US-GA-033",
    "name": "Burke"
  },
  {
    "code": "US-ND-015",
    "name": "Burleigh"
  },
  {
    "code": "US-TX-051",
    "name": "Burleson"
  },
  {
    "code": "US-NJ-005",
    "name": "Burlington"
  },
  {
    "code": "US-TX-053",
    "name": "Burnet"
  },
  {
    "code": "US-WI-013",
    "name": "Burnett"
  },
  {
    "code": "US-NE-021",
    "name": "Burt"
  },
  {
    "code": "US-NE-023",
    "name": "Butler"
  },
  {
    "code": "US-IA-023",
    "name": "Butler"
  },
  {
    "code": "US-PA-019",
    "name": "Butler"
  },
  {
    "code": "US-KS-015",
    "name": "Butler"
  },
  {
    "code": "US-AL-013",
    "name": "Butler"
  },
  {
    "code": "US-MO-023",
    "name": "Butler"
  },
  {
    "code": "US-OH-017",
    "name": "Butler"
  },
  {
    "code": "US-KY-031",
    "name": "Butler"
  },
  {
    "code": "US-CA-007",
    "name": "Butte"
  },
  {
    "code": "US-ID-023",
    "name": "Butte"
  },
  {
    "code": "US-SD-019",
    "name": "Butte"
  },
  {
    "code": "US-GA-035",
    "name": "Butts"
  },
  {
    "code": "US-NC-025",
    "name": "Cabarrus"
  },
  {
    "code": "US-WV-011",
    "name": "Cabell"
  },
  {
    "code": "US-UT-005",
    "name": "Cache"
  },
  {
    "code": "US-LA-017",
    "name": "Caddo"
  },
  {
    "code": "US-OK-015",
    "name": "Caddo"
  },
  {
    "code": "US-CA-009",
    "name": "Calaveras"
  },
  {
    "code": "US-LA-019",
    "name": "Calcasieu"
  },
  {
    "code": "US-TX-055",
    "name": "Caldwell"
  },
  {
    "code": "US-LA-021",
    "name": "Caldwell"
  },
  {
    "code": "US-MO-025",
    "name": "Caldwell"
  },
  {
    "code": "US-NC-027",
    "name": "Caldwell"
  },
  {
    "code": "US-KY-033",
    "name": "Caldwell"
  },
  {
    "code": "US-VT-005",
    "name": "Caledonia"
  },
  {
    "code": "US-MI-025",
    "name": "Calhoun"
  },
  {
    "code": "US-AR-013",
    "name": "Calhoun"
  },
  {
    "code": "US-TX-057",
    "name": "Calhoun"
  },
  {
    "code": "US-SC-017",
    "name": "Calhoun"
  },
  {
    "code": "US-FL-013",
    "name": "Calhoun"
  },
  {
    "code": "US-WV-013",
    "name": "Calhoun"
  },
  {
    "code": "US-IA-025",
    "name": "Calhoun"
  },
  {
    "code": "US-AL-015",
    "name": "Calhoun"
  },
  {
    "code": "US-IL-013",
    "name": "Calhoun"
  },
  {
    "code": "US-MS-013",
    "name": "Calhoun"
  },
  {
    "code": "US-GA-037",
    "name": "Calhoun"
  },
  {
    "code": "US-TX-059",
    "name": "Callahan"
  },
  {
    "code": "US-MO-027",
    "name": "Callaway"
  },
  {
    "code": "US-KY-035",
    "name": "Calloway"
  },
  {
    "code": "US-WI-015",
    "name": "Calumet"
  },
  {
    "code": "US-MD-009",
    "name": "Calvert"
  },
  {
    "code": "US-ID-025",
    "name": "Camas"
  },
  {
    "code": "US-PA-021",
    "name": "Cambria"
  },
  {
    "code": "US-NJ-007",
    "name": "Camden"
  },
  {
    "code": "US-MO-029",
    "name": "Camden"
  },
  {
    "code": "US-NC-029",
    "name": "Camden"
  },
  {
    "code": "US-GA-039",
    "name": "Camden"
  },
  {
    "code": "US-TX-061",
    "name": "Cameron"
  },
  {
    "code": "US-PA-023",
    "name": "Cameron"
  },
  {
    "code": "US-LA-023",
    "name": "Cameron"
  },
  {
    "code": "US-TX-063",
    "name": "Camp"
  },
  {
    "code": "US-WY-005",
    "name": "Campbell"
  },
  {
    "code": "US-VA-031",
    "name": "Campbell"
  },
  {
    "code": "US-TN-013",
    "name": "Campbell"
  },
  {
    "code": "US-KY-037",
    "name": "Campbell"
  },
  {
    "code": "US-SD-021",
    "name": "Campbell"
  },
  {
    "code": "US-OK-017",
    "name": "Canadian"
  },
  {
    "code": "US-GA-043",
    "name": "Candler"
  },
  {
    "code": "US-TN-015",
    "name": "Cannon"
  },
  {
    "code": "US-ID-027",
    "name": "Canyon"
  },
  {
    "code": "US-MO-031",
    "name": "Cape Girardeau"
  },
  {
    "code": "US-NJ-009",
    "name": "Cape May"
  },
  {
    "code": "US-MT-009",
    "name": "Carbon"
  },
  {
    "code": "US-WY-007",
    "name": "Carbon"
  },
  {
    "code": "US-PA-025",
    "name": "Carbon"
  },
  {
    "code": "US-UT-007",
    "name": "Carbon"
  },
  {
    "code": "US-ID-029",
    "name": "Caribou"
  },
  {
    "code": "US-KY-039",
    "name": "Carlisle"
  },
  {
    "code": "US-MN-017",
    "name": "Carlton"
  },
  {
    "code": "US-VA-033",
    "name": "Caroline"
  },
  {
    "code": "US-MD-011",
    "name": "Caroline"
  },
  {
    "code": "US-AR-015",
    "name": "Carroll"
  },
  {
    "code": "US-NH-003",
    "name": "Carroll"
  },
  {
    "code": "US-IA-027",
    "name": "Carroll"
  },
  {
    "code": "US-MO-033",
    "name": "Carroll"
  },
  {
    "code": "US-VA-035",
    "name": "Carroll"
  },
  {
    "code": "US-TN-017",
    "name": "Carroll"
  },
  {
    "code": "US-OH-019",
    "name": "Carroll"
  },
  {
    "code": "US-IL-015",
    "name": "Carroll"
  },
  {
    "code": "US-IN-015",
    "name": "Carroll"
  },
  {
    "code": "US-KY-041",
    "name": "Carroll"
  },
  {
    "code": "US-MS-015",
    "name": "Carroll"
  },
  {
    "code": "US-MD-013",
    "name": "Carroll"
  },
  {
    "code": "US-GA-045",
    "name": "Carroll"
  },
  {
    "code": "US-TX-065",
    "name": "Carson"
  },
  {
    "code": "US-NV-510",
    "name": "Carson City"
  },
  {
    "code": "US-MT-011",
    "name": "Carter"
  },
  {
    "code": "US-MO-035",
    "name": "Carter"
  },
  {
    "code": "US-TN-019",
    "name": "Carter"
  },
  {
    "code": "US-KY-043",
    "name": "Carter"
  },
  {
    "code": "US-OK-019",
    "name": "Carter"
  },
  {
    "code": "US-NC-031",
    "name": "Carteret"
  },
  {
    "code": "US-MN-019",
    "name": "Carver"
  },
  {
    "code": "US-MT-013",
    "name": "Cascade"
  },
  {
    "code": "US-KY-045",
    "name": "Casey"
  },
  {
    "code": "US-MI-027",
    "name": "Cass"
  },
  {
    "code": "US-ND-017",
    "name": "Cass"
  },
  {
    "code": "US-TX-067",
    "name": "Cass"
  },
  {
    "code": "US-NE-025",
    "name": "Cass"
  },
  {
    "code": "US-IA-029",
    "name": "Cass"
  },
  {
    "code": "US-MN-021",
    "name": "Cass"
  },
  {
    "code": "US-MO-037",
    "name": "Cass"
  },
  {
    "code": "US-IL-017",
    "name": "Cass"
  },
  {
    "code": "US-IN-017",
    "name": "Cass"
  },
  {
    "code": "US-ID-031",
    "name": "Cassia"
  },
  {
    "code": "US-TX-069",
    "name": "Castro"
  },
  {
    "code": "US-NC-033",
    "name": "Caswell"
  },
  {
    "code": "US-LA-025",
    "name": "Catahoula"
  },
  {
    "code": "US-NC-035",
    "name": "Catawba"
  },
  {
    "code": "US-GA-047",
    "name": "Catoosa"
  },
  {
    "code": "US-NM-003",
    "name": "Catron"
  },
  {
    "code": "US-NY-009",
    "name": "Cattaraugus"
  },
  {
    "code": "US-ND-019",
    "name": "Cavalier"
  },
  {
    "code": "US-NY-011",
    "name": "Cayuga"
  },
  {
    "code": "US-MD-015",
    "name": "Cecil"
  },
  {
    "code": "US-NE-027",
    "name": "Cedar"
  },
  {
    "code": "US-IA-031",
    "name": "Cedar"
  },
  {
    "code": "US-MO-039",
    "name": "Cedar"
  },
  {
    "code": "US-PA-027",
    "name": "Centre"
  },
  {
    "code": "US-IA-033",
    "name": "Cerro Gordo"
  },
  {
    "code": "US-CO-015",
    "name": "Chaffee"
  },
  {
    "code": "US-TX-071",
    "name": "Chambers"
  },
  {
    "code": "US-AL-017",
    "name": "Chambers"
  },
  {
    "code": "US-OH-021",
    "name": "Champaign"
  },
  {
    "code": "US-IL-019",
    "name": "Champaign"
  },
  {
    "code": "US-MO-041",
    "name": "Chariton"
  },
  {
    "code": "US-MD-017",
    "name": "Charles"
  },
  {
    "code": "US-VA-036",
    "name": "Charles City"
  },
  {
    "code": "US-SD-023",
    "name": "Charles Mix"
  },
  {
    "code": "US-SC-019",
    "name": "Charleston"
  },
  {
    "code": "US-MI-029",
    "name": "Charlevoix"
  },
  {
    "code": "US-FL-015",
    "name": "Charlotte"
  },
  {
    "code": "US-VA-037",
    "name": "Charlotte"
  },
  {
    "code": "US-VA-540",
    "name": "Charlottesville"
  },
  {
    "code": "US-GA-049",
    "name": "Charlton"
  },
  {
    "code": "US-NE-029",
    "name": "Chase"
  },
  {
    "code": "US-KS-017",
    "name": "Chase"
  },
  {
    "code": "US-NC-037",
    "name": "Chatham"
  },
  {
    "code": "US-GA-051",
    "name": "Chatham"
  },
  {
    "code": "US-GA-053",
    "name": "Chattahoochee"
  },
  {
    "code": "US-GA-055",
    "name": "Chattooga"
  },
  {
    "code": "US-KS-019",
    "name": "Chautauqua"
  },
  {
    "code": "US-NY-013",
    "name": "Chautauqua"
  },
  {
    "code": "US-NM-005",
    "name": "Chaves"
  },
  {
    "code": "US-TN-021",
    "name": "Cheatham"
  },
  {
    "code": "US-MI-031",
    "name": "Cheboygan"
  },
  {
    "code": "US-WA-007",
    "name": "Chelan"
  },
  {
    "code": "US-NY-015",
    "name": "Chemung"
  },
  {
    "code": "US-NY-017",
    "name": "Chenango"
  },
  {
    "code": "US-TX-073",
    "name": "Cherokee"
  },
  {
    "code": "US-SC-021",
    "name": "Cherokee"
  },
  {
    "code": "US-IA-035",
    "name": "Cherokee"
  },
  {
    "code": "US-KS-021",
    "name": "Cherokee"
  },
  {
    "code": "US-AL-019",
    "name": "Cherokee"
  },
  {
    "code": "US-NC-039",
    "name": "Cherokee"
  },
  {
    "code": "US-OK-021",
    "name": "Cherokee"
  },
  {
    "code": "US-GA-057",
    "name": "Cherokee"
  },
  {
    "code": "US-NE-031",
    "name": "Cherry"
  },
  {
    "code": "US-VA-550",
    "name": "Chesapeake"
  },
  {
    "code": "US-NH-005",
    "name": "Cheshire"
  },
  {
    "code": "US-SC-023",
    "name": "Chester"
  },
  {
    "code": "US-PA-029",
    "name": "Chester"
  },
  {
    "code": "US-TN-023",
    "name": "Chester"
  },
  {
    "code": "US-SC-025",
    "name": "Chesterfield"
  },
  {
    "code": "US-VA-041",
    "name": "Chesterfield"
  },
  {
    "code": "US-NE-033",
    "name": "Cheyenne"
  },
  {
    "code": "US-KS-023",
    "name": "Cheyenne"
  },
  {
    "code": "US-CO-017",
    "name": "Cheyenne"
  },
  {
    "code": "US-IA-037",
    "name": "Chickasaw"
  },
  {
    "code": "US-MS-017",
    "name": "Chickasaw"
  },
  {
    "code": "US-AR-017",
    "name": "Chicot"
  },
  {
    "code": "US-TX-075",
    "name": "Childress"
  },
  {
    "code": "US-AL-021",
    "name": "Chilton"
  },
  {
    "code": "US-MI-033",
    "name": "Chippewa"
  },
  {
    "code": "US-MN-023",
    "name": "Chippewa"
  },
  {
    "code": "US-WI-017",
    "name": "Chippewa"
  },
  {
    "code": "US-MN-025",
    "name": "Chisago"
  },
  {
    "code": "US-VT-007",
    "name": "Chittenden"
  },
  {
    "code": "US-AL-023",
    "name": "Choctaw"
  },
  {
    "code": "US-MS-019",
    "name": "Choctaw"
  },
  {
    "code": "US-OK-023",
    "name": "Choctaw"
  },
  {
    "code": "US-MT-015",
    "name": "Chouteau"
  },
  {
    "code": "US-NC-041",
    "name": "Chowan"
  },
  {
    "code": "US-IL-021",
    "name": "Christian"
  },
  {
    "code": "US-MO-043",
    "name": "Christian"
  },
  {
    "code": "US-KY-047",
    "name": "Christian"
  },
  {
    "code": "US-AK-063",
    "name": "Chugach Census Area"
  },
  {
    "code": "US-NV-001",
    "name": "Churchill"
  },
  {
    "code": "US-NM-006",
    "name": "Cibola"
  },
  {
    "code": "US-OK-025",
    "name": "Cimarron"
  },
  {
    "code": "US-FL-017",
    "name": "Citrus"
  },
  {
    "code": "US-OR-005",
    "name": "Clackamas"
  },
  {
    "code": "US-LA-027",
    "name": "Claiborne"
  },
  {
    "code": "US-TN-025",
    "name": "Claiborne"
  },
  {
    "code": "US-MS-021",
    "name": "Claiborne"
  },
  {
    "code": "US-WA-009",
    "name": "Clallam"
  },
  {
    "code": "US-MI-035",
    "name": "Clare"
  },
  {
    "code": "US-SC-027",
    "name": "Clarendon"
  },
  {
    "code": "US-PA-031",
    "name": "Clarion"
  },
  {
    "code": "US-AR-019",
    "name": "Clark"
  },
  {
    "code": "US-KS-025",
    "name": "Clark"
  },
  {
    "code": "US-ID-033",
    "name": "Clark"
  },
  {
    "code": "US-OH-023",
    "name": "Clark"
  },
  {
    "code": "US-IL-023",
    "name": "Clark"
  },
  {
    "code": "US-MO-045",
    "name": "Clark"
  },
  {
    "code": "US-IN-019",
    "name": "Clark"
  },
  {
    "code": "US-NV-003",
    "name": "Clark"
  },
  {
    "code": "US-KY-049",
    "name": "Clark"
  },
  {
    "code": "US-WA-011",
    "name": "Clark"
  },
  {
    "code": "US-SD-025",
    "name": "Clark"
  },
  {
    "code": "US-WI-019",
    "name": "Clark"
  },
  {
    "code": "US-IA-039",
    "name": "Clarke"
  },
  {
    "code": "US-AL-025",
    "name": "Clarke"
  },
  {
    "code": "US-VA-043",
    "name": "Clarke"
  },
  {
    "code": "US-MS-023",
    "name": "Clarke"
  },
  {
    "code": "US-GA-059",
    "name": "Clarke"
  },
  {
    "code": "US-OR-007",
    "name": "Clatsop"
  },
  {
    "code": "US-AR-021",
    "name": "Clay"
  },
  {
    "code": "US-TX-077",
    "name": "Clay"
  },
  {
    "code": "US-FL-019",
    "name": "Clay"
  },
  {
    "code": "US-NE-035",
    "name": "Clay"
  },
  {
    "code": "US-WV-015",
    "name": "Clay"
  },
  {
    "code": "US-IA-041",
    "name": "Clay"
  },
  {
    "code": "US-MN-027",
    "name": "Clay"
  },
  {
    "code": "US-KS-027",
    "name": "Clay"
  },
  {
    "code": "US-AL-027",
    "name": "Clay"
  },
  {
    "code": "US-TN-027",
    "name": "Clay"
  },
  {
    "code": "US-NC-043",
    "name": "Clay"
  },
  {
    "code": "US-IL-025",
    "name": "Clay"
  },
  {
    "code": "US-MO-047",
    "name": "Clay"
  },
  {
    "code": "US-KY-051",
    "name": "Clay"
  },
  {
    "code": "US-IN-021",
    "name": "Clay"
  },
  {
    "code": "US-MS-025",
    "name": "Clay"
  },
  {
    "code": "US-SD-027",
    "name": "Clay"
  },
  {
    "code": "US-GA-061",
    "name": "Clay"
  },
  {
    "code": "US-IA-043",
    "name": "Clayton"
  },
  {
    "code": "US-GA-063",
    "name": "Clayton"
  },
  {
    "code": "US-CO-019",
    "name": "Clear Creek"
  },
  {
    "code": "US-PA-033",
    "name": "Clearfield"
  },
  {
    "code": "US-MN-029",
    "name": "Clearwater"
  },
  {
    "code": "US-ID-035",
    "name": "Clearwater"
  },
  {
    "code": "US-AR-023",
    "name": "Cleburne"
  },
  {
    "code": "US-AL-029",
    "name": "Cleburne"
  },
  {
    "code": "US-OH-025",
    "name": "Clermont"
  },
  {
    "code": "US-AR-025",
    "name": "Cleveland"
  },
  {
    "code": "US-NC-045",
    "name": "Cleveland"
  },
  {
    "code": "US-OK-027",
    "name": "Cleveland"
  },
  {
    "code": "US-GA-065",
    "name": "Clinch"
  },
  {
    "code": "US-MI-037",
    "name": "Clinton"
  },
  {
    "code": "US-PA-035",
    "name": "Clinton"
  },
  {
    "code": "US-IA-045",
    "name": "Clinton"
  },
  {
    "code": "US-NY-019",
    "name": "Clinton"
  },
  {
    "code": "US-OH-027",
    "name": "Clinton"
  },
  {
    "code": "US-IL-027",
    "name": "Clinton"
  },
  {
    "code": "US-MO-049",
    "name": "Clinton"
  },
  {
    "code": "US-KY-053",
    "name": "Clinton"
  },
  {
    "code": "US-IN-023",
    "name": "Clinton"
  },
  {
    "code": "US-KS-029",
    "name": "Cloud"
  },
  {
    "code": "US-MS-027",
    "name": "Coahoma"
  },
  {
    "code": "US-OK-029",
    "name": "Coal"
  },
  {
    "code": "US-GA-067",
    "name": "Cobb"
  },
  {
    "code": "US-AZ-003",
    "name": "Cochise"
  },
  {
    "code": "US-TX-079",
    "name": "Cochran"
  },
  {
    "code": "US-TN-029",
    "name": "Cocke"
  },
  {
    "code": "US-AZ-005",
    "name": "Coconino"
  },
  {
    "code": "US-SD-029",
    "name": "Codington"
  },
  {
    "code": "US-AL-031",
    "name": "Coffee"
  },
  {
    "code": "US-TN-031",
    "name": "Coffee"
  },
  {
    "code": "US-GA-069",
    "name": "Coffee"
  },
  {
    "code": "US-KS-031",
    "name": "Coffey"
  },
  {
    "code": "US-TX-081",
    "name": "Coke"
  },
  {
    "code": "US-AL-033",
    "name": "Colbert"
  },
  {
    "code": "US-MO-051",
    "name": "Cole"
  },
  {
    "code": "US-TX-083",
    "name": "Coleman"
  },
  {
    "code": "US-IL-029",
    "name": "Coles"
  },
  {
    "code": "US-NE-037",
    "name": "Colfax"
  },
  {
    "code": "US-NM-007",
    "name": "Colfax"
  },
  {
    "code": "US-SC-029",
    "name": "Colleton"
  },
  {
    "code": "US-FL-021",
    "name": "Collier"
  },
  {
    "code": "US-TX-085",
    "name": "Collin"
  },
  {
    "code": "US-TX-087",
    "name": "Collingsworth"
  },
  {
    "code": "US-VA-570",
    "name": "Colonial Heights"
  },
  {
    "code": "US-TX-089",
    "name": "Colorado"
  },
  {
    "code": "US-GA-071",
    "name": "Colquitt"
  },
  {
    "code": "US-AR-027",
    "name": "Columbia"
  },
  {
    "code": "US-OR-009",
    "name": "Columbia"
  },
  {
    "code": "US-FL-023",
    "name": "Columbia"
  },
  {
    "code": "US-PA-037",
    "name": "Columbia"
  },
  {
    "code": "US-NY-021",
    "name": "Columbia"
  },
  {
    "code": "US-WA-013",
    "name": "Columbia"
  },
  {
    "code": "US-WI-021",
    "name": "Columbia"
  },
  {
    "code": "US-GA-073",
    "name": "Columbia"
  },
  {
    "code": "US-OH-029",
    "name": "Columbiana"
  },
  {
    "code": "US-NC-047",
    "name": "Columbus"
  },
  {
    "code": "US-CA-011",
    "name": "Colusa"
  },
  {
    "code": "US-TX-091",
    "name": "Comal"
  },
  {
    "code": "US-TX-093",
    "name": "Comanche"
  },
  {
    "code": "US-KS-033",
    "name": "Comanche"
  },
  {
    "code": "US-OK-031",
    "name": "Comanche"
  },
  {
    "code": "US-TX-095",
    "name": "Concho"
  },
  {
    "code": "US-LA-029",
    "name": "Concordia"
  },
  {
    "code": "US-AL-035",
    "name": "Conecuh"
  },
  {
    "code": "US-CO-021",
    "name": "Conejos"
  },
  {
    "code": "US-CA-013",
    "name": "Contra Costa"
  },
  {
    "code": "US-WY-009",
    "name": "Converse"
  },
  {
    "code": "US-AR-029",
    "name": "Conway"
  },
  {
    "code": "US-MN-031",
    "name": "Cook"
  },
  {
    "code": "US-IL-031",
    "name": "Cook"
  },
  {
    "code": "US-GA-075",
    "name": "Cook"
  },
  {
    "code": "US-TX-097",
    "name": "Cooke"
  },
  {
    "code": "US-MO-053",
    "name": "Cooper"
  },
  {
    "code": "US-OR-011",
    "name": "Coos"
  },
  {
    "code": "US-NH-007",
    "name": "Coos"
  },
  {
    "code": "US-AL-037",
    "name": "Coosa"
  },
  {
    "code": "US-MS-029",
    "name": "Copiah"
  },
  {
    "code": "US-AK-066",
    "name": "Copper River Census Area"
  },
  {
    "code": "US-SD-031",
    "name": "Corson"
  },
  {
    "code": "US-NY-023",
    "name": "Cortland"
  },
  {
    "code": "US-TX-099",
    "name": "Coryell"
  },
  {
    "code": "US-OH-031",
    "name": "Coshocton"
  },
  {
    "code": "US-CO-023",
    "name": "Costilla"
  },
  {
    "code": "US-TX-101",
    "name": "Cottle"
  },
  {
    "code": "US-OK-033",
    "name": "Cotton"
  },
  {
    "code": "US-MN-033",
    "name": "Cottonwood"
  },
  {
    "code": "US-AL-039",
    "name": "Covington"
  },
  {
    "code": "US-VA-580",
    "name": "Covington"
  },
  {
    "code": "US-MS-031",
    "name": "Covington"
  },
  {
    "code": "US-GA-077",
    "name": "Coweta"
  },
  {
    "code": "US-KS-035",
    "name": "Cowley"
  },
  {
    "code": "US-WA-015",
    "name": "Cowlitz"
  },
  {
    "code": "US-VA-045",
    "name": "Craig"
  },
  {
    "code": "US-OK-035",
    "name": "Craig"
  },
  {
    "code": "US-AR-031",
    "name": "Craighead"
  },
  {
    "code": "US-TX-103",
    "name": "Crane"
  },
  {
    "code": "US-NC-049",
    "name": "Craven"
  },
  {
    "code": "US-MI-039",
    "name": "Crawford"
  },
  {
    "code": "US-AR-033",
    "name": "Crawford"
  },
  {
    "code": "US-PA-039",
    "name": "Crawford"
  },
  {
    "code": "US-IA-047",
    "name": "Crawford"
  },
  {
    "code": "US-KS-037",
    "name": "Crawford"
  },
  {
    "code": "US-OH-033",
    "name": "Crawford"
  },
  {
    "code": "US-IL-033",
    "name": "Crawford"
  },
  {
    "code": "US-MO-055",
    "name": "Crawford"
  },
  {
    "code": "US-IN-025",
    "name": "Crawford"
  },
  {
    "code": "US-WI-023",
    "name": "Crawford"
  },
  {
    "code": "US-GA-079",
    "name": "Crawford"
  },
  {
    "code": "US-OK-037",
    "name": "Creek"
  },
  {
    "code": "US-AL-041",
    "name": "Crenshaw"
  },
  {
    "code": "US-GA-081",
    "name": "Crisp"
  },
  {
    "code": "US-AR-035",
    "name": "Crittenden"
  },
  {
    "code": "US-KY-055",
    "name": "Crittenden"
  },
  {
    "code": "US-TX-105",
    "name": "Crockett"
  },
  {
    "code": "US-TN-033",
    "name": "Crockett"
  },
  {
    "code": "US-OR-013",
    "name": "Crook"
  },
  {
    "code": "US-WY-011",
    "name": "Crook"
  },
  {
    "code": "US-TX-107",
    "name": "Crosby"
  },
  {
    "code": "US-AR-037",
    "name": "Cross"
  },
  {
    "code": "US-MN-035",
    "name": "Crow Wing"
  },
  {
    "code": "US-CO-025",
    "name": "Crowley"
  },
  {
    "code": "US-TX-109",
    "name": "Culberson"
  },
  {
    "code": "US-AL-043",
    "name": "Cullman"
  },
  {
    "code": "US-VA-047",
    "name": "Culpeper"
  },
  {
    "code": "US-ME-005",
    "name": "Cumberland"
  },
  {
    "code": "US-PA-041",
    "name": "Cumberland"
  },
  {
    "code": "US-NJ-011",
    "name": "Cumberland"
  },
  {
    "code": "US-VA-049",
    "name": "Cumberland"
  },
  {
    "code": "US-TN-035",
    "name": "Cumberland"
  },
  {
    "code": "US-NC-051",
    "name": "Cumberland"
  },
  {
    "code": "US-IL-035",
    "name": "Cumberland"
  },
  {
    "code": "US-KY-057",
    "name": "Cumberland"
  },
  {
    "code": "US-NE-039",
    "name": "Cuming"
  },
  {
    "code": "US-NC-053",
    "name": "Currituck"
  },
  {
    "code": "US-OR-015",
    "name": "Curry"
  },
  {
    "code": "US-NM-009",
    "name": "Curry"
  },
  {
    "code": "US-MT-017",
    "name": "Custer"
  },
  {
    "code": "US-NE-041",
    "name": "Custer"
  },
  {
    "code": "US-ID-037",
    "name": "Custer"
  },
  {
    "code": "US-CO-027",
    "name": "Custer"
  },
  {
    "code": "US-OK-039",
    "name": "Custer"
  },
  {
    "code": "US-SD-033",
    "name": "Custer"
  },
  {
    "code": "US-OH-035",
    "name": "Cuyahoga"
  },
  {
    "code": "US-MO-057",
    "name": "Dade"
  },
  {
    "code": "US-GA-083",
    "name": "Dade"
  },
  {
    "code": "US-UT-009",
    "name": "Daggett"
  },
  {
    "code": "US-NE-043",
    "name": "Dakota"
  },
  {
    "code": "US-MN-037",
    "name": "Dakota"
  },
  {
    "code": "US-AL-045",
    "name": "Dale"
  },
  {
    "code": "US-TX-111",
    "name": "Dallam"
  },
  {
    "code": "US-AR-039",
    "name": "Dallas"
  },
  {
    "code": "US-TX-113",
    "name": "Dallas"
  },
  {
    "code": "US-IA-049",
    "name": "Dallas"
  },
  {
    "code": "US-AL-047",
    "name": "Dallas"
  },
  {
    "code": "US-MO-059",
    "name": "Dallas"
  },
  {
    "code": "US-WI-025",
    "name": "Dane"
  },
  {
    "code": "US-MT-019",
    "name": "Daniels"
  },
  {
    "code": "US-VA-590",
    "name": "Danville"
  },
  {
    "code": "US-NC-055",
    "name": "Dare"
  },
  {
    "code": "US-OH-037",
    "name": "Darke"
  },
  {
    "code": "US-SC-031",
    "name": "Darlington"
  },
  {
    "code": "US-PA-043",
    "name": "Dauphin"
  },
  {
    "code": "US-TN-037",
    "name": "Davidson"
  },
  {
    "code": "US-NC-057",
    "name": "Davidson"
  },
  {
    "code": "US-NC-059",
    "name": "Davie"
  },
  {
    "code": "US-MO-061",
    "name": "Daviess"
  },
  {
    "code": "US-IN-027",
    "name": "Daviess"
  },
  {
    "code": "US-KY-059",
    "name": "Daviess"
  },
  {
    "code": "US-IA-051",
    "name": "Davis"
  },
  {
    "code": "US-UT-011",
    "name": "Davis"
  },
  {
    "code": "US-SD-035",
    "name": "Davison"
  },
  {
    "code": "US-NE-045",
    "name": "Dawes"
  },
  {
    "code": "US-MT-021",
    "name": "Dawson"
  },
  {
    "code": "US-TX-115",
    "name": "Dawson"
  },
  {
    "code": "US-NE-047",
    "name": "Dawson"
  },
  {
    "code": "US-GA-085",
    "name": "Dawson"
  },
  {
    "code": "US-SD-037",
    "name": "Day"
  },
  {
    "code": "US-NM-011",
    "name": "De Baca"
  },
  {
    "code": "US-LA-031",
    "name": "De Soto"
  },
  {
    "code": "US-IL-039",
    "name": "De Witt"
  },
  {
    "code": "US-TX-117",
    "name": "Deaf Smith"
  },
  {
    "code": "US-IN-029",
    "name": "Dearborn"
  },
  {
    "code": "US-IA-053",
    "name": "Decatur"
  },
  {
    "code": "US-KS-039",
    "name": "Decatur"
  },
  {
    "code": "US-TN-039",
    "name": "Decatur"
  },
  {
    "code": "US-IN-031",
    "name": "Decatur"
  },
  {
    "code": "US-GA-087",
    "name": "Decatur"
  },
  {
    "code": "US-MT-023",
    "name": "Deer Lodge"
  },
  {
    "code": "US-OH-039",
    "name": "Defiance"
  },
  {
    "code": "US-AL-049",
    "name": "DeKalb"
  },
  {
    "code": "US-TN-041",
    "name": "DeKalb"
  },
  {
    "code": "US-IL-037",
    "name": "DeKalb"
  },
  {
    "code": "US-MO-063",
    "name": "DeKalb"
  },
  {
    "code": "US-IN-033",
    "name": "DeKalb"
  },
  {
    "code": "US-GA-089",
    "name": "DeKalb"
  },
  {
    "code": "US-CA-015",
    "name": "Del Norte"
  },
  {
    "code": "US-PA-045",
    "name": "Delaware"
  },
  {
    "code": "US-IA-055",
    "name": "Delaware"
  },
  {
    "code": "US-NY-025",
    "name": "Delaware"
  },
  {
    "code": "US-OH-041",
    "name": "Delaware"
  },
  {
    "code": "US-IN-035",
    "name": "Delaware"
  },
  {
    "code": "US-OK-041",
    "name": "Delaware"
  },
  {
    "code": "US-MI-041",
    "name": "Delta"
  },
  {
    "code": "US-TX-119",
    "name": "Delta"
  },
  {
    "code": "US-CO-029",
    "name": "Delta"
  },
  {
    "code": "US-AK-068",
    "name": "Denali Borough"
  },
  {
    "code": "US-MO-065",
    "name": "Dent"
  },
  {
    "code": "US-TX-121",
    "name": "Denton"
  },
  {
    "code": "US-CO-031",
    "name": "Denver"
  },
  {
    "code": "US-IA-057",
    "name": "Des Moines"
  },
  {
    "code": "US-OR-017",
    "name": "Deschutes"
  },
  {
    "code": "US-AR-041",
    "name": "Desha"
  },
  {
    "code": "US-FL-027",
    "name": "DeSoto"
  },
  {
    "code": "US-MS-033",
    "name": "DeSoto"
  },
  {
    "code": "US-NE-049",
    "name": "Deuel"
  },
  {
    "code": "US-SD-039",
    "name": "Deuel"
  },
  {
    "code": "US-OK-043",
    "name": "Dewey"
  },
  {
    "code": "US-SD-041",
    "name": "Dewey"
  },
  {
    "code": "US-TX-123",
    "name": "DeWitt"
  },
  {
    "code": "US-TX-125",
    "name": "Dickens"
  },
  {
    "code": "US-VA-051",
    "name": "Dickenson"
  },
  {
    "code": "US-ND-021",
    "name": "Dickey"
  },
  {
    "code": "US-MI-043",
    "name": "Dickinson"
  },
  {
    "code": "US-IA-059",
    "name": "Dickinson"
  },
  {
    "code": "US-KS-041",
    "name": "Dickinson"
  },
  {
    "code": "US-TN-043",
    "name": "Dickson"
  },
  {
    "code": "US-AK-070",
    "name": "Dillingham Census Area"
  },
  {
    "code": "US-SC-033",
    "name": "Dillon"
  },
  {
    "code": "US-TX-127",
    "name": "Dimmit"
  },
  {
    "code": "US-VA-053",
    "name": "Dinwiddie"
  },
  {
    "code": "US-DC-001",
    "name": "District of Columbia"
  },
  {
    "code": "US-ND-023",
    "name": "Divide"
  },
  {
    "code": "US-FL-029",
    "name": "Dixie"
  },
  {
    "code": "US-NE-051",
    "name": "Dixon"
  },
  {
    "code": "US-WV-017",
    "name": "Doddridge"
  },
  {
    "code": "US-NE-053",
    "name": "Dodge"
  },
  {
    "code": "US-MN-039",
    "name": "Dodge"
  },
  {
    "code": "US-WI-027",
    "name": "Dodge"
  },
  {
    "code": "US-GA-091",
    "name": "Dodge"
  },
  {
    "code": "US-CO-033",
    "name": "Dolores"
  },
  {
    "code": "US-NM-013",
    "name": "Dona Ana"
  },
  {
    "code": "US-KS-043",
    "name": "Doniphan"
  },
  {
    "code": "US-TX-129",
    "name": "Donley"
  },
  {
    "code": "US-GA-093",
    "name": "Dooly"
  },
  {
    "code": "US-WI-029",
    "name": "Door"
  },
  {
    "code": "US-SC-035",
    "name": "Dorchester"
  },
  {
    "code": "US-MD-019",
    "name": "Dorchester"
  },
  {
    "code": "US-GA-095",
    "name": "Dougherty"
  },
  {
    "code": "US-OR-019",
    "name": "Douglas"
  },
  {
    "code": "US-NE-055",
    "name": "Douglas"
  },
  {
    "code": "US-MN-041",
    "name": "Douglas"
  },
  {
    "code": "US-KS-045",
    "name": "Douglas"
  },
  {
    "code": "US-IL-041",
    "name": "Douglas"
  },
  {
    "code": "US-MO-067",
    "name": "Douglas"
  },
  {
    "code": "US-CO-035",
    "name": "Douglas"
  },
  {
    "code": "US-NV-005",
    "name": "Douglas"
  },
  {
    "code": "US-WA-017",
    "name": "Douglas"
  },
  {
    "code": "US-SD-043",
    "name": "Douglas"
  },
  {
    "code": "US-WI-031",
    "name": "Douglas"
  },
  {
    "code": "US-GA-097",
    "name": "Douglas"
  },
  {
    "code": "US-AR-043",
    "name": "Drew"
  },
  {
    "code": "US-IN-037",
    "name": "Dubois"
  },
  {
    "code": "US-IA-061",
    "name": "Dubuque"
  },
  {
    "code": "US-UT-013",
    "name": "Duchesne"
  },
  {
    "code": "US-MA-007",
    "name": "Dukes"
  },
  {
    "code": "US-NE-057",
    "name": "Dundy"
  },
  {
    "code": "US-MO-069",
    "name": "Dunklin"
  },
  {
    "code": "US-ND-025",
    "name": "Dunn"
  },
  {
    "code": "US-WI-033",
    "name": "Dunn"
  },
  {
    "code": "US-IL-043",
    "name": "DuPage"
  },
  {
    "code": "US-NC-061",
    "name": "Duplin"
  },
  {
    "code": "US-NC-063",
    "name": "Durham"
  },
  {
    "code": "US-NY-027",
    "name": "Dutchess"
  },
  {
    "code": "US-TX-131",
    "name": "Duval"
  },
  {
    "code": "US-FL-031",
    "name": "Duval"
  },
  {
    "code": "US-TN-045",
    "name": "Dyer"
  },
  {
    "code": "US-CO-037",
    "name": "Eagle"
  },
  {
    "code": "US-GA-099",
    "name": "Early"
  },
  {
    "code": "US-LA-033",
    "name": "East Baton Rouge"
  },
  {
    "code": "US-LA-035",
    "name": "East Carroll"
  },
  {
    "code": "US-LA-037",
    "name": "East Feliciana"
  },
  {
    "code": "US-TX-133",
    "name": "Eastland"
  },
  {
    "code": "US-MI-045",
    "name": "Eaton"
  },
  {
    "code": "US-WI-035",
    "name": "Eau Claire"
  },
  {
    "code": "US-GA-101",
    "name": "Echols"
  },
  {
    "code": "US-TX-135",
    "name": "Ector"
  },
  {
    "code": "US-ND-027",
    "name": "Eddy"
  },
  {
    "code": "US-NM-015",
    "name": "Eddy"
  },
  {
    "code": "US-IL-045",
    "name": "Edgar"
  },
  {
    "code": "US-NC-065",
    "name": "Edgecombe"
  },
  {
    "code": "US-SC-037",
    "name": "Edgefield"
  },
  {
    "code": "US-KY-061",
    "name": "Edmonson"
  },
  {
    "code": "US-SD-045",
    "name": "Edmunds"
  },
  {
    "code": "US-TX-137",
    "name": "Edwards"
  },
  {
    "code": "US-KS-047",
    "name": "Edwards"
  },
  {
    "code": "US-IL-047",
    "name": "Edwards"
  },
  {
    "code": "US-GA-103",
    "name": "Effingham"
  },
  {
    "code": "US-IL-049",
    "name": "Effingham"
  },
  {
    "code": "US-CA-017",
    "name": "El Dorado"
  },
  {
    "code": "US-TX-141",
    "name": "El Paso"
  },
  {
    "code": "US-CO-041",
    "name": "El Paso"
  },
  {
    "code": "US-GA-105",
    "name": "Elbert"
  },
  {
    "code": "US-CO-039",
    "name": "Elbert"
  },
  {
    "code": "US-PA-047",
    "name": "Elk"
  },
  {
    "code": "US-KS-049",
    "name": "Elk"
  },
  {
    "code": "US-IN-039",
    "name": "Elkhart"
  },
  {
    "code": "US-NV-007",
    "name": "Elko"
  },
  {
    "code": "US-KY-063",
    "name": "Elliott"
  },
  {
    "code": "US-TX-139",
    "name": "Ellis"
  },
  {
    "code": "US-KS-051",
    "name": "Ellis"
  },
  {
    "code": "US-OK-045",
    "name": "Ellis"
  },
  {
    "code": "US-KS-053",
    "name": "Ellsworth"
  },
  {
    "code": "US-ID-039",
    "name": "Elmore"
  },
  {
    "code": "US-AL-051",
    "name": "Elmore"
  },
  {
    "code": "US-GA-107",
    "name": "Emanuel"
  },
  {
    "code": "US-UT-015",
    "name": "Emery"
  },
  {
    "code": "US-MI-047",
    "name": "Emmet"
  },
  {
    "code": "US-IA-063",
    "name": "Emmet"
  },
  {
    "code": "US-ND-029",
    "name": "Emmons"
  },
  {
    "code": "US-VA-595",
    "name": "Emporia"
  },
  {
    "code": "US-TX-143",
    "name": "Erath"
  },
  {
    "code": "US-PA-049",
    "name": "Erie"
  },
  {
    "code": "US-NY-029",
    "name": "Erie"
  },
  {
    "code": "US-OH-043",
    "name": "Erie"
  },
  {
    "code": "US-FL-033",
    "name": "Escambia"
  },
  {
    "code": "US-AL-053",
    "name": "Escambia"
  },
  {
    "code": "US-NV-009",
    "name": "Esmeralda"
  },
  {
    "code": "US-VT-009",
    "name": "Essex"
  },
  {
    "code": "US-NJ-013",
    "name": "Essex"
  },
  {
    "code": "US-NY-031",
    "name": "Essex"
  },
  {
    "code": "US-VA-057",
    "name": "Essex"
  },
  {
    "code": "US-MA-009",
    "name": "Essex"
  },
  {
    "code": "US-KY-065",
    "name": "Estill"
  },
  {
    "code": "US-AL-055",
    "name": "Etowah"
  },
  {
    "code": "US-NV-011",
    "name": "Eureka"
  },
  {
    "code": "US-LA-039",
    "name": "Evangeline"
  },
  {
    "code": "US-GA-109",
    "name": "Evans"
  },
  {
    "code": "US-AK-090",
    "name": "Fairbanks North Star Borough"
  },
  {
    "code": "US-VA-059",
    "name": "Fairfax"
  },
  {
    "code": "US-VA-600",
    "name": "Fairfax City"
  },
  {
    "code": "US-CT-001",
    "name": "Fairfield"
  },
  {
    "code": "US-SC-039",
    "name": "Fairfield"
  },
  {
    "code": "US-OH-045",
    "name": "Fairfield"
  },
  {
    "code": "US-SD-047",
    "name": "Fall River"
  },
  {
    "code": "US-MT-025",
    "name": "Fallon"
  },
  {
    "code": "US-TX-145",
    "name": "Falls"
  },
  {
    "code": "US-VA-610",
    "name": "Falls Church"
  },
  {
    "code": "US-GA-111",
    "name": "Fannin"
  },
  {
    "code": "US-TX-147",
    "name": "Fannin"
  },
  {
    "code": "US-MN-043",
    "name": "Faribault"
  },
  {
    "code": "US-SD-049",
    "name": "Faulk"
  },
  {
    "code": "US-AR-045",
    "name": "Faulkner"
  },
  {
    "code": "US-VA-061",
    "name": "Fauquier"
  },
  {
    "code": "US-GA-113",
    "name": "Fayette"
  },
  {
    "code": "US-TX-149",
    "name": "Fayette"
  },
  {
    "code": "US-IN-041",
    "name": "Fayette"
  },
  {
    "code": "US-WV-019",
    "name": "Fayette"
  },
  {
    "code": "US-PA-051",
    "name": "Fayette"
  },
  {
    "code": "US-IA-065",
    "name": "Fayette"
  },
  {
    "code": "US-AL-057",
    "name": "Fayette"
  },
  {
    "code": "US-TN-047",
    "name": "Fayette"
  },
  {
    "code": "US-OH-047",
    "name": "Fayette"
  },
  {
    "code": "US-IL-051",
    "name": "Fayette"
  },
  {
    "code": "US-KY-067",
    "name": "Fayette"
  },
  {
    "code": "US-TN-049",
    "name": "Fentress"
  },
  {
    "code": "US-MT-027",
    "name": "Fergus"
  },
  {
    "code": "US-WA-019",
    "name": "Ferry"
  },
  {
    "code": "US-NE-059",
    "name": "Fillmore"
  },
  {
    "code": "US-MN-045",
    "name": "Fillmore"
  },
  {
    "code": "US-KS-055",
    "name": "Finney"
  },
  {
    "code": "US-TX-151",
    "name": "Fisher"
  },
  {
    "code": "US-FL-035",
    "name": "Flagler"
  },
  {
    "code": "US-MT-029",
    "name": "Flathead"
  },
  {
    "code": "US-KY-069",
    "name": "Fleming"
  },
  {
    "code": "US-SC-041",
    "name": "Florence"
  },
  {
    "code": "US-WI-037",
    "name": "Florence"
  },
  {
    "code": "US-GA-115",
    "name": "Floyd"
  },
  {
    "code": "US-TX-153",
    "name": "Floyd"
  },
  {
    "code": "US-IN-043",
    "name": "Floyd"
  },
  {
    "code": "US-IA-067",
    "name": "Floyd"
  },
  {
    "code": "US-VA-063",
    "name": "Floyd"
  },
  {
    "code": "US-KY-071",
    "name": "Floyd"
  },
  {
    "code": "US-VA-065",
    "name": "Fluvanna"
  },
  {
    "code": "US-TX-155",
    "name": "Foard"
  },
  {
    "code": "US-WI-039",
    "name": "Fond du Lac"
  },
  {
    "code": "US-KS-057",
    "name": "Ford"
  },
  {
    "code": "US-IL-053",
    "name": "Ford"
  },
  {
    "code": "US-PA-053",
    "name": "Forest"
  },
  {
    "code": "US-WI-041",
    "name": "Forest"
  },
  {
    "code": "US-MS-035",
    "name": "Forrest"
  },
  {
    "code": "US-GA-117",
    "name": "Forsyth"
  },
  {
    "code": "US-NC-067",
    "name": "Forsyth"
  },
  {
    "code": "US-TX-157",
    "name": "Fort Bend"
  },
  {
    "code": "US-ND-031",
    "name": "Foster"
  },
  {
    "code": "US-IN-045",
    "name": "Fountain"
  },
  {
    "code": "US-AR-047",
    "name": "Franklin"
  },
  {
    "code": "US-GA-119",
    "name": "Franklin"
  },
  {
    "code": "US-ME-007",
    "name": "Franklin"
  },
  {
    "code": "US-TX-159",
    "name": "Franklin"
  },
  {
    "code": "US-IN-047",
    "name": "Franklin"
  },
  {
    "code": "US-FL-037",
    "name": "Franklin"
  },
  {
    "code": "US-NE-061",
    "name": "Franklin"
  },
  {
    "code": "US-PA-055",
    "name": "Franklin"
  },
  {
    "code": "US-IA-069",
    "name": "Franklin"
  },
  {
    "code": "US-KS-059",
    "name": "Franklin"
  },
  {
    "code": "US-VT-011",
    "name": "Franklin"
  },
  {
    "code": "US-ID-041",
    "name": "Franklin"
  },
  {
    "code": "US-NY-033",
    "name": "Franklin"
  },
  {
    "code": "US-LA-041",
    "name": "Franklin"
  },
  {
    "code": "US-AL-059",
    "name": "Franklin"
  },
  {
    "code": "US-VA-067",
    "name": "Franklin"
  },
  {
    "code": "US-OH-049",
    "name": "Franklin"
  },
  {
    "code": "US-NC-069",
    "name": "Franklin"
  },
  {
    "code": "US-IL-055",
    "name": "Franklin"
  },
  {
    "code": "US-MO-071",
    "name": "Franklin"
  },
  {
    "code": "US-TN-051",
    "name": "Franklin"
  },
  {
    "code": "US-MS-037",
    "name": "Franklin"
  },
  {
    "code": "US-WA-021",
    "name": "Franklin"
  },
  {
    "code": "US-MA-011",
    "name": "Franklin"
  },
  {
    "code": "US-KY-073",
    "name": "Franklin"
  },
  {
    "code": "US-VA-620",
    "name": "Franklin City"
  },
  {
    "code": "US-VA-069",
    "name": "Frederick"
  },
  {
    "code": "US-MD-021",
    "name": "Frederick"
  },
  {
    "code": "US-VA-630",
    "name": "Fredericksburg"
  },
  {
    "code": "US-MN-047",
    "name": "Freeborn"
  },
  {
    "code": "US-TX-161",
    "name": "Freestone"
  },
  {
    "code": "US-WY-013",
    "name": "Fremont"
  },
  {
    "code": "US-IA-071",
    "name": "Fremont"
  },
  {
    "code": "US-ID-043",
    "name": "Fremont"
  },
  {
    "code": "US-CO-043",
    "name": "Fremont"
  },
  {
    "code": "US-CA-019",
    "name": "Fresno"
  },
  {
    "code": "US-TX-163",
    "name": "Frio"
  },
  {
    "code": "US-NE-063",
    "name": "Frontier"
  },
  {
    "code": "US-AR-049",
    "name": "Fulton"
  },
  {
    "code": "US-GA-121",
    "name": "Fulton"
  },
  {
    "code": "US-IN-049",
    "name": "Fulton"
  },
  {
    "code": "US-PA-057",
    "name": "Fulton"
  },
  {
    "code": "US-NY-035",
    "name": "Fulton"
  },
  {
    "code": "US-OH-051",
    "name": "Fulton"
  },
  {
    "code": "US-IL-057",
    "name": "Fulton"
  },
  {
    "code": "US-KY-075",
    "name": "Fulton"
  },
  {
    "code": "US-NE-065",
    "name": "Furnas"
  },
  {
    "code": "US-FL-039",
    "name": "Gadsden"
  },
  {
    "code": "US-NE-067",
    "name": "Gage"
  },
  {
    "code": "US-TX-165",
    "name": "Gaines"
  },
  {
    "code": "US-VA-640",
    "name": "Galax"
  },
  {
    "code": "US-MT-031",
    "name": "Gallatin"
  },
  {
    "code": "US-IL-059",
    "name": "Gallatin"
  },
  {
    "code": "US-KY-077",
    "name": "Gallatin"
  },
  {
    "code": "US-OH-053",
    "name": "Gallia"
  },
  {
    "code": "US-TX-167",
    "name": "Galveston"
  },
  {
    "code": "US-NE-069",
    "name": "Garden"
  },
  {
    "code": "US-MT-033",
    "name": "Garfield"
  },
  {
    "code": "US-NE-071",
    "name": "Garfield"
  },
  {
    "code": "US-UT-017",
    "name": "Garfield"
  },
  {
    "code": "US-CO-045",
    "name": "Garfield"
  },
  {
    "code": "US-WA-023",
    "name": "Garfield"
  },
  {
    "code": "US-OK-047",
    "name": "Garfield"
  },
  {
    "code": "US-AR-051",
    "name": "Garland"
  },
  {
    "code": "US-KY-079",
    "name": "Garrard"
  },
  {
    "code": "US-MD-023",
    "name": "Garrett"
  },
  {
    "code": "US-OK-049",
    "name": "Garvin"
  },
  {
    "code": "US-TX-169",
    "name": "Garza"
  },
  {
    "code": "US-MO-073",
    "name": "Gasconade"
  },
  {
    "code": "US-NC-071",
    "name": "Gaston"
  },
  {
    "code": "US-NC-073",
    "name": "Gates"
  },
  {
    "code": "US-KS-061",
    "name": "Geary"
  },
  {
    "code": "US-OH-055",
    "name": "Geauga"
  },
  {
    "code": "US-ID-045",
    "name": "Gem"
  },
  {
    "code": "US-MI-049",
    "name": "Genesee"
  },
  {
    "code": "US-NY-037",
    "name": "Genesee"
  },
  {
    "code": "US-AL-061",
    "name": "Geneva"
  },
  {
    "code": "US-MO-075",
    "name": "Gentry"
  },
  {
    "code": "US-MS-039",
    "name": "George"
  },
  {
    "code": "US-SC-043",
    "name": "Georgetown"
  },
  {
    "code": "US-IN-051",
    "name": "Gibson"
  },
  {
    "code": "US-TN-053",
    "name": "Gibson"
  },
  {
    "code": "US-AZ-007",
    "name": "Gila"
  },
  {
    "code": "US-FL-041",
    "name": "Gilchrist"
  },
  {
    "code": "US-VA-071",
    "name": "Giles"
  },
  {
    "code": "US-TN-055",
    "name": "Giles"
  },
  {
    "code": "US-TX-171",
    "name": "Gillespie"
  },
  {
    "code": "US-OR-021",
    "name": "Gilliam"
  },
  {
    "code": "US-GA-123",
    "name": "Gilmer"
  },
  {
    "code": "US-WV-021",
    "name": "Gilmer"
  },
  {
    "code": "US-CO-047",
    "name": "Gilpin"
  },
  {
    "code": "US-MT-035",
    "name": "Glacier"
  },
  {
    "code": "US-FL-043",
    "name": "Glades"
  },
  {
    "code": "US-MI-051",
    "name": "Gladwin"
  },
  {
    "code": "US-GA-125",
    "name": "Glascock"
  },
  {
    "code": "US-TX-173",
    "name": "Glasscock"
  },
  {
    "code": "US-CA-021",
    "name": "Glenn"
  },
  {
    "code": "US-NJ-015",
    "name": "Gloucester"
  },
  {
    "code": "US-VA-073",
    "name": "Gloucester"
  },
  {
    "code": "US-GA-127",
    "name": "Glynn"
  },
  {
    "code": "US-MI-053",
    "name": "Gogebic"
  },
  {
    "code": "US-MT-037",
    "name": "Golden Valley"
  },
  {
    "code": "US-ND-033",
    "name": "Golden Valley"
  },
  {
    "code": "US-TX-175",
    "name": "Goliad"
  },
  {
    "code": "US-TX-177",
    "name": "Gonzales"
  },
  {
    "code": "US-VA-075",
    "name": "Goochland"
  },
  {
    "code": "US-MN-049",
    "name": "Goodhue"
  },
  {
    "code": "US-ID-047",
    "name": "Gooding"
  },
  {
    "code": "US-GA-129",
    "name": "Gordon"
  },
  {
    "code": "US-WY-015",
    "name": "Goshen"
  },
  {
    "code": "US-NE-073",
    "name": "Gosper"
  },
  {
    "code": "US-KS-063",
    "name": "Gove"
  },
  {
    "code": "US-GA-131",
    "name": "Grady"
  },
  {
    "code": "US-OK-051",
    "name": "Grady"
  },
  {
    "code": "US-NH-009",
    "name": "Grafton"
  },
  {
    "code": "US-AZ-009",
    "name": "Graham"
  },
  {
    "code": "US-KS-065",
    "name": "Graham"
  },
  {
    "code": "US-NC-075",
    "name": "Graham"
  },
  {
    "code": "US-TN-057",
    "name": "Grainger"
  },
  {
    "code": "US-UT-019",
    "name": "Grand"
  },
  {
    "code": "US-CO-049",
    "name": "Grand"
  },
  {
    "code": "US-ND-035",
    "name": "Grand Forks"
  },
  {
    "code": "US-VT-013",
    "name": "Grand Isle"
  },
  {
    "code": "US-MI-055",
    "name": "Grand Traverse"
  },
  {
    "code": "US-MT-039",
    "name": "Granite"
  },
  {
    "code": "US-OR-023",
    "name": "Grant"
  },
  {
    "code": "US-AR-053",
    "name": "Grant"
  },
  {
    "code": "US-IN-053",
    "name": "Grant"
  },
  {
    "code": "US-NE-075",
    "name": "Grant"
  },
  {
    "code": "US-WV-023",
    "name": "Grant"
  },
  {
    "code": "US-NM-017",
    "name": "Grant"
  },
  {
    "code": "US-MN-051",
    "name": "Grant"
  },
  {
    "code": "US-KS-067",
    "name": "Grant"
  },
  {
    "code": "US-LA-043",
    "name": "Grant"
  },
  {
    "code": "US-WA-025",
    "name": "Grant"
  },
  {
    "code": "US-OK-053",
    "name": "Grant"
  },
  {
    "code": "US-SD-051",
    "name": "Grant"
  },
  {
    "code": "US-ND-037",
    "name": "Grant"
  },
  {
    "code": "US-KY-081",
    "name": "Grant"
  },
  {
    "code": "US-WI-043",
    "name": "Grant"
  },
  {
    "code": "US-NC-077",
    "name": "Granville"
  },
  {
    "code": "US-MI-057",
    "name": "Gratiot"
  },
  {
    "code": "US-KY-083",
    "name": "Graves"
  },
  {
    "code": "US-TX-179",
    "name": "Gray"
  },
  {
    "code": "US-KS-069",
    "name": "Gray"
  },
  {
    "code": "US-WA-027",
    "name": "Grays Harbor"
  },
  {
    "code": "US-TX-181",
    "name": "Grayson"
  },
  {
    "code": "US-VA-077",
    "name": "Grayson"
  },
  {
    "code": "US-KY-085",
    "name": "Grayson"
  },
  {
    "code": "US-NE-077",
    "name": "Greeley"
  },
  {
    "code": "US-KS-071",
    "name": "Greeley"
  },
  {
    "code": "US-KY-087",
    "name": "Green"
  },
  {
    "code": "US-WI-045",
    "name": "Green"
  },
  {
    "code": "US-WI-047",
    "name": "Green Lake"
  },
  {
    "code": "US-WV-025",
    "name": "Greenbrier"
  },
  {
    "code": "US-AR-055",
    "name": "Greene"
  },
  {
    "code": "US-GA-133",
    "name": "Greene"
  },
  {
    "code": "US-IN-055",
    "name": "Greene"
  },
  {
    "code": "US-PA-059",
    "name": "Greene"
  },
  {
    "code": "US-IA-073",
    "name": "Greene"
  },
  {
    "code": "US-NY-039",
    "name": "Greene"
  },
  {
    "code": "US-AL-063",
    "name": "Greene"
  },
  {
    "code": "US-MS-041",
    "name": "Greene"
  },
  {
    "code": "US-VA-079",
    "name": "Greene"
  },
  {
    "code": "US-OH-057",
    "name": "Greene"
  },
  {
    "code": "US-NC-079",
    "name": "Greene"
  },
  {
    "code": "US-IL-061",
    "name": "Greene"
  },
  {
    "code": "US-MO-077",
    "name": "Greene"
  },
  {
    "code": "US-TN-059",
    "name": "Greene"
  },
  {
    "code": "US-AZ-011",
    "name": "Greenlee"
  },
  {
    "code": "US-VA-081",
    "name": "Greensville"
  },
  {
    "code": "US-KY-089",
    "name": "Greenup"
  },
  {
    "code": "US-SC-045",
    "name": "Greenville"
  },
  {
    "code": "US-SC-047",
    "name": "Greenwood"
  },
  {
    "code": "US-KS-073",
    "name": "Greenwood"
  },
  {
    "code": "US-OK-055",
    "name": "Greer"
  },
  {
    "code": "US-TX-183",
    "name": "Gregg"
  },
  {
    "code": "US-SD-053",
    "name": "Gregory"
  },
  {
    "code": "US-MS-043",
    "name": "Grenada"
  },
  {
    "code": "US-ND-039",
    "name": "Griggs"
  },
  {
    "code": "US-TX-185",
    "name": "Grimes"
  },
  {
    "code": "US-IA-075",
    "name": "Grundy"
  },
  {
    "code": "US-IL-063",
    "name": "Grundy"
  },
  {
    "code": "US-MO-079",
    "name": "Grundy"
  },
  {
    "code": "US-TN-061",
    "name": "Grundy"
  },
  {
    "code": "US-TX-187",
    "name": "Guadalupe"
  },
  {
    "code": "US-NM-019",
    "name": "Guadalupe"
  },
  {
    "code": "US-OH-059",
    "name": "Guernsey"
  },
  {
    "code": "US-NC-081",
    "name": "Guilford"
  },
  {
    "code": "US-FL-045",
    "name": "Gulf"
  },
  {
    "code": "US-CO-051",
    "name": "Gunnison"
  },
  {
    "code": "US-IA-077",
    "name": "Guthrie"
  },
  {
    "code": "US-GA-135",
    "name": "Gwinnett"
  },
  {
    "code": "US-SD-055",
    "name": "Haakon"
  },
  {
    "code": "US-GA-137",
    "name": "Habersham"
  },
  {
    "code": "US-AK-100",
    "name": "Haines Borough"
  },
  {
    "code": "US-TX-189",
    "name": "Hale"
  },
  {
    "code": "US-AL-065",
    "name": "Hale"
  },
  {
    "code": "US-VA-083",
    "name": "Halifax"
  },
  {
    "code": "US-NC-083",
    "name": "Halifax"
  },
  {
    "code": "US-GA-139",
    "name": "Hall"
  },
  {
    "code": "US-NE-079",
    "name": "Hall"
  },
  {
    "code": "US-TX-191",
    "name": "Hall"
  },
  {
    "code": "US-TN-063",
    "name": "Hamblen"
  },
  {
    "code": "US-NE-081",
    "name": "Hamilton"
  },
  {
    "code": "US-IN-057",
    "name": "Hamilton"
  },
  {
    "code": "US-TX-193",
    "name": "Hamilton"
  },
  {
    "code": "US-FL-047",
    "name": "Hamilton"
  },
  {
    "code": "US-IA-079",
    "name": "Hamilton"
  },
  {
    "code": "US-KS-075",
    "name": "Hamilton"
  },
  {
    "code": "US-NY-041",
    "name": "Hamilton"
  },
  {
    "code": "US-OH-061",
    "name": "Hamilton"
  },
  {
    "code": "US-IL-065",
    "name": "Hamilton"
  },
  {
    "code": "US-TN-065",
    "name": "Hamilton"
  },
  {
    "code": "US-SD-057",
    "name": "Hamlin"
  },
  {
    "code": "US-MA-013",
    "name": "Hampden"
  },
  {
    "code": "US-WV-027",
    "name": "Hampshire"
  },
  {
    "code": "US-MA-015",
    "name": "Hampshire"
  },
  {
    "code": "US-SC-049",
    "name": "Hampton"
  },
  {
    "code": "US-VA-650",
    "name": "Hampton"
  },
  {
    "code": "US-ME-009",
    "name": "Hancock"
  },
  {
    "code": "US-GA-141",
    "name": "Hancock"
  },
  {
    "code": "US-IN-059",
    "name": "Hancock"
  },
  {
    "code": "US-IA-081",
    "name": "Hancock"
  },
  {
    "code": "US-WV-029",
    "name": "Hancock"
  },
  {
    "code": "US-MS-045",
    "name": "Hancock"
  },
  {
    "code": "US-OH-063",
    "name": "Hancock"
  },
  {
    "code": "US-IL-067",
    "name": "Hancock"
  },
  {
    "code": "US-TN-067",
    "name": "Hancock"
  },
  {
    "code": "US-KY-091",
    "name": "Hancock"
  },
  {
    "code": "US-SD-059",
    "name": "Hand"
  },
  {
    "code": "US-VA-085",
    "name": "Hanover"
  },
  {
    "code": "US-TX-195",
    "name": "Hansford"
  },
  {
    "code": "US-SD-061",
    "name": "Hanson"
  },
  {
    "code": "US-GA-143",
    "name": "Haralson"
  },
  {
    "code": "US-FL-049",
    "name": "Hardee"
  },
  {
    "code": "US-TX-197",
    "name": "Hardeman"
  },
  {
    "code": "US-TN-069",
    "name": "Hardeman"
  },
  {
    "code": "US-TX-199",
    "name": "Hardin"
  },
  {
    "code": "US-IA-083",
    "name": "Hardin"
  },
  {
    "code": "US-OH-065",
    "name": "Hardin"
  },
  {
    "code": "US-IL-069",
    "name": "Hardin"
  },
  {
    "code": "US-TN-071",
    "name": "Hardin"
  },
  {
    "code": "US-KY-093",
    "name": "Hardin"
  },
  {
    "code": "US-NM-021",
    "name": "Harding"
  },
  {
    "code": "US-SD-063",
    "name": "Harding"
  },
  {
    "code": "US-WV-031",
    "name": "Hardy"
  },
  {
    "code": "US-MD-025",
    "name": "Harford"
  },
  {
    "code": "US-NE-083",
    "name": "Harlan"
  },
  {
    "code": "US-KY-095",
    "name": "Harlan"
  },
  {
    "code": "US-OK-057",
    "name": "Harmon"
  },
  {
    "code": "US-NC-085",
    "name": "Harnett"
  },
  {
    "code": "US-OR-025",
    "name": "Harney"
  },
  {
    "code": "US-KS-077",
    "name": "Harper"
  },
  {
    "code": "US-OK-059",
    "name": "Harper"
  },
  {
    "code": "US-GA-145",
    "name": "Harris"
  },
  {
    "code": "US-TX-201",
    "name": "Harris"
  },
  {
    "code": "US-IN-061",
    "name": "Harrison"
  },
  {
    "code": "US-IA-085",
    "name": "Harrison"
  },
  {
    "code": "US-WV-033",
    "name": "Harrison"
  },
  {
    "code": "US-MS-047",
    "name": "Harrison"
  },
  {
    "code": "US-OH-067",
    "name": "Harrison"
  },
  {
    "code": "US-MO-081",
    "name": "Harrison"
  },
  {
    "code": "US-TX-203",
    "name": "Harrison"
  },
  {
    "code": "US-KY-097",
    "name": "Harrison"
  },
  {
    "code": "US-VA-660",
    "name": "Harrisonburg"
  },
  {
    "code": "US-GA-147",
    "name": "Hart"
  },
  {
    "code": "US-KY-099",
    "name": "Hart"
  },
  {
    "code": "US-CT-003",
    "name": "Hartford"
  },
  {
    "code": "US-TX-205",
    "name": "Hartley"
  },
  {
    "code": "US-KS-079",
    "name": "Harvey"
  },
  {
    "code": "US-KS-081",
    "name": "Haskell"
  },
  {
    "code": "US-TX-207",
    "name": "Haskell"
  },
  {
    "code": "US-OK-061",
    "name": "Haskell"
  },
  {
    "code": "US-HI-001",
    "name": "Hawaii"
  },
  {
    "code": "US-TN-073",
    "name": "Hawkins"
  },
  {
    "code": "US-NE-085",
    "name": "Hayes"
  },
  {
    "code": "US-TX-209",
    "name": "Hays"
  },
  {
    "code": "US-NC-087",
    "name": "Haywood"
  },
  {
    "code": "US-TN-075",
    "name": "Haywood"
  },
  {
    "code": "US-GA-149",
    "name": "Heard"
  },
  {
    "code": "US-TX-211",
    "name": "Hemphill"
  },
  {
    "code": "US-AR-057",
    "name": "Hempstead"
  },
  {
    "code": "US-NC-089",
    "name": "Henderson"
  },
  {
    "code": "US-IL-071",
    "name": "Henderson"
  },
  {
    "code": "US-TN-077",
    "name": "Henderson"
  },
  {
    "code": "US-TX-213",
    "name": "Henderson"
  },
  {
    "code": "US-KY-101",
    "name": "Henderson"
  },
  {
    "code": "US-IN-063",
    "name": "Hendricks"
  },
  {
    "code": "US-FL-051",
    "name": "Hendry"
  },
  {
    "code": "US-MN-053",
    "name": "Hennepin"
  },
  {
    "code": "US-VA-087",
    "name": "Henrico"
  },
  {
    "code": "US-GA-151",
    "name": "Henry"
  },
  {
    "code": "US-IN-065",
    "name": "Henry"
  },
  {
    "code": "US-IA-087",
    "name": "Henry"
  },
  {
    "code": "US-AL-067",
    "name": "Henry"
  },
  {
    "code": "US-VA-089",
    "name": "Henry"
  },
  {
    "code": "US-OH-069",
    "name": "Henry"
  },
  {
    "code": "US-IL-073",
    "name": "Henry"
  },
  {
    "code": "US-MO-083",
    "name": "Henry"
  },
  {
    "code": "US-TN-079",
    "name": "Henry"
  },
  {
    "code": "US-KY-103",
    "name": "Henry"
  },
  {
    "code": "US-NY-043",
    "name": "Herkimer"
  },
  {
    "code": "US-FL-053",
    "name": "Hernando"
  },
  {
    "code": "US-NC-091",
    "name": "Hertford"
  },
  {
    "code": "US-ND-041",
    "name": "Hettinger"
  },
  {
    "code": "US-TN-081",
    "name": "Hickman"
  },
  {
    "code": "US-KY-105",
    "name": "Hickman"
  },
  {
    "code": "US-MO-085",
    "name": "Hickory"
  },
  {
    "code": "US-NM-023",
    "name": "Hidalgo"
  },
  {
    "code": "US-TX-215",
    "name": "Hidalgo"
  },
  {
    "code": "US-VA-091",
    "name": "Highland"
  },
  {
    "code": "US-OH-071",
    "name": "Highland"
  },
  {
    "code": "US-FL-055",
    "name": "Highlands"
  },
  {
    "code": "US-MT-041",
    "name": "Hill"
  },
  {
    "code": "US-TX-217",
    "name": "Hill"
  },
  {
    "code": "US-NH-011",
    "name": "Hillsborough"
  },
  {
    "code": "US-FL-057",
    "name": "Hillsborough"
  },
  {
    "code": "US-MI-059",
    "name": "Hillsdale"
  },
  {
    "code": "US-MS-049",
    "name": "Hinds"
  },
  {
    "code": "US-CO-053",
    "name": "Hinsdale"
  },
  {
    "code": "US-NE-087",
    "name": "Hitchcock"
  },
  {
    "code": "US-OH-073",
    "name": "Hocking"
  },
  {
    "code": "US-TX-219",
    "name": "Hockley"
  },
  {
    "code": "US-KS-083",
    "name": "Hodgeman"
  },
  {
    "code": "US-NC-093",
    "name": "Hoke"
  },
  {
    "code": "US-FL-059",
    "name": "Holmes"
  },
  {
    "code": "US-MS-051",
    "name": "Holmes"
  },
  {
    "code": "US-OH-075",
    "name": "Holmes"
  },
  {
    "code": "US-NE-089",
    "name": "Holt"
  },
  {
    "code": "US-MO-087",
    "name": "Holt"
  },
  {
    "code": "US-HI-003",
    "name": "Honolulu"
  },
  {
    "code": "US-TX-221",
    "name": "Hood"
  },
  {
    "code": "US-OR-027",
    "name": "Hood River"
  },
  {
    "code": "US-NE-091",
    "name": "Hooker"
  },
  {
    "code": "US-AK-105",
    "name": "Hoonah-Angoon Census Area"
  },
  {
    "code": "US-VA-670",
    "name": "Hopewell"
  },
  {
    "code": "US-TX-223",
    "name": "Hopkins"
  },
  {
    "code": "US-KY-107",
    "name": "Hopkins"
  },
  {
    "code": "US-SC-051",
    "name": "Horry"
  },
  {
    "code": "US-AR-059",
    "name": "Hot Spring"
  },
  {
    "code": "US-WY-017",
    "name": "Hot Springs"
  },
  {
    "code": "US-MI-061",
    "name": "Houghton"
  },
  {
    "code": "US-GA-153",
    "name": "Houston"
  },
  {
    "code": "US-MN-055",
    "name": "Houston"
  },
  {
    "code": "US-AL-069",
    "name": "Houston"
  },
  {
    "code": "US-TN-083",
    "name": "Houston"
  },
  {
    "code": "US-TX-225",
    "name": "Houston"
  },
  {
    "code": "US-AR-061",
    "name": "Howard"
  },
  {
    "code": "US-NE-093",
    "name": "Howard"
  },
  {
    "code": "US-IN-067",
    "name": "Howard"
  },
  {
    "code": "US-IA-089",
    "name": "Howard"
  },
  {
    "code": "US-MO-089",
    "name": "Howard"
  },
  {
    "code": "US-TX-227",
    "name": "Howard"
  },
  {
    "code": "US-MD-027",
    "name": "Howard"
  },
  {
    "code": "US-MO-091",
    "name": "Howell"
  },
  {
    "code": "US-MN-057",
    "name": "Hubbard"
  },
  {
    "code": "US-NJ-017",
    "name": "Hudson"
  },
  {
    "code": "US-TX-229",
    "name": "Hudspeth"
  },
  {
    "code": "US-CO-055",
    "name": "Huerfano"
  },
  {
    "code": "US-SD-065",
    "name": "Hughes"
  },
  {
    "code": "US-OK-063",
    "name": "Hughes"
  },
  {
    "code": "US-CA-023",
    "name": "Humboldt"
  },
  {
    "code": "US-IA-091",
    "name": "Humboldt"
  },
  {
    "code": "US-NV-013",
    "name": "Humboldt"
  },
  {
    "code": "US-MS-053",
    "name": "Humphreys"
  },
  {
    "code": "US-TN-085",
    "name": "Humphreys"
  },
  {
    "code": "US-TX-231",
    "name": "Hunt"
  },
  {
    "code": "US-NJ-019",
    "name": "Hunterdon"
  },
  {
    "code": "US-PA-061",
    "name": "Huntingdon"
  },
  {
    "code": "US-IN-069",
    "name": "Huntington"
  },
  {
    "code": "US-MI-063",
    "name": "Huron"
  },
  {
    "code": "US-OH-077",
    "name": "Huron"
  },
  {
    "code": "US-TX-233",
    "name": "Hutchinson"
  },
  {
    "code": "US-SD-067",
    "name": "Hutchinson"
  },
  {
    "code": "US-NC-095",
    "name": "Hyde"
  },
  {
    "code": "US-SD-069",
    "name": "Hyde"
  },
  {
    "code": "US-LA-045",
    "name": "Iberia"
  },
  {
    "code": "US-LA-047",
    "name": "Iberville"
  },
  {
    "code": "US-IA-093",
    "name": "Ida"
  },
  {
    "code": "US-ID-049",
    "name": "Idaho"
  },
  {
    "code": "US-CA-025",
    "name": "Imperial"
  },
  {
    "code": "US-AR-063",
    "name": "Independence"
  },
  {
    "code": "US-FL-061",
    "name": "Indian River"
  },
  {
    "code": "US-PA-063",
    "name": "Indiana"
  },
  {
    "code": "US-MI-065",
    "name": "Ingham"
  },
  {
    "code": "US-CA-027",
    "name": "Inyo"
  },
  {
    "code": "US-MI-067",
    "name": "Ionia"
  },
  {
    "code": "US-MI-069",
    "name": "Iosco"
  },
  {
    "code": "US-IA-095",
    "name": "Iowa"
  },
  {
    "code": "US-WI-049",
    "name": "Iowa"
  },
  {
    "code": "US-NC-097",
    "name": "Iredell"
  },
  {
    "code": "US-TX-235",
    "name": "Irion"
  },
  {
    "code": "US-MI-071",
    "name": "Iron"
  },
  {
    "code": "US-UT-021",
    "name": "Iron"
  },
  {
    "code": "US-MO-093",
    "name": "Iron"
  },
  {
    "code": "US-WI-051",
    "name": "Iron"
  },
  {
    "code": "US-IL-075",
    "name": "Iroquois"
  },
  {
    "code": "US-GA-155",
    "name": "Irwin"
  },
  {
    "code": "US-MI-073",
    "name": "Isabella"
  },
  {
    "code": "US-MN-059",
    "name": "Isanti"
  },
  {
    "code": "US-WA-029",
    "name": "Island"
  },
  {
    "code": "US-VA-093",
    "name": "Isle of Wight"
  },
  {
    "code": "US-MS-055",
    "name": "Issaquena"
  },
  {
    "code": "US-MN-061",
    "name": "Itasca"
  },
  {
    "code": "US-MS-057",
    "name": "Itawamba"
  },
  {
    "code": "US-AR-065",
    "name": "Izard"
  },
  {
    "code": "US-TX-237",
    "name": "Jack"
  },
  {
    "code": "US-OR-029",
    "name": "Jackson"
  },
  {
    "code": "US-AR-067",
    "name": "Jackson"
  },
  {
    "code": "US-MI-075",
    "name": "Jackson"
  },
  {
    "code": "US-GA-157",
    "name": "Jackson"
  },
  {
    "code": "US-IN-071",
    "name": "Jackson"
  },
  {
    "code": "US-FL-063",
    "name": "Jackson"
  },
  {
    "code": "US-IA-097",
    "name": "Jackson"
  },
  {
    "code": "US-WV-035",
    "name": "Jackson"
  },
  {
    "code": "US-MN-063",
    "name": "Jackson"
  },
  {
    "code": "US-KS-085",
    "name": "Jackson"
  },
  {
    "code": "US-LA-049",
    "name": "Jackson"
  },
  {
    "code": "US-AL-071",
    "name": "Jackson"
  },
  {
    "code": "US-MS-059",
    "name": "Jackson"
  },
  {
    "code": "US-OH-079",
    "name": "Jackson"
  },
  {
    "code": "US-NC-099",
    "name": "Jackson"
  },
  {
    "code": "US-IL-077",
    "name": "Jackson"
  },
  {
    "code": "US-TN-087",
    "name": "Jackson"
  },
  {
    "code": "US-MO-095",
    "name": "Jackson"
  },
  {
    "code": "US-TX-239",
    "name": "Jackson"
  },
  {
    "code": "US-KY-109",
    "name": "Jackson"
  },
  {
    "code": "US-SD-071",
    "name": "Jackson"
  },
  {
    "code": "US-OK-065",
    "name": "Jackson"
  },
  {
    "code": "US-WI-053",
    "name": "Jackson"
  },
  {
    "code": "US-CO-057",
    "name": "Jackson"
  },
  {
    "code": "US-VA-095",
    "name": "James City"
  },
  {
    "code": "US-GA-159",
    "name": "Jasper"
  },
  {
    "code": "US-SC-053",
    "name": "Jasper"
  },
  {
    "code": "US-IN-073",
    "name": "Jasper"
  },
  {
    "code": "US-IA-099",
    "name": "Jasper"
  },
  {
    "code": "US-MS-061",
    "name": "Jasper"
  },
  {
    "code": "US-IL-079",
    "name": "Jasper"
  },
  {
    "code": "US-MO-097",
    "name": "Jasper"
  },
  {
    "code": "US-TX-241",
    "name": "Jasper"
  },
  {
    "code": "US-IN-075",
    "name": "Jay"
  },
  {
    "code": "US-GA-161",
    "name": "Jeff Davis"
  },
  {
    "code": "US-TX-243",
    "name": "Jeff Davis"
  },
  {
    "code": "US-OR-031",
    "name": "Jefferson"
  },
  {
    "code": "US-AR-069",
    "name": "Jefferson"
  },
  {
    "code": "US-MT-043",
    "name": "Jefferson"
  },
  {
    "code": "US-GA-163",
    "name": "Jefferson"
  },
  {
    "code": "US-IN-077",
    "name": "Jefferson"
  },
  {
    "code": "US-NE-095",
    "name": "Jefferson"
  },
  {
    "code": "US-FL-065",
    "name": "Jefferson"
  },
  {
    "code": "US-PA-065",
    "name": "Jefferson"
  },
  {
    "code": "US-WV-037",
    "name": "Jefferson"
  },
  {
    "code": "US-KS-087",
    "name": "Jefferson"
  },
  {
    "code": "US-ID-051",
    "name": "Jefferson"
  },
  {
    "code": "US-LA-051",
    "name": "Jefferson"
  },
  {
    "code": "US-NY-045",
    "name": "Jefferson"
  },
  {
    "code": "US-AL-073",
    "name": "Jefferson"
  },
  {
    "code": "US-IA-101",
    "name": "Jefferson"
  },
  {
    "code": "US-MS-063",
    "name": "Jefferson"
  },
  {
    "code": "US-OH-081",
    "name": "Jefferson"
  },
  {
    "code": "US-IL-081",
    "name": "Jefferson"
  },
  {
    "code": "US-TN-089",
    "name": "Jefferson"
  },
  {
    "code": "US-MO-099",
    "name": "Jefferson"
  },
  {
    "code": "US-TX-245",
    "name": "Jefferson"
  },
  {
    "code": "US-WA-031",
    "name": "Jefferson"
  },
  {
    "code": "US-KY-111",
    "name": "Jefferson"
  },
  {
    "code": "US-OK-067",
    "name": "Jefferson"
  },
  {
    "code": "US-WI-055",
    "name": "Jefferson"
  },
  {
    "code": "US-CO-059",
    "name": "Jefferson"
  },
  {
    "code": "US-LA-053",
    "name": "Jefferson Davis"
  },
  {
    "code": "US-MS-065",
    "name": "Jefferson Davis"
  },
  {
    "code": "US-GA-165",
    "name": "Jenkins"
  },
  {
    "code": "US-IN-079",
    "name": "Jennings"
  },
  {
    "code": "US-SD-073",
    "name": "Jerauld"
  },
  {
    "code": "US-ID-053",
    "name": "Jerome"
  },
  {
    "code": "US-IL-083",
    "name": "Jersey"
  },
  {
    "code": "US-KY-113",
    "name": "Jessamine"
  },
  {
    "code": "US-KS-089",
    "name": "Jewell"
  },
  {
    "code": "US-TX-247",
    "name": "Jim Hogg"
  },
  {
    "code": "US-TX-249",
    "name": "Jim Wells"
  },
  {
    "code": "US-IL-085",
    "name": "Jo Daviess"
  },
  {
    "code": "US-AR-071",
    "name": "Johnson"
  },
  {
    "code": "US-GA-167",
    "name": "Johnson"
  },
  {
    "code": "US-WY-019",
    "name": "Johnson"
  },
  {
    "code": "US-NE-097",
    "name": "Johnson"
  },
  {
    "code": "US-IN-081",
    "name": "Johnson"
  },
  {
    "code": "US-KS-091",
    "name": "Johnson"
  },
  {
    "code": "US-MO-101",
    "name": "Johnson"
  },
  {
    "code": "US-IA-103",
    "name": "Johnson"
  },
  {
    "code": "US-TN-091",
    "name": "Johnson"
  },
  {
    "code": "US-IL-087",
    "name": "Johnson"
  },
  {
    "code": "US-TX-251",
    "name": "Johnson"
  },
  {
    "code": "US-KY-115",
    "name": "Johnson"
  },
  {
    "code": "US-NC-101",
    "name": "Johnston"
  },
  {
    "code": "US-OK-069",
    "name": "Johnston"
  },
  {
    "code": "US-GA-169",
    "name": "Jones"
  },
  {
    "code": "US-IA-105",
    "name": "Jones"
  },
  {
    "code": "US-MS-067",
    "name": "Jones"
  },
  {
    "code": "US-NC-103",
    "name": "Jones"
  },
  {
    "code": "US-TX-253",
    "name": "Jones"
  },
  {
    "code": "US-SD-075",
    "name": "Jones"
  },
  {
    "code": "US-OR-033",
    "name": "Josephine"
  },
  {
    "code": "US-UT-023",
    "name": "Juab"
  },
  {
    "code": "US-MT-045",
    "name": "Judith Basin"
  },
  {
    "code": "US-WI-057",
    "name": "Juneau"
  },
  {
    "code": "US-AK-110",
    "name": "Juneau City and Borough"
  },
  {
    "code": "US-PA-067",
    "name": "Juniata"
  },
  {
    "code": "US-MI-077",
    "name": "Kalamazoo"
  },
  {
    "code": "US-HI-005",
    "name": "Kalawao"
  },
  {
    "code": "US-MI-079",
    "name": "Kalkaska"
  },
  {
    "code": "US-MN-065",
    "name": "Kanabec"
  },
  {
    "code": "US-WV-039",
    "name": "Kanawha"
  },
  {
    "code": "US-MN-067",
    "name": "Kandiyohi"
  },
  {
    "code": "US-UT-025",
    "name": "Kane"
  },
  {
    "code": "US-IL-089",
    "name": "Kane"
  },
  {
    "code": "US-IL-091",
    "name": "Kankakee"
  },
  {
    "code": "US-TX-255",
    "name": "Karnes"
  },
  {
    "code": "US-HI-007",
    "name": "Kauai"
  },
  {
    "code": "US-TX-257",
    "name": "Kaufman"
  },
  {
    "code": "US-OK-071",
    "name": "Kay"
  },
  {
    "code": "US-NE-099",
    "name": "Kearney"
  },
  {
    "code": "US-KS-093",
    "name": "Kearny"
  },
  {
    "code": "US-NE-101",
    "name": "Keith"
  },
  {
    "code": "US-MS-069",
    "name": "Kemper"
  },
  {
    "code": "US-AK-122",
    "name": "Kenai Peninsula Borough"
  },
  {
    "code": "US-IL-093",
    "name": "Kendall"
  },
  {
    "code": "US-TX-259",
    "name": "Kendall"
  },
  {
    "code": "US-TX-261",
    "name": "Kenedy"
  },
  {
    "code": "US-ME-011",
    "name": "Kennebec"
  },
  {
    "code": "US-WI-059",
    "name": "Kenosha"
  },
  {
    "code": "US-MI-081",
    "name": "Kent"
  },
  {
    "code": "US-DE-001",
    "name": "Kent"
  },
  {
    "code": "US-RI-003",
    "name": "Kent"
  },
  {
    "code": "US-TX-263",
    "name": "Kent"
  },
  {
    "code": "US-MD-029",
    "name": "Kent"
  },
  {
    "code": "US-KY-117",
    "name": "Kenton"
  },
  {
    "code": "US-IA-107",
    "name": "Keokuk"
  },
  {
    "code": "US-CA-029",
    "name": "Kern"
  },
  {
    "code": "US-TX-265",
    "name": "Kerr"
  },
  {
    "code": "US-SC-055",
    "name": "Kershaw"
  },
  {
    "code": "US-AK-130",
    "name": "Ketchikan Gateway Borough"
  },
  {
    "code": "US-WI-061",
    "name": "Kewaunee"
  },
  {
    "code": "US-MI-083",
    "name": "Keweenaw"
  },
  {
    "code": "US-NE-103",
    "name": "Keya Paha"
  },
  {
    "code": "US-ND-043",
    "name": "Kidder"
  },
  {
    "code": "US-NE-105",
    "name": "Kimball"
  },
  {
    "code": "US-TX-267",
    "name": "Kimble"
  },
  {
    "code": "US-TX-269",
    "name": "King"
  },
  {
    "code": "US-WA-033",
    "name": "King"
  },
  {
    "code": "US-VA-097",
    "name": "King and Queen"
  },
  {
    "code": "US-VA-099",
    "name": "King George"
  },
  {
    "code": "US-VA-101",
    "name": "King William"
  },
  {
    "code": "US-OK-073",
    "name": "Kingfisher"
  },
  {
    "code": "US-KS-095",
    "name": "Kingman"
  },
  {
    "code": "US-CA-031",
    "name": "Kings"
  },
  {
    "code": "US-NY-047",
    "name": "Kings"
  },
  {
    "code": "US-SD-077",
    "name": "Kingsbury"
  },
  {
    "code": "US-TX-271",
    "name": "Kinney"
  },
  {
    "code": "US-KS-097",
    "name": "Kiowa"
  },
  {
    "code": "US-OK-075",
    "name": "Kiowa"
  },
  {
    "code": "US-CO-061",
    "name": "Kiowa"
  },
  {
    "code": "US-CO-063",
    "name": "Kit Carson"
  },
  {
    "code": "US-WA-035",
    "name": "Kitsap"
  },
  {
    "code": "US-WA-037",
    "name": "Kittitas"
  },
  {
    "code": "US-MN-069",
    "name": "Kittson"
  },
  {
    "code": "US-OR-035",
    "name": "Klamath"
  },
  {
    "code": "US-TX-273",
    "name": "Kleberg"
  },
  {
    "code": "US-WA-039",
    "name": "Klickitat"
  },
  {
    "code": "US-KY-119",
    "name": "Knott"
  },
  {
    "code": "US-ME-013",
    "name": "Knox"
  },
  {
    "code": "US-NE-107",
    "name": "Knox"
  },
  {
    "code": "US-IN-083",
    "name": "Knox"
  },
  {
    "code": "US-MO-103",
    "name": "Knox"
  },
  {
    "code": "US-OH-083",
    "name": "Knox"
  },
  {
    "code": "US-TN-093",
    "name": "Knox"
  },
  {
    "code": "US-IL-095",
    "name": "Knox"
  },
  {
    "code": "US-TX-275",
    "name": "Knox"
  },
  {
    "code": "US-KY-121",
    "name": "Knox"
  },
  {
    "code": "US-AK-150",
    "name": "Kodiak Island Borough"
  },
  {
    "code": "US-MN-071",
    "name": "Koochiching"
  },
  {
    "code": "US-ID-055",
    "name": "Kootenai"
  },
  {
    "code": "US-IN-085",
    "name": "Kosciusko"
  },
  {
    "code": "US-IA-109",
    "name": "Kossuth"
  },
  {
    "code": "US-AK-270",
    "name": "Kusilvak Census Area"
  },
  {
    "code": "US-WI-063",
    "name": "La Crosse"
  },
  {
    "code": "US-AZ-012",
    "name": "La Paz"
  },
  {
    "code": "US-CO-067",
    "name": "La Plata"
  },
  {
    "code": "US-LA-059",
    "name": "La Salle"
  },
  {
    "code": "US-IL-099",
    "name": "La Salle"
  },
  {
    "code": "US-TX-283",
    "name": "La Salle"
  },
  {
    "code": "US-KS-099",
    "name": "Labette"
  },
  {
    "code": "US-MN-073",
    "name": "Lac qui Parle"
  },
  {
    "code": "US-PA-069",
    "name": "Lackawanna"
  },
  {
    "code": "US-MO-105",
    "name": "Laclede"
  },
  {
    "code": "US-AR-073",
    "name": "Lafayette"
  },
  {
    "code": "US-FL-067",
    "name": "Lafayette"
  },
  {
    "code": "US-MO-107",
    "name": "Lafayette"
  },
  {
    "code": "US-LA-055",
    "name": "Lafayette"
  },
  {
    "code": "US-MS-071",
    "name": "Lafayette"
  },
  {
    "code": "US-WI-065",
    "name": "Lafayette"
  },
  {
    "code": "US-LA-057",
    "name": "Lafourche"
  },
  {
    "code": "US-IN-087",
    "name": "LaGrange"
  },
  {
    "code": "US-OR-037",
    "name": "Lake"
  },
  {
    "code": "US-MI-085",
    "name": "Lake"
  },
  {
    "code": "US-CA-033",
    "name": "Lake"
  },
  {
    "code": "US-MT-047",
    "name": "Lake"
  },
  {
    "code": "US-IN-089",
    "name": "Lake"
  },
  {
    "code": "US-FL-069",
    "name": "Lake"
  },
  {
    "code": "US-MN-075",
    "name": "Lake"
  },
  {
    "code": "US-OH-085",
    "name": "Lake"
  },
  {
    "code": "US-TN-095",
    "name": "Lake"
  },
  {
    "code": "US-IL-097",
    "name": "Lake"
  },
  {
    "code": "US-SD-079",
    "name": "Lake"
  },
  {
    "code": "US-CO-065",
    "name": "Lake"
  },
  {
    "code": "US-AK-164",
    "name": "Lake and Peninsula Borough"
  },
  {
    "code": "US-MN-077",
    "name": "Lake of the Woods"
  },
  {
    "code": "US-GA-171",
    "name": "Lamar"
  },
  {
    "code": "US-AL-075",
    "name": "Lamar"
  },
  {
    "code": "US-MS-073",
    "name": "Lamar"
  },
  {
    "code": "US-TX-277",
    "name": "Lamar"
  },
  {
    "code": "US-TX-279",
    "name": "Lamb"
  },
  {
    "code": "US-VT-015",
    "name": "Lamoille"
  },
  {
    "code": "US-ND-045",
    "name": "LaMoure"
  },
  {
    "code": "US-TX-281",
    "name": "Lampasas"
  },
  {
    "code": "US-NE-109",
    "name": "Lancaster"
  },
  {
    "code": "US-SC-057",
    "name": "Lancaster"
  },
  {
    "code": "US-PA-071",
    "name": "Lancaster"
  },
  {
    "code": "US-VA-103",
    "name": "Lancaster"
  },
  {
    "code": "US-NV-015",
    "name": "Lander"
  },
  {
    "code": "US-OR-039",
    "name": "Lane"
  },
  {
    "code": "US-KS-101",
    "name": "Lane"
  },
  {
    "code": "US-WI-067",
    "name": "Langlade"
  },
  {
    "code": "US-GA-173",
    "name": "Lanier"
  },
  {
    "code": "US-MI-087",
    "name": "Lapeer"
  },
  {
    "code": "US-IN-091",
    "name": "LaPorte"
  },
  {
    "code": "US-WY-021",
    "name": "Laramie"
  },
  {
    "code": "US-CO-069",
    "name": "Larimer"
  },
  {
    "code": "US-KY-123",
    "name": "Larue"
  },
  {
    "code": "US-CO-071",
    "name": "Las Animas"
  },
  {
    "code": "US-CA-035",
    "name": "Lassen"
  },
  {
    "code": "US-ID-057",
    "name": "Latah"
  },
  {
    "code": "US-OK-077",
    "name": "Latimer"
  },
  {
    "code": "US-AL-077",
    "name": "Lauderdale"
  },
  {
    "code": "US-MS-075",
    "name": "Lauderdale"
  },
  {
    "code": "US-TN-097",
    "name": "Lauderdale"
  },
  {
    "code": "US-KY-125",
    "name": "Laurel"
  },
  {
    "code": "US-GA-175",
    "name": "Laurens"
  },
  {
    "code": "US-SC-059",
    "name": "Laurens"
  },
  {
    "code": "US-TX-285",
    "name": "Lavaca"
  },
  {
    "code": "US-AR-075",
    "name": "Lawrence"
  },
  {
    "code": "US-IN-093",
    "name": "Lawrence"
  },
  {
    "code": "US-PA-073",
    "name": "Lawrence"
  },
  {
    "code": "US-MO-109",
    "name": "Lawrence"
  },
  {
    "code": "US-IL-101",
    "name": "Lawrence"
  },
  {
    "code": "US-AL-079",
    "name": "Lawrence"
  },
  {
    "code": "US-MS-077",
    "name": "Lawrence"
  },
  {
    "code": "US-OH-087",
    "name": "Lawrence"
  },
  {
    "code": "US-TN-099",
    "name": "Lawrence"
  },
  {
    "code": "US-SD-081",
    "name": "Lawrence"
  },
  {
    "code": "US-KY-127",
    "name": "Lawrence"
  },
  {
    "code": "US-OK-079",
    "name": "Le Flore"
  },
  {
    "code": "US-MN-079",
    "name": "Le Sueur"
  },
  {
    "code": "US-NM-025",
    "name": "Lea"
  },
  {
    "code": "US-MS-079",
    "name": "Leake"
  },
  {
    "code": "US-KS-103",
    "name": "Leavenworth"
  },
  {
    "code": "US-PA-075",
    "name": "Lebanon"
  },
  {
    "code": "US-AR-077",
    "name": "Lee"
  },
  {
    "code": "US-GA-177",
    "name": "Lee"
  },
  {
    "code": "US-SC-061",
    "name": "Lee"
  },
  {
    "code": "US-FL-071",
    "name": "Lee"
  },
  {
    "code": "US-VA-105",
    "name": "Lee"
  },
  {
    "code": "US-IL-103",
    "name": "Lee"
  },
  {
    "code": "US-IA-111",
    "name": "Lee"
  },
  {
    "code": "US-AL-081",
    "name": "Lee"
  },
  {
    "code": "US-MS-081",
    "name": "Lee"
  },
  {
    "code": "US-NC-105",
    "name": "Lee"
  },
  {
    "code": "US-TX-287",
    "name": "Lee"
  },
  {
    "code": "US-KY-129",
    "name": "Lee"
  },
  {
    "code": "US-MI-089",
    "name": "Leelanau"
  },
  {
    "code": "US-MS-083",
    "name": "Leflore"
  },
  {
    "code": "US-PA-077",
    "name": "Lehigh"
  },
  {
    "code": "US-ID-059",
    "name": "Lemhi"
  },
  {
    "code": "US-MI-091",
    "name": "Lenawee"
  },
  {
    "code": "US-NC-107",
    "name": "Lenoir"
  },
  {
    "code": "US-FL-073",
    "name": "Leon"
  },
  {
    "code": "US-TX-289",
    "name": "Leon"
  },
  {
    "code": "US-KY-131",
    "name": "Leslie"
  },
  {
    "code": "US-KY-133",
    "name": "Letcher"
  },
  {
    "code": "US-FL-075",
    "name": "Levy"
  },
  {
    "code": "US-WV-041",
    "name": "Lewis"
  },
  {
    "code": "US-TN-101",
    "name": "Lewis"
  },
  {
    "code": "US-MO-111",
    "name": "Lewis"
  },
  {
    "code": "US-ID-061",
    "name": "Lewis"
  },
  {
    "code": "US-NY-049",
    "name": "Lewis"
  },
  {
    "code": "US-WA-041",
    "name": "Lewis"
  },
  {
    "code": "US-KY-135",
    "name": "Lewis"
  },
  {
    "code": "US-MT-049",
    "name": "Lewis and Clark"
  },
  {
    "code": "US-SC-063",
    "name": "Lexington"
  },
  {
    "code": "US-VA-678",
    "name": "Lexington"
  },
  {
    "code": "US-MT-051",
    "name": "Liberty"
  },
  {
    "code": "US-GA-179",
    "name": "Liberty"
  },
  {
    "code": "US-FL-077",
    "name": "Liberty"
  },
  {
    "code": "US-TX-291",
    "name": "Liberty"
  },
  {
    "code": "US-OH-089",
    "name": "Licking"
  },
  {
    "code": "US-AL-083",
    "name": "Limestone"
  },
  {
    "code": "US-TX-293",
    "name": "Limestone"
  },
  {
    "code": "US-AR-079",
    "name": "Lincoln"
  },
  {
    "code": "US-OR-041",
    "name": "Lincoln"
  },
  {
    "code": "US-ME-015",
    "name": "Lincoln"
  },
  {
    "code": "US-MT-053",
    "name": "Lincoln"
  },
  {
    "code": "US-GA-181",
    "name": "Lincoln"
  },
  {
    "code": "US-KS-105",
    "name": "Lincoln"
  },
  {
    "code": "US-NE-111",
    "name": "Lincoln"
  },
  {
    "code": "US-WY-023",
    "name": "Lincoln"
  },
  {
    "code": "US-WV-043",
    "name": "Lincoln"
  },
  {
    "code": "US-TN-103",
    "name": "Lincoln"
  },
  {
    "code": "US-NM-027",
    "name": "Lincoln"
  },
  {
    "code": "US-MN-081",
    "name": "Lincoln"
  },
  {
    "code": "US-MO-113",
    "name": "Lincoln"
  },
  {
    "code": "US-ID-063",
    "name": "Lincoln"
  },
  {
    "code": "US-LA-061",
    "name": "Lincoln"
  },
  {
    "code": "US-MS-085",
    "name": "Lincoln"
  },
  {
    "code": "US-NC-109",
    "name": "Lincoln"
  },
  {
    "code": "US-NV-017",
    "name": "Lincoln"
  },
  {
    "code": "US-WA-043",
    "name": "Lincoln"
  },
  {
    "code": "US-SD-083",
    "name": "Lincoln"
  },
  {
    "code": "US-KY-137",
    "name": "Lincoln"
  },
  {
    "code": "US-OK-081",
    "name": "Lincoln"
  },
  {
    "code": "US-WI-069",
    "name": "Lincoln"
  },
  {
    "code": "US-CO-073",
    "name": "Lincoln"
  },
  {
    "code": "US-OR-043",
    "name": "Linn"
  },
  {
    "code": "US-KS-107",
    "name": "Linn"
  },
  {
    "code": "US-MO-115",
    "name": "Linn"
  },
  {
    "code": "US-IA-113",
    "name": "Linn"
  },
  {
    "code": "US-TX-295",
    "name": "Lipscomb"
  },
  {
    "code": "US-CT-005",
    "name": "Litchfield"
  },
  {
    "code": "US-AR-081",
    "name": "Little River"
  },
  {
    "code": "US-TX-297",
    "name": "Live Oak"
  },
  {
    "code": "US-MI-093",
    "name": "Livingston"
  },
  {
    "code": "US-MO-117",
    "name": "Livingston"
  },
  {
    "code": "US-LA-063",
    "name": "Livingston"
  },
  {
    "code": "US-IL-105",
    "name": "Livingston"
  },
  {
    "code": "US-NY-051",
    "name": "Livingston"
  },
  {
    "code": "US-KY-139",
    "name": "Livingston"
  },
  {
    "code": "US-TX-299",
    "name": "Llano"
  },
  {
    "code": "US-AR-083",
    "name": "Logan"
  },
  {
    "code": "US-KS-109",
    "name": "Logan"
  },
  {
    "code": "US-NE-113",
    "name": "Logan"
  },
  {
    "code": "US-WV-045",
    "name": "Logan"
  },
  {
    "code": "US-IL-107",
    "name": "Logan"
  },
  {
    "code": "US-OH-091",
    "name": "Logan"
  },
  {
    "code": "US-KY-141",
    "name": "Logan"
  },
  {
    "code": "US-OK-083",
    "name": "Logan"
  },
  {
    "code": "US-ND-047",
    "name": "Logan"
  },
  {
    "code": "US-CO-075",
    "name": "Logan"
  },
  {
    "code": "US-GA-183",
    "name": "Long"
  },
  {
    "code": "US-AR-085",
    "name": "Lonoke"
  },
  {
    "code": "US-OH-093",
    "name": "Lorain"
  },
  {
    "code": "US-NM-028",
    "name": "Los Alamos"
  },
  {
    "code": "US-CA-037",
    "name": "Los Angeles"
  },
  {
    "code": "US-TN-105",
    "name": "Loudon"
  },
  {
    "code": "US-VA-107",
    "name": "Loudoun"
  },
  {
    "code": "US-VA-109",
    "name": "Louisa"
  },
  {
    "code": "US-IA-115",
    "name": "Louisa"
  },
  {
    "code": "US-NE-115",
    "name": "Loup"
  },
  {
    "code": "US-OK-085",
    "name": "Love"
  },
  {
    "code": "US-TX-301",
    "name": "Loving"
  },
  {
    "code": "US-GA-185",
    "name": "Lowndes"
  },
  {
    "code": "US-AL-085",
    "name": "Lowndes"
  },
  {
    "code": "US-MS-087",
    "name": "Lowndes"
  },
  {
    "code": "US-TX-303",
    "name": "Lubbock"
  },
  {
    "code": "US-IA-117",
    "name": "Lucas"
  },
  {
    "code": "US-OH-095",
    "name": "Lucas"
  },
  {
    "code": "US-MI-095",
    "name": "Luce"
  },
  {
    "code": "US-GA-187",
    "name": "Lumpkin"
  },
  {
    "code": "US-NM-029",
    "name": "Luna"
  },
  {
    "code": "US-VA-111",
    "name": "Lunenburg"
  },
  {
    "code": "US-PA-079",
    "name": "Luzerne"
  },
  {
    "code": "US-PA-081",
    "name": "Lycoming"
  },
  {
    "code": "US-SD-085",
    "name": "Lyman"
  },
  {
    "code": "US-VA-680",
    "name": "Lynchburg"
  },
  {
    "code": "US-TX-305",
    "name": "Lynn"
  },
  {
    "code": "US-KS-111",
    "name": "Lyon"
  },
  {
    "code": "US-MN-083",
    "name": "Lyon"
  },
  {
    "code": "US-IA-119",
    "name": "Lyon"
  },
  {
    "code": "US-NV-019",
    "name": "Lyon"
  },
  {
    "code": "US-KY-143",
    "name": "Lyon"
  },
  {
    "code": "US-MI-097",
    "name": "Mackinac"
  },
  {
    "code": "US-MI-099",
    "name": "Macomb"
  },
  {
    "code": "US-GA-193",
    "name": "Macon"
  },
  {
    "code": "US-TN-111",
    "name": "Macon"
  },
  {
    "code": "US-MO-121",
    "name": "Macon"
  },
  {
    "code": "US-NC-113",
    "name": "Macon"
  },
  {
    "code": "US-IL-115",
    "name": "Macon"
  },
  {
    "code": "US-AL-087",
    "name": "Macon"
  },
  {
    "code": "US-IL-117",
    "name": "Macoupin"
  },
  {
    "code": "US-CA-039",
    "name": "Madera"
  },
  {
    "code": "US-AR-087",
    "name": "Madison"
  },
  {
    "code": "US-MT-057",
    "name": "Madison"
  },
  {
    "code": "US-GA-195",
    "name": "Madison"
  },
  {
    "code": "US-NE-119",
    "name": "Madison"
  },
  {
    "code": "US-IN-095",
    "name": "Madison"
  },
  {
    "code": "US-FL-079",
    "name": "Madison"
  },
  {
    "code": "US-VA-113",
    "name": "Madison"
  },
  {
    "code": "US-TN-113",
    "name": "Madison"
  },
  {
    "code": "US-MO-123",
    "name": "Madison"
  },
  {
    "code": "US-ID-065",
    "name": "Madison"
  },
  {
    "code": "US-NC-115",
    "name": "Madison"
  },
  {
    "code": "US-LA-065",
    "name": "Madison"
  },
  {
    "code": "US-IL-119",
    "name": "Madison"
  },
  {
    "code": "US-NY-053",
    "name": "Madison"
  },
  {
    "code": "US-AL-089",
    "name": "Madison"
  },
  {
    "code": "US-MS-089",
    "name": "Madison"
  },
  {
    "code": "US-OH-097",
    "name": "Madison"
  },
  {
    "code": "US-IA-121",
    "name": "Madison"
  },
  {
    "code": "US-KY-151",
    "name": "Madison"
  },
  {
    "code": "US-TX-313",
    "name": "Madison"
  },
  {
    "code": "US-KY-153",
    "name": "Magoffin"
  },
  {
    "code": "US-IA-123",
    "name": "Mahaska"
  },
  {
    "code": "US-MN-087",
    "name": "Mahnomen"
  },
  {
    "code": "US-OH-099",
    "name": "Mahoning"
  },
  {
    "code": "US-OK-093",
    "name": "Major"
  },
  {
    "code": "US-OR-045",
    "name": "Malheur"
  },
  {
    "code": "US-VA-683",
    "name": "Manassas"
  },
  {
    "code": "US-VA-685",
    "name": "Manassas Park"
  },
  {
    "code": "US-FL-081",
    "name": "Manatee"
  },
  {
    "code": "US-MI-101",
    "name": "Manistee"
  },
  {
    "code": "US-WI-071",
    "name": "Manitowoc"
  },
  {
    "code": "US-WI-073",
    "name": "Marathon"
  },
  {
    "code": "US-AL-091",
    "name": "Marengo"
  },
  {
    "code": "US-AZ-013",
    "name": "Maricopa"
  },
  {
    "code": "US-MO-125",
    "name": "Maries"
  },
  {
    "code": "US-CA-041",
    "name": "Marin"
  },
  {
    "code": "US-WI-075",
    "name": "Marinette"
  },
  {
    "code": "US-AR-089",
    "name": "Marion"
  },
  {
    "code": "US-OR-047",
    "name": "Marion"
  },
  {
    "code": "US-SC-067",
    "name": "Marion"
  },
  {
    "code": "US-GA-197",
    "name": "Marion"
  },
  {
    "code": "US-KS-115",
    "name": "Marion"
  },
  {
    "code": "US-IN-097",
    "name": "Marion"
  },
  {
    "code": "US-FL-083",
    "name": "Marion"
  },
  {
    "code": "US-WV-049",
    "name": "Marion"
  },
  {
    "code": "US-TN-115",
    "name": "Marion"
  },
  {
    "code": "US-MO-127",
    "name": "Marion"
  },
  {
    "code": "US-IL-121",
    "name": "Marion"
  },
  {
    "code": "US-AL-093",
    "name": "Marion"
  },
  {
    "code": "US-MS-091",
    "name": "Marion"
  },
  {
    "code": "US-IA-125",
    "name": "Marion"
  },
  {
    "code": "US-OH-101",
    "name": "Marion"
  },
  {
    "code": "US-TX-315",
    "name": "Marion"
  },
  {
    "code": "US-KY-155",
    "name": "Marion"
  },
  {
    "code": "US-CA-043",
    "name": "Mariposa"
  },
  {
    "code": "US-SC-069",
    "name": "Marlboro"
  },
  {
    "code": "US-MI-103",
    "name": "Marquette"
  },
  {
    "code": "US-WI-077",
    "name": "Marquette"
  },
  {
    "code": "US-KS-117",
    "name": "Marshall"
  },
  {
    "code": "US-IN-099",
    "name": "Marshall"
  },
  {
    "code": "US-WV-051",
    "name": "Marshall"
  },
  {
    "code": "US-TN-117",
    "name": "Marshall"
  },
  {
    "code": "US-MN-089",
    "name": "Marshall"
  },
  {
    "code": "US-IL-123",
    "name": "Marshall"
  },
  {
    "code": "US-AL-095",
    "name": "Marshall"
  },
  {
    "code": "US-MS-093",
    "name": "Marshall"
  },
  {
    "code": "US-IA-127",
    "name": "Marshall"
  },
  {
    "code": "US-SD-091",
    "name": "Marshall"
  },
  {
    "code": "US-OK-095",
    "name": "Marshall"
  },
  {
    "code": "US-KY-157",
    "name": "Marshall"
  },
  {
    "code": "US-IN-101",
    "name": "Martin"
  },
  {
    "code": "US-FL-085",
    "name": "Martin"
  },
  {
    "code": "US-MN-091",
    "name": "Martin"
  },
  {
    "code": "US-NC-117",
    "name": "Martin"
  },
  {
    "code": "US-TX-317",
    "name": "Martin"
  },
  {
    "code": "US-KY-159",
    "name": "Martin"
  },
  {
    "code": "US-VA-690",
    "name": "Martinsville"
  },
  {
    "code": "US-WV-053",
    "name": "Mason"
  },
  {
    "code": "US-IL-125",
    "name": "Mason"
  },
  {
    "code": "US-WA-045",
    "name": "Mason"
  },
  {
    "code": "US-MI-105",
    "name": "Mason"
  },
  {
    "code": "US-TX-319",
    "name": "Mason"
  },
  {
    "code": "US-KY-161",
    "name": "Mason"
  },
  {
    "code": "US-IL-127",
    "name": "Massac"
  },
  {
    "code": "US-TX-321",
    "name": "Matagorda"
  },
  {
    "code": "US-AK-170",
    "name": "Matanuska-Susitna Borough"
  },
  {
    "code": "US-VA-115",
    "name": "Mathews"
  },
  {
    "code": "US-HI-009",
    "name": "Maui"
  },
  {
    "code": "US-TN-119",
    "name": "Maury"
  },
  {
    "code": "US-TX-323",
    "name": "Maverick"
  },
  {
    "code": "US-OK-097",
    "name": "Mayes"
  },
  {
    "code": "US-OK-087",
    "name": "McClain"
  },
  {
    "code": "US-MT-055",
    "name": "McCone"
  },
  {
    "code": "US-SD-087",
    "name": "McCook"
  },
  {
    "code": "US-SC-065",
    "name": "McCormick"
  },
  {
    "code": "US-KY-145",
    "name": "McCracken"
  },
  {
    "code": "US-KY-147",
    "name": "McCreary"
  },
  {
    "code": "US-TX-307",
    "name": "McCulloch"
  },
  {
    "code": "US-OK-089",
    "name": "McCurtain"
  },
  {
    "code": "US-MO-119",
    "name": "McDonald"
  },
  {
    "code": "US-IL-109",
    "name": "McDonough"
  },
  {
    "code": "US-WV-047",
    "name": "McDowell"
  },
  {
    "code": "US-NC-111",
    "name": "McDowell"
  },
  {
    "code": "US-GA-189",
    "name": "McDuffie"
  },
  {
    "code": "US-IL-111",
    "name": "McHenry"
  },
  {
    "code": "US-ND-049",
    "name": "McHenry"
  },
  {
    "code": "US-GA-191",
    "name": "McIntosh"
  },
  {
    "code": "US-OK-091",
    "name": "McIntosh"
  },
  {
    "code": "US-ND-051",
    "name": "McIntosh"
  },
  {
    "code": "US-PA-083",
    "name": "McKean"
  },
  {
    "code": "US-ND-053",
    "name": "McKenzie"
  },
  {
    "code": "US-NM-031",
    "name": "McKinley"
  },
  {
    "code": "US-IL-113",
    "name": "McLean"
  },
  {
    "code": "US-KY-149",
    "name": "McLean"
  },
  {
    "code": "US-ND-055",
    "name": "McLean"
  },
  {
    "code": "US-TX-309",
    "name": "McLennan"
  },
  {
    "code": "US-MN-085",
    "name": "McLeod"
  },
  {
    "code": "US-TN-107",
    "name": "McMinn"
  },
  {
    "code": "US-TX-311",
    "name": "McMullen"
  },
  {
    "code": "US-TN-109",
    "name": "McNairy"
  },
  {
    "code": "US-KS-113",
    "name": "McPherson"
  },
  {
    "code": "US-NE-117",
    "name": "McPherson"
  },
  {
    "code": "US-SD-089",
    "name": "McPherson"
  },
  {
    "code": "US-KS-119",
    "name": "Meade"
  },
  {
    "code": "US-SD-093",
    "name": "Meade"
  },
  {
    "code": "US-KY-163",
    "name": "Meade"
  },
  {
    "code": "US-MT-059",
    "name": "Meagher"
  },
  {
    "code": "US-VA-117",
    "name": "Mecklenburg"
  },
  {
    "code": "US-NC-119",
    "name": "Mecklenburg"
  },
  {
    "code": "US-MI-107",
    "name": "Mecosta"
  },
  {
    "code": "US-OH-103",
    "name": "Medina"
  },
  {
    "code": "US-TX-325",
    "name": "Medina"
  },
  {
    "code": "US-MN-093",
    "name": "Meeker"
  },
  {
    "code": "US-TN-121",
    "name": "Meigs"
  },
  {
    "code": "US-OH-105",
    "name": "Meigs"
  },
  {
    "code": "US-SD-095",
    "name": "Mellette"
  },
  {
    "code": "US-IL-129",
    "name": "Menard"
  },
  {
    "code": "US-TX-327",
    "name": "Menard"
  },
  {
    "code": "US-CA-045",
    "name": "Mendocino"
  },
  {
    "code": "US-KY-165",
    "name": "Menifee"
  },
  {
    "code": "US-MI-109",
    "name": "Menominee"
  },
  {
    "code": "US-WI-078",
    "name": "Menominee"
  },
  {
    "code": "US-CA-047",
    "name": "Merced"
  },
  {
    "code": "US-PA-085",
    "name": "Mercer"
  },
  {
    "code": "US-WV-055",
    "name": "Mercer"
  },
  {
    "code": "US-MO-129",
    "name": "Mercer"
  },
  {
    "code": "US-NJ-021",
    "name": "Mercer"
  },
  {
    "code": "US-IL-131",
    "name": "Mercer"
  },
  {
    "code": "US-OH-107",
    "name": "Mercer"
  },
  {
    "code": "US-KY-167",
    "name": "Mercer"
  },
  {
    "code": "US-ND-057",
    "name": "Mercer"
  },
  {
    "code": "US-GA-199",
    "name": "Meriwether"
  },
  {
    "code": "US-NE-121",
    "name": "Merrick"
  },
  {
    "code": "US-NH-013",
    "name": "Merrimack"
  },
  {
    "code": "US-CO-077",
    "name": "Mesa"
  },
  {
    "code": "US-KY-169",
    "name": "Metcalfe"
  },
  {
    "code": "US-KS-121",
    "name": "Miami"
  },
  {
    "code": "US-IN-103",
    "name": "Miami"
  },
  {
    "code": "US-OH-109",
    "name": "Miami"
  },
  {
    "code": "US-FL-086",
    "name": "Miami-Dade"
  },
  {
    "code": "US-CT-007",
    "name": "Middlesex"
  },
  {
    "code": "US-VA-119",
    "name": "Middlesex"
  },
  {
    "code": "US-NJ-023",
    "name": "Middlesex"
  },
  {
    "code": "US-MA-017",
    "name": "Middlesex"
  },
  {
    "code": "US-TX-329",
    "name": "Midland"
  },
  {
    "code": "US-MI-111",
    "name": "Midland"
  },
  {
    "code": "US-PA-087",
    "name": "Mifflin"
  },
  {
    "code": "US-TX-331",
    "name": "Milam"
  },
  {
    "code": "US-UT-027",
    "name": "Millard"
  },
  {
    "code": "US-MN-095",
    "name": "Mille Lacs"
  },
  {
    "code": "US-AR-091",
    "name": "Miller"
  },
  {
    "code": "US-GA-201",
    "name": "Miller"
  },
  {
    "code": "US-MO-131",
    "name": "Miller"
  },
  {
    "code": "US-IA-129",
    "name": "Mills"
  },
  {
    "code": "US-TX-333",
    "name": "Mills"
  },
  {
    "code": "US-WI-079",
    "name": "Milwaukee"
  },
  {
    "code": "US-SD-097",
    "name": "Miner"
  },
  {
    "code": "US-MT-061",
    "name": "Mineral"
  },
  {
    "code": "US-WV-057",
    "name": "Mineral"
  },
  {
    "code": "US-NV-021",
    "name": "Mineral"
  },
  {
    "code": "US-CO-079",
    "name": "Mineral"
  },
  {
    "code": "US-WV-059",
    "name": "Mingo"
  },
  {
    "code": "US-ID-067",
    "name": "Minidoka"
  },
  {
    "code": "US-SD-099",
    "name": "Minnehaha"
  },
  {
    "code": "US-MI-113",
    "name": "Missaukee"
  },
  {
    "code": "US-AR-093",
    "name": "Mississippi"
  },
  {
    "code": "US-MO-133",
    "name": "Mississippi"
  },
  {
    "code": "US-MT-063",
    "name": "Missoula"
  },
  {
    "code": "US-KS-123",
    "name": "Mitchell"
  },
  {
    "code": "US-GA-205",
    "name": "Mitchell"
  },
  {
    "code": "US-NC-121",
    "name": "Mitchell"
  },
  {
    "code": "US-IA-131",
    "name": "Mitchell"
  },
  {
    "code": "US-TX-335",
    "name": "Mitchell"
  },
  {
    "code": "US-AL-097",
    "name": "Mobile"
  },
  {
    "code": "US-CA-049",
    "name": "Modoc"
  },
  {
    "code": "US-CO-081",
    "name": "Moffat"
  },
  {
    "code": "US-AZ-015",
    "name": "Mohave"
  },
  {
    "code": "US-MO-135",
    "name": "Moniteau"
  },
  {
    "code": "US-NJ-025",
    "name": "Monmouth"
  },
  {
    "code": "US-CA-051",
    "name": "Mono"
  },
  {
    "code": "US-IA-133",
    "name": "Monona"
  },
  {
    "code": "US-WV-061",
    "name": "Monongalia"
  },
  {
    "code": "US-AR-095",
    "name": "Monroe"
  },
  {
    "code": "US-IN-105",
    "name": "Monroe"
  },
  {
    "code": "US-GA-207",
    "name": "Monroe"
  },
  {
    "code": "US-FL-087",
    "name": "Monroe"
  },
  {
    "code": "US-PA-089",
    "name": "Monroe"
  },
  {
    "code": "US-TN-123",
    "name": "Monroe"
  },
  {
    "code": "US-WV-063",
    "name": "Monroe"
  },
  {
    "code": "US-MO-137",
    "name": "Monroe"
  },
  {
    "code": "US-NY-055",
    "name": "Monroe"
  },
  {
    "code": "US-IL-133",
    "name": "Monroe"
  },
  {
    "code": "US-AL-099",
    "name": "Monroe"
  },
  {
    "code": "US-MS-095",
    "name": "Monroe"
  },
  {
    "code": "US-IA-135",
    "name": "Monroe"
  },
  {
    "code": "US-OH-111",
    "name": "Monroe"
  },
  {
    "code": "US-MI-115",
    "name": "Monroe"
  },
  {
    "code": "US-KY-171",
    "name": "Monroe"
  },
  {
    "code": "US-WI-081",
    "name": "Monroe"
  },
  {
    "code": "US-TX-337",
    "name": "Montague"
  },
  {
    "code": "US-MI-117",
    "name": "Montcalm"
  },
  {
    "code": "US-CA-053",
    "name": "Monterey"
  },
  {
    "code": "US-CO-083",
    "name": "Montezuma"
  },
  {
    "code": "US-AR-097",
    "name": "Montgomery"
  },
  {
    "code": "US-KS-125",
    "name": "Montgomery"
  },
  {
    "code": "US-IN-107",
    "name": "Montgomery"
  },
  {
    "code": "US-GA-209",
    "name": "Montgomery"
  },
  {
    "code": "US-VA-121",
    "name": "Montgomery"
  },
  {
    "code": "US-PA-091",
    "name": "Montgomery"
  },
  {
    "code": "US-TN-125",
    "name": "Montgomery"
  },
  {
    "code": "US-MO-139",
    "name": "Montgomery"
  },
  {
    "code": "US-NC-123",
    "name": "Montgomery"
  },
  {
    "code": "US-NY-057",
    "name": "Montgomery"
  },
  {
    "code": "US-IL-135",
    "name": "Montgomery"
  },
  {
    "code": "US-MS-097",
    "name": "Montgomery"
  },
  {
    "code": "US-AL-101",
    "name": "Montgomery"
  },
  {
    "code": "US-IA-137",
    "name": "Montgomery"
  },
  {
    "code": "US-OH-113",
    "name": "Montgomery"
  },
  {
    "code": "US-MD-031",
    "name": "Montgomery"
  },
  {
    "code": "US-TX-339",
    "name": "Montgomery"
  },
  {
    "code": "US-KY-173",
    "name": "Montgomery"
  },
  {
    "code": "US-MI-119",
    "name": "Montmorency"
  },
  {
    "code": "US-PA-093",
    "name": "Montour"
  },
  {
    "code": "US-CO-085",
    "name": "Montrose"
  },
  {
    "code": "US-SD-101",
    "name": "Moody"
  },
  {
    "code": "US-TN-127",
    "name": "Moore"
  },
  {
    "code": "US-NC-125",
    "name": "Moore"
  },
  {
    "code": "US-TX-341",
    "name": "Moore"
  },
  {
    "code": "US-NM-033",
    "name": "Mora"
  },
  {
    "code": "US-LA-067",
    "name": "Morehouse"
  },
  {
    "code": "US-IN-109",
    "name": "Morgan"
  },
  {
    "code": "US-GA-211",
    "name": "Morgan"
  },
  {
    "code": "US-TN-129",
    "name": "Morgan"
  },
  {
    "code": "US-WV-065",
    "name": "Morgan"
  },
  {
    "code": "US-UT-029",
    "name": "Morgan"
  },
  {
    "code": "US-MO-141",
    "name": "Morgan"
  },
  {
    "code": "US-IL-137",
    "name": "Morgan"
  },
  {
    "code": "US-AL-103",
    "name": "Morgan"
  },
  {
    "code": "US-OH-115",
    "name": "Morgan"
  },
  {
    "code": "US-KY-175",
    "name": "Morgan"
  },
  {
    "code": "US-CO-087",
    "name": "Morgan"
  },
  {
    "code": "US-NE-123",
    "name": "Morrill"
  },
  {
    "code": "US-KS-127",
    "name": "Morris"
  },
  {
    "code": "US-NJ-027",
    "name": "Morris"
  },
  {
    "code": "US-TX-343",
    "name": "Morris"
  },
  {
    "code": "US-MN-097",
    "name": "Morrison"
  },
  {
    "code": "US-OR-049",
    "name": "Morrow"
  },
  {
    "code": "US-OH-117",
    "name": "Morrow"
  },
  {
    "code": "US-KS-129",
    "name": "Morton"
  },
  {
    "code": "US-ND-059",
    "name": "Morton"
  },
  {
    "code": "US-TX-345",
    "name": "Motley"
  },
  {
    "code": "US-IL-139",
    "name": "Moultrie"
  },
  {
    "code": "US-ND-061",
    "name": "Mountrail"
  },
  {
    "code": "US-MN-099",
    "name": "Mower"
  },
  {
    "code": "US-KY-177",
    "name": "Muhlenberg"
  },
  {
    "code": "US-OR-051",
    "name": "Multnomah"
  },
  {
    "code": "US-GA-213",
    "name": "Murray"
  },
  {
    "code": "US-MN-101",
    "name": "Murray"
  },
  {
    "code": "US-OK-099",
    "name": "Murray"
  },
  {
    "code": "US-IA-139",
    "name": "Muscatine"
  },
  {
    "code": "US-GA-215",
    "name": "Muscogee"
  },
  {
    "code": "US-MI-121",
    "name": "Muskegon"
  },
  {
    "code": "US-OH-119",
    "name": "Muskingum"
  },
  {
    "code": "US-OK-101",
    "name": "Muskogee"
  },
  {
    "code": "US-MT-065",
    "name": "Musselshell"
  },
  {
    "code": "US-TX-347",
    "name": "Nacogdoches"
  },
  {
    "code": "US-NE-125",
    "name": "Nance"
  },
  {
    "code": "US-MA-019",
    "name": "Nantucket"
  },
  {
    "code": "US-CA-055",
    "name": "Napa"
  },
  {
    "code": "US-NC-127",
    "name": "Nash"
  },
  {
    "code": "US-FL-089",
    "name": "Nassau"
  },
  {
    "code": "US-NY-059",
    "name": "Nassau"
  },
  {
    "code": "US-LA-069",
    "name": "Natchitoches"
  },
  {
    "code": "US-WY-025",
    "name": "Natrona"
  },
  {
    "code": "US-AZ-017",
    "name": "Navajo"
  },
  {
    "code": "US-TX-349",
    "name": "Navarro"
  },
  {
    "code": "US-VA-125",
    "name": "Nelson"
  },
  {
    "code": "US-KY-179",
    "name": "Nelson"
  },
  {
    "code": "US-ND-063",
    "name": "Nelson"
  },
  {
    "code": "US-KS-131",
    "name": "Nemaha"
  },
  {
    "code": "US-NE-127",
    "name": "Nemaha"
  },
  {
    "code": "US-KS-133",
    "name": "Neosho"
  },
  {
    "code": "US-MS-099",
    "name": "Neshoba"
  },
  {
    "code": "US-KS-135",
    "name": "Ness"
  },
  {
    "code": "US-AR-099",
    "name": "Nevada"
  },
  {
    "code": "US-CA-057",
    "name": "Nevada"
  },
  {
    "code": "US-DE-003",
    "name": "New Castle"
  },
  {
    "code": "US-NC-129",
    "name": "New Hanover"
  },
  {
    "code": "US-CT-009",
    "name": "New Haven"
  },
  {
    "code": "US-VA-127",
    "name": "New Kent"
  },
  {
    "code": "US-CT-011",
    "name": "New London"
  },
  {
    "code": "US-MO-143",
    "name": "New Madrid"
  },
  {
    "code": "US-NY-061",
    "name": "New York"
  },
  {
    "code": "US-MI-123",
    "name": "Newaygo"
  },
  {
    "code": "US-SC-071",
    "name": "Newberry"
  },
  {
    "code": "US-RI-005",
    "name": "Newport"
  },
  {
    "code": "US-VA-700",
    "name": "Newport News"
  },
  {
    "code": "US-AR-101",
    "name": "Newton"
  },
  {
    "code": "US-IN-111",
    "name": "Newton"
  },
  {
    "code": "US-GA-217",
    "name": "Newton"
  },
  {
    "code": "US-MO-145",
    "name": "Newton"
  },
  {
    "code": "US-MS-101",
    "name": "Newton"
  },
  {
    "code": "US-TX-351",
    "name": "Newton"
  },
  {
    "code": "US-ID-069",
    "name": "Nez Perce"
  },
  {
    "code": "US-NY-063",
    "name": "Niagara"
  },
  {
    "code": "US-WV-067",
    "name": "Nicholas"
  },
  {
    "code": "US-KY-181",
    "name": "Nicholas"
  },
  {
    "code": "US-MN-103",
    "name": "Nicollet"
  },
  {
    "code": "US-WY-027",
    "name": "Niobrara"
  },
  {
    "code": "US-OK-103",
    "name": "Noble"
  },
  {
    "code": "US-IN-113",
    "name": "Noble"
  },
  {
    "code": "US-OH-121",
    "name": "Noble"
  },
  {
    "code": "US-MN-105",
    "name": "Nobles"
  },
  {
    "code": "US-MO-147",
    "name": "Nodaway"
  },
  {
    "code": "US-TX-353",
    "name": "Nolan"
  },
  {
    "code": "US-AK-180",
    "name": "Nome Census Area"
  },
  {
    "code": "US-VA-710",
    "name": "Norfolk"
  },
  {
    "code": "US-MA-021",
    "name": "Norfolk"
  },
  {
    "code": "US-MN-107",
    "name": "Norman"
  },
  {
    "code": "US-AK-185",
    "name": "North Slope Borough"
  },
  {
    "code": "US-VA-131",
    "name": "Northampton"
  },
  {
    "code": "US-PA-095",
    "name": "Northampton"
  },
  {
    "code": "US-NC-131",
    "name": "Northampton"
  },
  {
    "code": "US-VA-133",
    "name": "Northumberland"
  },
  {
    "code": "US-PA-097",
    "name": "Northumberland"
  },
  {
    "code": "US-AK-188",
    "name": "Northwest Arctic Borough"
  },
  {
    "code": "US-HI-010",
    "name": "Northwestern Hawaiian Islands"
  },
  {
    "code": "US-KS-137",
    "name": "Norton"
  },
  {
    "code": "US-VA-720",
    "name": "Norton"
  },
  {
    "code": "US-VA-135",
    "name": "Nottoway"
  },
  {
    "code": "US-OK-105",
    "name": "Nowata"
  },
  {
    "code": "US-MS-103",
    "name": "Noxubee"
  },
  {
    "code": "US-NE-129",
    "name": "Nuckolls"
  },
  {
    "code": "US-TX-355",
    "name": "Nueces"
  },
  {
    "code": "US-NV-023",
    "name": "Nye"
  },
  {
    "code": "US-IA-141",
    "name": "O'Brien"
  },
  {
    "code": "US-MI-125",
    "name": "Oakland"
  },
  {
    "code": "US-TN-131",
    "name": "Obion"
  },
  {
    "code": "US-NJ-029",
    "name": "Ocean"
  },
  {
    "code": "US-MI-127",
    "name": "Oceana"
  },
  {
    "code": "US-TX-357",
    "name": "Ochiltree"
  },
  {
    "code": "US-SC-073",
    "name": "Oconee"
  },
  {
    "code": "US-GA-219",
    "name": "Oconee"
  },
  {
    "code": "US-WI-083",
    "name": "Oconto"
  },
  {
    "code": "US-MI-129",
    "name": "Ogemaw"
  },
  {
    "code": "US-SD-113",
    "name": "Oglala Lakota"
  },
  {
    "code": "US-IL-141",
    "name": "Ogle"
  },
  {
    "code": "US-GA-221",
    "name": "Oglethorpe"
  },
  {
    "code": "US-IN-115",
    "name": "Ohio"
  },
  {
    "code": "US-WV-069",
    "name": "Ohio"
  },
  {
    "code": "US-KY-183",
    "name": "Ohio"
  },
  {
    "code": "US-FL-091",
    "name": "Okaloosa"
  },
  {
    "code": "US-WA-047",
    "name": "Okanogan"
  },
  {
    "code": "US-FL-093",
    "name": "Okeechobee"
  },
  {
    "code": "US-OK-107",
    "name": "Okfuskee"
  },
  {
    "code": "US-OK-109",
    "name": "Oklahoma"
  },
  {
    "code": "US-OK-111",
    "name": "Okmulgee"
  },
  {
    "code": "US-MS-105",
    "name": "Oktibbeha"
  },
  {
    "code": "US-KY-185",
    "name": "Oldham"
  },
  {
    "code": "US-TX-359",
    "name": "Oldham"
  },
  {
    "code": "US-ND-065",
    "name": "Oliver"
  },
  {
    "code": "US-MN-109",
    "name": "Olmsted"
  },
  {
    "code": "US-ID-071",
    "name": "Oneida"
  },
  {
    "code": "US-NY-065",
    "name": "Oneida"
  },
  {
    "code": "US-WI-085",
    "name": "Oneida"
  },
  {
    "code": "US-NY-067",
    "name": "Onondaga"
  },
  {
    "code": "US-NC-133",
    "name": "Onslow"
  },
  {
    "code": "US-NY-069",
    "name": "Ontario"
  },
  {
    "code": "US-MI-131",
    "name": "Ontonagon"
  },
  {
    "code": "US-CA-059",
    "name": "Orange"
  },
  {
    "code": "US-IN-117",
    "name": "Orange"
  },
  {
    "code": "US-FL-095",
    "name": "Orange"
  },
  {
    "code": "US-VA-137",
    "name": "Orange"
  },
  {
    "code": "US-VT-017",
    "name": "Orange"
  },
  {
    "code": "US-NY-071",
    "name": "Orange"
  },
  {
    "code": "US-NC-135",
    "name": "Orange"
  },
  {
    "code": "US-TX-361",
    "name": "Orange"
  },
  {
    "code": "US-SC-075",
    "name": "Orangeburg"
  },
  {
    "code": "US-MO-149",
    "name": "Oregon"
  },
  {
    "code": "US-VT-019",
    "name": "Orleans"
  },
  {
    "code": "US-NY-073",
    "name": "Orleans"
  },
  {
    "code": "US-LA-071",
    "name": "Orleans"
  },
  {
    "code": "US-OK-113",
    "name": "Osage"
  },
  {
    "code": "US-KS-139",
    "name": "Osage"
  },
  {
    "code": "US-MO-151",
    "name": "Osage"
  },
  {
    "code": "US-KS-141",
    "name": "Osborne"
  },
  {
    "code": "US-FL-097",
    "name": "Osceola"
  },
  {
    "code": "US-IA-143",
    "name": "Osceola"
  },
  {
    "code": "US-MI-133",
    "name": "Osceola"
  },
  {
    "code": "US-MI-135",
    "name": "Oscoda"
  },
  {
    "code": "US-NY-075",
    "name": "Oswego"
  },
  {
    "code": "US-NM-035",
    "name": "Otero"
  },
  {
    "code": "US-CO-089",
    "name": "Otero"
  },
  {
    "code": "US-NE-131",
    "name": "Otoe"
  },
  {
    "code": "US-NY-077",
    "name": "Otsego"
  },
  {
    "code": "US-MI-137",
    "name": "Otsego"
  },
  {
    "code": "US-OK-115",
    "name": "Ottawa"
  },
  {
    "code": "US-KS-143",
    "name": "Ottawa"
  },
  {
    "code": "US-OH-123",
    "name": "Ottawa"
  },
  {
    "code": "US-MI-139",
    "name": "Ottawa"
  },
  {
    "code": "US-MN-111",
    "name": "Otter Tail"
  },
  {
    "code": "US-AR-103",
    "name": "Ouachita"
  },
  {
    "code": "US-LA-073",
    "name": "Ouachita"
  },
  {
    "code": "US-CO-091",
    "name": "Ouray"
  },
  {
    "code": "US-WI-087",
    "name": "Outagamie"
  },
  {
    "code": "US-TN-133",
    "name": "Overton"
  },
  {
    "code": "US-IN-119",
    "name": "Owen"
  },
  {
    "code": "US-KY-187",
    "name": "Owen"
  },
  {
    "code": "US-KY-189",
    "name": "Owsley"
  },
  {
    "code": "US-ID-073",
    "name": "Owyhee"
  },
  {
    "code": "US-ME-017",
    "name": "Oxford"
  },
  {
    "code": "US-MO-153",
    "name": "Ozark"
  },
  {
    "code": "US-WI-089",
    "name": "Ozaukee"
  },
  {
    "code": "US-WA-049",
    "name": "Pacific"
  },
  {
    "code": "US-VA-139",
    "name": "Page"
  },
  {
    "code": "US-IA-145",
    "name": "Page"
  },
  {
    "code": "US-FL-099",
    "name": "Palm Beach"
  },
  {
    "code": "US-IA-147",
    "name": "Palo Alto"
  },
  {
    "code": "US-TX-363",
    "name": "Palo Pinto"
  },
  {
    "code": "US-NC-137",
    "name": "Pamlico"
  },
  {
    "code": "US-MS-107",
    "name": "Panola"
  },
  {
    "code": "US-TX-365",
    "name": "Panola"
  },
  {
    "code": "US-MT-067",
    "name": "Park"
  },
  {
    "code": "US-WY-029",
    "name": "Park"
  },
  {
    "code": "US-CO-093",
    "name": "Park"
  },
  {
    "code": "US-IN-121",
    "name": "Parke"
  },
  {
    "code": "US-TX-367",
    "name": "Parker"
  },
  {
    "code": "US-TX-369",
    "name": "Parmer"
  },
  {
    "code": "US-FL-101",
    "name": "Pasco"
  },
  {
    "code": "US-NC-139",
    "name": "Pasquotank"
  },
  {
    "code": "US-NJ-031",
    "name": "Passaic"
  },
  {
    "code": "US-VA-141",
    "name": "Patrick"
  },
  {
    "code": "US-GA-223",
    "name": "Paulding"
  },
  {
    "code": "US-OH-125",
    "name": "Paulding"
  },
  {
    "code": "US-OK-117",
    "name": "Pawnee"
  },
  {
    "code": "US-KS-145",
    "name": "Pawnee"
  },
  {
    "code": "US-NE-133",
    "name": "Pawnee"
  },
  {
    "code": "US-ID-075",
    "name": "Payette"
  },
  {
    "code": "US-OK-119",
    "name": "Payne"
  },
  {
    "code": "US-GA-225",
    "name": "Peach"
  },
  {
    "code": "US-MS-109",
    "name": "Pearl River"
  },
  {
    "code": "US-TX-371",
    "name": "Pecos"
  },
  {
    "code": "US-ND-067",
    "name": "Pembina"
  },
  {
    "code": "US-MO-155",
    "name": "Pemiscot"
  },
  {
    "code": "US-WA-051",
    "name": "Pend Oreille"
  },
  {
    "code": "US-NC-141",
    "name": "Pender"
  },
  {
    "code": "US-WV-071",
    "name": "Pendleton"
  },
  {
    "code": "US-KY-191",
    "name": "Pendleton"
  },
  {
    "code": "US-MN-113",
    "name": "Pennington"
  },
  {
    "code": "US-SD-103",
    "name": "Pennington"
  },
  {
    "code": "US-ME-019",
    "name": "Penobscot"
  },
  {
    "code": "US-IL-143",
    "name": "Peoria"
  },
  {
    "code": "US-WI-091",
    "name": "Pepin"
  },
  {
    "code": "US-NE-135",
    "name": "Perkins"
  },
  {
    "code": "US-SD-105",
    "name": "Perkins"
  },
  {
    "code": "US-NC-143",
    "name": "Perquimans"
  },
  {
    "code": "US-AR-105",
    "name": "Perry"
  },
  {
    "code": "US-IN-123",
    "name": "Perry"
  },
  {
    "code": "US-TN-135",
    "name": "Perry"
  },
  {
    "code": "US-PA-099",
    "name": "Perry"
  },
  {
    "code": "US-MO-157",
    "name": "Perry"
  },
  {
    "code": "US-KY-193",
    "name": "Perry"
  },
  {
    "code": "US-IL-145",
    "name": "Perry"
  },
  {
    "code": "US-MS-111",
    "name": "Perry"
  },
  {
    "code": "US-AL-105",
    "name": "Perry"
  },
  {
    "code": "US-OH-127",
    "name": "Perry"
  },
  {
    "code": "US-NV-027",
    "name": "Pershing"
  },
  {
    "code": "US-NC-145",
    "name": "Person"
  },
  {
    "code": "US-VA-730",
    "name": "Petersburg"
  },
  {
    "code": "US-AK-195",
    "name": "Petersburg Borough"
  },
  {
    "code": "US-MT-069",
    "name": "Petroleum"
  },
  {
    "code": "US-MO-159",
    "name": "Pettis"
  },
  {
    "code": "US-NE-137",
    "name": "Phelps"
  },
  {
    "code": "US-MO-161",
    "name": "Phelps"
  },
  {
    "code": "US-PA-101",
    "name": "Philadelphia"
  },
  {
    "code": "US-MT-071",
    "name": "Phillips"
  },
  {
    "code": "US-KS-147",
    "name": "Phillips"
  },
  {
    "code": "US-AR-107",
    "name": "Phillips"
  },
  {
    "code": "US-CO-095",
    "name": "Phillips"
  },
  {
    "code": "US-IL-147",
    "name": "Piatt"
  },
  {
    "code": "US-OH-129",
    "name": "Pickaway"
  },
  {
    "code": "US-SC-077",
    "name": "Pickens"
  },
  {
    "code": "US-GA-227",
    "name": "Pickens"
  },
  {
    "code": "US-AL-107",
    "name": "Pickens"
  },
  {
    "code": "US-TN-137",
    "name": "Pickett"
  },
  {
    "code": "US-NE-139",
    "name": "Pierce"
  },
  {
    "code": "US-GA-229",
    "name": "Pierce"
  },
  {
    "code": "US-WA-053",
    "name": "Pierce"
  },
  {
    "code": "US-WI-093",
    "name": "Pierce"
  },
  {
    "code": "US-ND-069",
    "name": "Pierce"
  },
  {
    "code": "US-AR-109",
    "name": "Pike"
  },
  {
    "code": "US-IN-125",
    "name": "Pike"
  },
  {
    "code": "US-GA-231",
    "name": "Pike"
  },
  {
    "code": "US-PA-103",
    "name": "Pike"
  },
  {
    "code": "US-KY-195",
    "name": "Pike"
  },
  {
    "code": "US-IL-149",
    "name": "Pike"
  },
  {
    "code": "US-MO-163",
    "name": "Pike"
  },
  {
    "code": "US-MS-113",
    "name": "Pike"
  },
  {
    "code": "US-AL-109",
    "name": "Pike"
  },
  {
    "code": "US-OH-131",
    "name": "Pike"
  },
  {
    "code": "US-AZ-019",
    "name": "Pima"
  },
  {
    "code": "US-AZ-021",
    "name": "Pinal"
  },
  {
    "code": "US-MN-115",
    "name": "Pine"
  },
  {
    "code": "US-FL-103",
    "name": "Pinellas"
  },
  {
    "code": "US-MN-117",
    "name": "Pipestone"
  },
  {
    "code": "US-ME-021",
    "name": "Piscataquis"
  },
  {
    "code": "US-CO-097",
    "name": "Pitkin"
  },
  {
    "code": "US-NC-147",
    "name": "Pitt"
  },
  {
    "code": "US-OK-121",
    "name": "Pittsburg"
  },
  {
    "code": "US-VA-143",
    "name": "Pittsylvania"
  },
  {
    "code": "US-UT-031",
    "name": "Piute"
  },
  {
    "code": "US-CA-061",
    "name": "Placer"
  },
  {
    "code": "US-LA-075",
    "name": "Plaquemines"
  },
  {
    "code": "US-NE-141",
    "name": "Platte"
  },
  {
    "code": "US-WY-031",
    "name": "Platte"
  },
  {
    "code": "US-MO-165",
    "name": "Platte"
  },
  {
    "code": "US-WV-073",
    "name": "Pleasants"
  },
  {
    "code": "US-CA-063",
    "name": "Plumas"
  },
  {
    "code": "US-IA-149",
    "name": "Plymouth"
  },
  {
    "code": "US-MA-023",
    "name": "Plymouth"
  },
  {
    "code": "US-WV-075",
    "name": "Pocahontas"
  },
  {
    "code": "US-IA-151",
    "name": "Pocahontas"
  },
  {
    "code": "US-AR-111",
    "name": "Poinsett"
  },
  {
    "code": "US-LA-077",
    "name": "Pointe Coupee"
  },
  {
    "code": "US-OR-053",
    "name": "Polk"
  },
  {
    "code": "US-AR-113",
    "name": "Polk"
  },
  {
    "code": "US-NE-143",
    "name": "Polk"
  },
  {
    "code": "US-GA-233",
    "name": "Polk"
  },
  {
    "code": "US-MN-119",
    "name": "Polk"
  },
  {
    "code": "US-TN-139",
    "name": "Polk"
  },
  {
    "code": "US-FL-105",
    "name": "Polk"
  },
  {
    "code": "US-NC-149",
    "name": "Polk"
  },
  {
    "code": "US-MO-167",
    "name": "Polk"
  },
  {
    "code": "US-IA-153",
    "name": "Polk"
  },
  {
    "code": "US-TX-373",
    "name": "Polk"
  },
  {
    "code": "US-WI-095",
    "name": "Polk"
  },
  {
    "code": "US-MT-073",
    "name": "Pondera"
  },
  {
    "code": "US-OK-123",
    "name": "Pontotoc"
  },
  {
    "code": "US-MS-115",
    "name": "Pontotoc"
  },
  {
    "code": "US-AR-115",
    "name": "Pope"
  },
  {
    "code": "US-MN-121",
    "name": "Pope"
  },
  {
    "code": "US-IL-151",
    "name": "Pope"
  },
  {
    "code": "US-VA-735",
    "name": "Poquoson"
  },
  {
    "code": "US-OH-133",
    "name": "Portage"
  },
  {
    "code": "US-WI-097",
    "name": "Portage"
  },
  {
    "code": "US-IN-127",
    "name": "Porter"
  },
  {
    "code": "US-VA-740",
    "name": "Portsmouth"
  },
  {
    "code": "US-IN-129",
    "name": "Posey"
  },
  {
    "code": "US-OK-125",
    "name": "Pottawatomie"
  },
  {
    "code": "US-KS-149",
    "name": "Pottawatomie"
  },
  {
    "code": "US-IA-155",
    "name": "Pottawattamie"
  },
  {
    "code": "US-PA-105",
    "name": "Potter"
  },
  {
    "code": "US-SD-107",
    "name": "Potter"
  },
  {
    "code": "US-TX-375",
    "name": "Potter"
  },
  {
    "code": "US-MT-075",
    "name": "Powder River"
  },
  {
    "code": "US-MT-077",
    "name": "Powell"
  },
  {
    "code": "US-KY-197",
    "name": "Powell"
  },
  {
    "code": "US-ID-077",
    "name": "Power"
  },
  {
    "code": "US-IA-157",
    "name": "Poweshiek"
  },
  {
    "code": "US-VA-145",
    "name": "Powhatan"
  },
  {
    "code": "US-MT-079",
    "name": "Prairie"
  },
  {
    "code": "US-AR-117",
    "name": "Prairie"
  },
  {
    "code": "US-KS-151",
    "name": "Pratt"
  },
  {
    "code": "US-OH-135",
    "name": "Preble"
  },
  {
    "code": "US-MS-117",
    "name": "Prentiss"
  },
  {
    "code": "US-TX-377",
    "name": "Presidio"
  },
  {
    "code": "US-MI-141",
    "name": "Presque Isle"
  },
  {
    "code": "US-WV-077",
    "name": "Preston"
  },
  {
    "code": "US-WI-099",
    "name": "Price"
  },
  {
    "code": "US-VA-147",
    "name": "Prince Edward"
  },
  {
    "code": "US-VA-149",
    "name": "Prince George"
  },
  {
    "code": "US-MD-033",
    "name": "Prince George's"
  },
  {
    "code": "US-AK-198",
    "name": "Prince of Wales-Hyder Census Area"
  },
  {
    "code": "US-VA-153",
    "name": "Prince William"
  },
  {
    "code": "US-RI-007",
    "name": "Providence"
  },
  {
    "code": "US-CO-099",
    "name": "Prowers"
  },
  {
    "code": "US-CO-101",
    "name": "Pueblo"
  },
  {
    "code": "US-AR-119",
    "name": "Pulaski"
  },
  {
    "code": "US-IN-131",
    "name": "Pulaski"
  },
  {
    "code": "US-GA-235",
    "name": "Pulaski"
  },
  {
    "code": "US-VA-155",
    "name": "Pulaski"
  },
  {
    "code": "US-KY-199",
    "name": "Pulaski"
  },
  {
    "code": "US-IL-153",
    "name": "Pulaski"
  },
  {
    "code": "US-MO-169",
    "name": "Pulaski"
  },
  {
    "code": "US-OK-127",
    "name": "Pushmataha"
  },
  {
    "code": "US-IN-133",
    "name": "Putnam"
  },
  {
    "code": "US-GA-237",
    "name": "Putnam"
  },
  {
    "code": "US-TN-141",
    "name": "Putnam"
  },
  {
    "code": "US-FL-107",
    "name": "Putnam"
  },
  {
    "code": "US-WV-079",
    "name": "Putnam"
  },
  {
    "code": "US-NY-079",
    "name": "Putnam"
  },
  {
    "code": "US-IL-155",
    "name": "Putnam"
  },
  {
    "code": "US-MO-171",
    "name": "Putnam"
  },
  {
    "code": "US-OH-137",
    "name": "Putnam"
  },
  {
    "code": "US-NM-037",
    "name": "Quay"
  },
  {
    "code": "US-MD-035",
    "name": "Queen Anne's"
  },
  {
    "code": "US-NY-081",
    "name": "Queens"
  },
  {
    "code": "US-GA-239",
    "name": "Quitman"
  },
  {
    "code": "US-MS-119",
    "name": "Quitman"
  },
  {
    "code": "US-GA-241",
    "name": "Rabun"
  },
  {
    "code": "US-WI-101",
    "name": "Racine"
  },
  {
    "code": "US-VA-750",
    "name": "Radford"
  },
  {
    "code": "US-TX-379",
    "name": "Rains"
  },
  {
    "code": "US-WV-081",
    "name": "Raleigh"
  },
  {
    "code": "US-MO-173",
    "name": "Ralls"
  },
  {
    "code": "US-MN-123",
    "name": "Ramsey"
  },
  {
    "code": "US-ND-071",
    "name": "Ramsey"
  },
  {
    "code": "US-TX-381",
    "name": "Randall"
  },
  {
    "code": "US-AR-121",
    "name": "Randolph"
  },
  {
    "code": "US-IN-135",
    "name": "Randolph"
  },
  {
    "code": "US-GA-243",
    "name": "Randolph"
  },
  {
    "code": "US-WV-083",
    "name": "Randolph"
  },
  {
    "code": "US-NC-151",
    "name": "Randolph"
  },
  {
    "code": "US-IL-157",
    "name": "Randolph"
  },
  {
    "code": "US-MO-175",
    "name": "Randolph"
  },
  {
    "code": "US-AL-111",
    "name": "Randolph"
  },
  {
    "code": "US-MS-121",
    "name": "Rankin"
  },
  {
    "code": "US-ND-073",
    "name": "Ransom"
  },
  {
    "code": "US-LA-079",
    "name": "Rapides"
  },
  {
    "code": "US-VA-157",
    "name": "Rappahannock"
  },
  {
    "code": "US-MT-081",
    "name": "Ravalli"
  },
  {
    "code": "US-KS-153",
    "name": "Rawlins"
  },
  {
    "code": "US-MO-177",
    "name": "Ray"
  },
  {
    "code": "US-TX-383",
    "name": "Reagan"
  },
  {
    "code": "US-TX-385",
    "name": "Real"
  },
  {
    "code": "US-MN-125",
    "name": "Red Lake"
  },
  {
    "code": "US-LA-081",
    "name": "Red River"
  },
  {
    "code": "US-TX-387",
    "name": "Red River"
  },
  {
    "code": "US-NE-145",
    "name": "Red Willow"
  },
  {
    "code": "US-MN-127",
    "name": "Redwood"
  },
  {
    "code": "US-TX-389",
    "name": "Reeves"
  },
  {
    "code": "US-TX-391",
    "name": "Refugio"
  },
  {
    "code": "US-KS-155",
    "name": "Reno"
  },
  {
    "code": "US-NY-083",
    "name": "Rensselaer"
  },
  {
    "code": "US-MN-129",
    "name": "Renville"
  },
  {
    "code": "US-ND-075",
    "name": "Renville"
  },
  {
    "code": "US-KS-157",
    "name": "Republic"
  },
  {
    "code": "US-MO-179",
    "name": "Reynolds"
  },
  {
    "code": "US-TN-143",
    "name": "Rhea"
  },
  {
    "code": "US-KS-159",
    "name": "Rice"
  },
  {
    "code": "US-MN-131",
    "name": "Rice"
  },
  {
    "code": "US-UT-033",
    "name": "Rich"
  },
  {
    "code": "US-NE-147",
    "name": "Richardson"
  },
  {
    "code": "US-SC-079",
    "name": "Richland"
  },
  {
    "code": "US-LA-083",
    "name": "Richland"
  },
  {
    "code": "US-IL-159",
    "name": "Richland"
  },
  {
    "code": "US-OH-139",
    "name": "Richland"
  },
  {
    "code": "US-WI-103",
    "name": "Richland"
  },
  {
    "code": "US-MT-083",
    "name": "Richland"
  },
  {
    "code": "US-ND-077",
    "name": "Richland"
  },
  {
    "code": "US-GA-245",
    "name": "Richmond"
  },
  {
    "code": "US-VA-159",
    "name": "Richmond"
  },
  {
    "code": "US-NY-085",
    "name": "Richmond"
  },
  {
    "code": "US-NC-153",
    "name": "Richmond"
  },
  {
    "code": "US-VA-760",
    "name": "Richmond City"
  },
  {
    "code": "US-KS-161",
    "name": "Riley"
  },
  {
    "code": "US-IA-159",
    "name": "Ringgold"
  },
  {
    "code": "US-NM-039",
    "name": "Rio Arriba"
  },
  {
    "code": "US-CO-103",
    "name": "Rio Blanco"
  },
  {
    "code": "US-CO-105",
    "name": "Rio Grande"
  },
  {
    "code": "US-IN-137",
    "name": "Ripley"
  },
  {
    "code": "US-MO-181",
    "name": "Ripley"
  },
  {
    "code": "US-WV-085",
    "name": "Ritchie"
  },
  {
    "code": "US-CA-065",
    "name": "Riverside"
  },
  {
    "code": "US-TN-145",
    "name": "Roane"
  },
  {
    "code": "US-WV-087",
    "name": "Roane"
  },
  {
    "code": "US-VA-161",
    "name": "Roanoke"
  },
  {
    "code": "US-VA-770",
    "name": "Roanoke City"
  },
  {
    "code": "US-SD-109",
    "name": "Roberts"
  },
  {
    "code": "US-TX-393",
    "name": "Roberts"
  },
  {
    "code": "US-TN-147",
    "name": "Robertson"
  },
  {
    "code": "US-KY-201",
    "name": "Robertson"
  },
  {
    "code": "US-TX-395",
    "name": "Robertson"
  },
  {
    "code": "US-NC-155",
    "name": "Robeson"
  },
  {
    "code": "US-NE-149",
    "name": "Rock"
  },
  {
    "code": "US-MN-133",
    "name": "Rock"
  },
  {
    "code": "US-WI-105",
    "name": "Rock"
  },
  {
    "code": "US-IL-161",
    "name": "Rock Island"
  },
  {
    "code": "US-VA-163",
    "name": "Rockbridge"
  },
  {
    "code": "US-KY-203",
    "name": "Rockcastle"
  },
  {
    "code": "US-GA-247",
    "name": "Rockdale"
  },
  {
    "code": "US-NH-015",
    "name": "Rockingham"
  },
  {
    "code": "US-VA-165",
    "name": "Rockingham"
  },
  {
    "code": "US-NC-157",
    "name": "Rockingham"
  },
  {
    "code": "US-NY-087",
    "name": "Rockland"
  },
  {
    "code": "US-TX-397",
    "name": "Rockwall"
  },
  {
    "code": "US-OK-129",
    "name": "Roger Mills"
  },
  {
    "code": "US-OK-131",
    "name": "Rogers"
  },
  {
    "code": "US-ND-079",
    "name": "Rolette"
  },
  {
    "code": "US-KS-163",
    "name": "Rooks"
  },
  {
    "code": "US-NM-041",
    "name": "Roosevelt"
  },
  {
    "code": "US-MT-085",
    "name": "Roosevelt"
  },
  {
    "code": "US-MI-143",
    "name": "Roscommon"
  },
  {
    "code": "US-MN-135",
    "name": "Roseau"
  },
  {
    "code": "US-MT-087",
    "name": "Rosebud"
  },
  {
    "code": "US-OH-141",
    "name": "Ross"
  },
  {
    "code": "US-CO-107",
    "name": "Routt"
  },
  {
    "code": "US-KY-205",
    "name": "Rowan"
  },
  {
    "code": "US-NC-159",
    "name": "Rowan"
  },
  {
    "code": "US-TX-399",
    "name": "Runnels"
  },
  {
    "code": "US-KS-165",
    "name": "Rush"
  },
  {
    "code": "US-IN-139",
    "name": "Rush"
  },
  {
    "code": "US-TX-401",
    "name": "Rusk"
  },
  {
    "code": "US-WI-107",
    "name": "Rusk"
  },
  {
    "code": "US-KS-167",
    "name": "Russell"
  },
  {
    "code": "US-VA-167",
    "name": "Russell"
  },
  {
    "code": "US-KY-207",
    "name": "Russell"
  },
  {
    "code": "US-AL-113",
    "name": "Russell"
  },
  {
    "code": "US-TN-149",
    "name": "Rutherford"
  },
  {
    "code": "US-NC-161",
    "name": "Rutherford"
  },
  {
    "code": "US-VT-021",
    "name": "Rutland"
  },
  {
    "code": "US-TX-403",
    "name": "Sabine"
  },
  {
    "code": "US-LA-085",
    "name": "Sabine"
  },
  {
    "code": "US-IA-161",
    "name": "Sac"
  },
  {
    "code": "US-CA-067",
    "name": "Sacramento"
  },
  {
    "code": "US-ME-023",
    "name": "Sagadahoc"
  },
  {
    "code": "US-MI-145",
    "name": "Saginaw"
  },
  {
    "code": "US-CO-109",
    "name": "Saguache"
  },
  {
    "code": "US-VA-775",
    "name": "Salem"
  },
  {
    "code": "US-NJ-033",
    "name": "Salem"
  },
  {
    "code": "US-KS-169",
    "name": "Saline"
  },
  {
    "code": "US-AR-125",
    "name": "Saline"
  },
  {
    "code": "US-NE-151",
    "name": "Saline"
  },
  {
    "code": "US-IL-165",
    "name": "Saline"
  },
  {
    "code": "US-MO-195",
    "name": "Saline"
  },
  {
    "code": "US-UT-035",
    "name": "Salt Lake"
  },
  {
    "code": "US-SC-081",
    "name": "Saluda"
  },
  {
    "code": "US-NC-163",
    "name": "Sampson"
  },
  {
    "code": "US-TX-405",
    "name": "San Augustine"
  },
  {
    "code": "US-CA-069",
    "name": "San Benito"
  },
  {
    "code": "US-CA-071",
    "name": "San Bernardino"
  },
  {
    "code": "US-CA-073",
    "name": "San Diego"
  },
  {
    "code": "US-CA-075",
    "name": "San Francisco"
  },
  {
    "code": "US-TX-407",
    "name": "San Jacinto"
  },
  {
    "code": "US-CA-077",
    "name": "San Joaquin"
  },
  {
    "code": "US-NM-045",
    "name": "San Juan"
  },
  {
    "code": "US-UT-037",
    "name": "San Juan"
  },
  {
    "code": "US-WA-055",
    "name": "San Juan"
  },
  {
    "code": "US-CO-111",
    "name": "San Juan"
  },
  {
    "code": "US-CA-079",
    "name": "San Luis Obispo"
  },
  {
    "code": "US-CA-081",
    "name": "San Mateo"
  },
  {
    "code": "US-NM-047",
    "name": "San Miguel"
  },
  {
    "code": "US-CO-113",
    "name": "San Miguel"
  },
  {
    "code": "US-TX-409",
    "name": "San Patricio"
  },
  {
    "code": "US-TX-411",
    "name": "San Saba"
  },
  {
    "code": "US-SD-111",
    "name": "Sanborn"
  },
  {
    "code": "US-MT-089",
    "name": "Sanders"
  },
  {
    "code": "US-NM-043",
    "name": "Sandoval"
  },
  {
    "code": "US-OH-143",
    "name": "Sandusky"
  },
  {
    "code": "US-IL-167",
    "name": "Sangamon"
  },
  {
    "code": "US-MI-151",
    "name": "Sanilac"
  },
  {
    "code": "US-UT-039",
    "name": "Sanpete"
  },
  {
    "code": "US-CA-083",
    "name": "Santa Barbara"
  },
  {
    "code": "US-CA-085",
    "name": "Santa Clara"
  },
  {
    "code": "US-CA-087",
    "name": "Santa Cruz"
  },
  {
    "code": "US-AZ-023",
    "name": "Santa Cruz"
  },
  {
    "code": "US-NM-049",
    "name": "Santa Fe"
  },
  {
    "code": "US-FL-113",
    "name": "Santa Rosa"
  },
  {
    "code": "US-FL-115",
    "name": "Sarasota"
  },
  {
    "code": "US-NY-091",
    "name": "Saratoga"
  },
  {
    "code": "US-ND-081",
    "name": "Sargent"
  },
  {
    "code": "US-NE-153",
    "name": "Sarpy"
  },
  {
    "code": "US-WI-111",
    "name": "Sauk"
  },
  {
    "code": "US-NE-155",
    "name": "Saunders"
  },
  {
    "code": "US-WI-113",
    "name": "Sawyer"
  },
  {
    "code": "US-NY-093",
    "name": "Schenectady"
  },
  {
    "code": "US-TX-413",
    "name": "Schleicher"
  },
  {
    "code": "US-GA-249",
    "name": "Schley"
  },
  {
    "code": "US-NY-095",
    "name": "Schoharie"
  },
  {
    "code": "US-MI-153",
    "name": "Schoolcraft"
  },
  {
    "code": "US-NY-097",
    "name": "Schuyler"
  },
  {
    "code": "US-IL-169",
    "name": "Schuyler"
  },
  {
    "code": "US-MO-197",
    "name": "Schuyler"
  },
  {
    "code": "US-PA-107",
    "name": "Schuylkill"
  },
  {
    "code": "US-OH-145",
    "name": "Scioto"
  },
  {
    "code": "US-NC-165",
    "name": "Scotland"
  },
  {
    "code": "US-MO-199",
    "name": "Scotland"
  },
  {
    "code": "US-KS-171",
    "name": "Scott"
  },
  {
    "code": "US-AR-127",
    "name": "Scott"
  },
  {
    "code": "US-IN-143",
    "name": "Scott"
  },
  {
    "code": "US-VA-169",
    "name": "Scott"
  },
  {
    "code": "US-TN-151",
    "name": "Scott"
  },
  {
    "code": "US-MN-139",
    "name": "Scott"
  },
  {
    "code": "US-MO-201",
    "name": "Scott"
  },
  {
    "code": "US-KY-209",
    "name": "Scott"
  },
  {
    "code": "US-IL-171",
    "name": "Scott"
  },
  {
    "code": "US-MS-123",
    "name": "Scott"
  },
  {
    "code": "US-IA-163",
    "name": "Scott"
  },
  {
    "code": "US-NE-157",
    "name": "Scotts Bluff"
  },
  {
    "code": "US-GA-251",
    "name": "Screven"
  },
  {
    "code": "US-TX-415",
    "name": "Scurry"
  },
  {
    "code": "US-AR-129",
    "name": "Searcy"
  },
  {
    "code": "US-AR-131",
    "name": "Sebastian"
  },
  {
    "code": "US-KS-173",
    "name": "Sedgwick"
  },
  {
    "code": "US-CO-115",
    "name": "Sedgwick"
  },
  {
    "code": "US-OK-133",
    "name": "Seminole"
  },
  {
    "code": "US-GA-253",
    "name": "Seminole"
  },
  {
    "code": "US-FL-117",
    "name": "Seminole"
  },
  {
    "code": "US-NY-099",
    "name": "Seneca"
  },
  {
    "code": "US-OH-147",
    "name": "Seneca"
  },
  {
    "code": "US-TN-153",
    "name": "Sequatchie"
  },
  {
    "code": "US-OK-135",
    "name": "Sequoyah"
  },
  {
    "code": "US-AR-133",
    "name": "Sevier"
  },
  {
    "code": "US-TN-155",
    "name": "Sevier"
  },
  {
    "code": "US-UT-041",
    "name": "Sevier"
  },
  {
    "code": "US-KS-175",
    "name": "Seward"
  },
  {
    "code": "US-NE-159",
    "name": "Seward"
  },
  {
    "code": "US-TX-417",
    "name": "Shackelford"
  },
  {
    "code": "US-MO-203",
    "name": "Shannon"
  },
  {
    "code": "US-MS-125",
    "name": "Sharkey"
  },
  {
    "code": "US-AR-135",
    "name": "Sharp"
  },
  {
    "code": "US-CA-089",
    "name": "Shasta"
  },
  {
    "code": "US-WI-115",
    "name": "Shawano"
  },
  {
    "code": "US-KS-177",
    "name": "Shawnee"
  },
  {
    "code": "US-WI-117",
    "name": "Sheboygan"
  },
  {
    "code": "US-IN-145",
    "name": "Shelby"
  },
  {
    "code": "US-TN-157",
    "name": "Shelby"
  },
  {
    "code": "US-MO-205",
    "name": "Shelby"
  },
  {
    "code": "US-KY-211",
    "name": "Shelby"
  },
  {
    "code": "US-TX-419",
    "name": "Shelby"
  },
  {
    "code": "US-IL-173",
    "name": "Shelby"
  },
  {
    "code": "US-AL-117",
    "name": "Shelby"
  },
  {
    "code": "US-IA-165",
    "name": "Shelby"
  },
  {
    "code": "US-OH-149",
    "name": "Shelby"
  },
  {
    "code": "US-VA-171",
    "name": "Shenandoah"
  },
  {
    "code": "US-MN-141",
    "name": "Sherburne"
  },
  {
    "code": "US-KS-179",
    "name": "Sheridan"
  },
  {
    "code": "US-NE-161",
    "name": "Sheridan"
  },
  {
    "code": "US-WY-033",
    "name": "Sheridan"
  },
  {
    "code": "US-MT-091",
    "name": "Sheridan"
  },
  {
    "code": "US-ND-083",
    "name": "Sheridan"
  },
  {
    "code": "US-OR-055",
    "name": "Sherman"
  },
  {
    "code": "US-KS-181",
    "name": "Sherman"
  },
  {
    "code": "US-NE-163",
    "name": "Sherman"
  },
  {
    "code": "US-TX-421",
    "name": "Sherman"
  },
  {
    "code": "US-MI-155",
    "name": "Shiawassee"
  },
  {
    "code": "US-ID-079",
    "name": "Shoshone"
  },
  {
    "code": "US-MN-143",
    "name": "Sibley"
  },
  {
    "code": "US-CA-091",
    "name": "Sierra"
  },
  {
    "code": "US-NM-051",
    "name": "Sierra"
  },
  {
    "code": "US-MT-093",
    "name": "Silver Bow"
  },
  {
    "code": "US-KY-213",
    "name": "Simpson"
  },
  {
    "code": "US-MS-127",
    "name": "Simpson"
  },
  {
    "code": "US-NE-165",
    "name": "Sioux"
  },
  {
    "code": "US-IA-167",
    "name": "Sioux"
  },
  {
    "code": "US-ND-085",
    "name": "Sioux"
  },
  {
    "code": "US-CA-093",
    "name": "Siskiyou"
  },
  {
    "code": "US-AK-220",
    "name": "Sitka City and Borough"
  },
  {
    "code": "US-WA-057",
    "name": "Skagit"
  },
  {
    "code": "US-AK-230",
    "name": "Skagway Municipality"
  },
  {
    "code": "US-WA-059",
    "name": "Skamania"
  },
  {
    "code": "US-ND-087",
    "name": "Slope"
  },
  {
    "code": "US-KS-183",
    "name": "Smith"
  },
  {
    "code": "US-TN-159",
    "name": "Smith"
  },
  {
    "code": "US-TX-423",
    "name": "Smith"
  },
  {
    "code": "US-MS-129",
    "name": "Smith"
  },
  {
    "code": "US-VA-173",
    "name": "Smyth"
  },
  {
    "code": "US-WA-061",
    "name": "Snohomish"
  },
  {
    "code": "US-PA-109",
    "name": "Snyder"
  },
  {
    "code": "US-NM-053",
    "name": "Socorro"
  },
  {
    "code": "US-CA-095",
    "name": "Solano"
  },
  {
    "code": "US-ME-025",
    "name": "Somerset"
  },
  {
    "code": "US-PA-111",
    "name": "Somerset"
  },
  {
    "code": "US-NJ-035",
    "name": "Somerset"
  },
  {
    "code": "US-MD-039",
    "name": "Somerset"
  },
  {
    "code": "US-TX-425",
    "name": "Somervell"
  },
  {
    "code": "US-CA-097",
    "name": "Sonoma"
  },
  {
    "code": "US-VA-175",
    "name": "Southampton"
  },
  {
    "code": "US-AK-240",
    "name": "Southeast Fairbanks Census Area"
  },
  {
    "code": "US-GA-255",
    "name": "Spalding"
  },
  {
    "code": "US-SC-083",
    "name": "Spartanburg"
  },
  {
    "code": "US-IN-147",
    "name": "Spencer"
  },
  {
    "code": "US-KY-215",
    "name": "Spencer"
  },
  {
    "code": "US-SD-115",
    "name": "Spink"
  },
  {
    "code": "US-WA-063",
    "name": "Spokane"
  },
  {
    "code": "US-VA-177",
    "name": "Spotsylvania"
  },
  {
    "code": "US-LA-087",
    "name": "St. Bernard"
  },
  {
    "code": "US-LA-089",
    "name": "St. Charles"
  },
  {
    "code": "US-MO-183",
    "name": "St. Charles"
  },
  {
    "code": "US-IL-163",
    "name": "St. Clair"
  },
  {
    "code": "US-MO-185",
    "name": "St. Clair"
  },
  {
    "code": "US-AL-115",
    "name": "St. Clair"
  },
  {
    "code": "US-MI-147",
    "name": "St. Clair"
  },
  {
    "code": "US-WI-109",
    "name": "St. Croix"
  },
  {
    "code": "US-AR-123",
    "name": "St. Francis"
  },
  {
    "code": "US-MO-187",
    "name": "St. Francois"
  },
  {
    "code": "US-LA-091",
    "name": "St. Helena"
  },
  {
    "code": "US-LA-093",
    "name": "St. James"
  },
  {
    "code": "US-LA-095",
    "name": "St. John the Baptist"
  },
  {
    "code": "US-FL-109",
    "name": "St. Johns"
  },
  {
    "code": "US-IN-141",
    "name": "St. Joseph"
  },
  {
    "code": "US-MI-149",
    "name": "St. Joseph"
  },
  {
    "code": "US-LA-097",
    "name": "St. Landry"
  },
  {
    "code": "US-NY-089",
    "name": "St. Lawrence"
  },
  {
    "code": "US-MN-137",
    "name": "St. Louis"
  },
  {
    "code": "US-MO-189",
    "name": "St. Louis"
  },
  {
    "code": "US-MO-510",
    "name": "St. Louis City"
  },
  {
    "code": "US-FL-111",
    "name": "St. Lucie"
  },
  {
    "code": "US-LA-099",
    "name": "St. Martin"
  },
  {
    "code": "US-LA-101",
    "name": "St. Mary"
  },
  {
    "code": "US-MD-037",
    "name": "St. Mary's"
  },
  {
    "code": "US-LA-103",
    "name": "St. Tammany"
  },
  {
    "code": "US-KS-185",
    "name": "Stafford"
  },
  {
    "code": "US-VA-179",
    "name": "Stafford"
  },
  {
    "code": "US-CA-099",
    "name": "Stanislaus"
  },
  {
    "code": "US-SD-117",
    "name": "Stanley"
  },
  {
    "code": "US-NC-167",
    "name": "Stanly"
  },
  {
    "code": "US-KS-187",
    "name": "Stanton"
  },
  {
    "code": "US-NE-167",
    "name": "Stanton"
  },
  {
    "code": "US-IL-175",
    "name": "Stark"
  },
  {
    "code": "US-OH-151",
    "name": "Stark"
  },
  {
    "code": "US-ND-089",
    "name": "Stark"
  },
  {
    "code": "US-IN-149",
    "name": "Starke"
  },
  {
    "code": "US-TX-427",
    "name": "Starr"
  },
  {
    "code": "US-VA-790",
    "name": "Staunton"
  },
  {
    "code": "US-MO-186",
    "name": "Ste. Genevieve"
  },
  {
    "code": "US-MN-145",
    "name": "Stearns"
  },
  {
    "code": "US-MN-147",
    "name": "Steele"
  },
  {
    "code": "US-ND-091",
    "name": "Steele"
  },
  {
    "code": "US-OK-137",
    "name": "Stephens"
  },
  {
    "code": "US-GA-257",
    "name": "Stephens"
  },
  {
    "code": "US-TX-429",
    "name": "Stephens"
  },
  {
    "code": "US-IL-177",
    "name": "Stephenson"
  },
  {
    "code": "US-TX-431",
    "name": "Sterling"
  },
  {
    "code": "US-IN-151",
    "name": "Steuben"
  },
  {
    "code": "US-NY-101",
    "name": "Steuben"
  },
  {
    "code": "US-KS-189",
    "name": "Stevens"
  },
  {
    "code": "US-MN-149",
    "name": "Stevens"
  },
  {
    "code": "US-WA-065",
    "name": "Stevens"
  },
  {
    "code": "US-GA-259",
    "name": "Stewart"
  },
  {
    "code": "US-TN-161",
    "name": "Stewart"
  },
  {
    "code": "US-MT-095",
    "name": "Stillwater"
  },
  {
    "code": "US-MO-207",
    "name": "Stoddard"
  },
  {
    "code": "US-NC-169",
    "name": "Stokes"
  },
  {
    "code": "US-AR-137",
    "name": "Stone"
  },
  {
    "code": "US-MO-209",
    "name": "Stone"
  },
  {
    "code": "US-MS-131",
    "name": "Stone"
  },
  {
    "code": "US-TX-433",
    "name": "Stonewall"
  },
  {
    "code": "US-NV-029",
    "name": "Storey"
  },
  {
    "code": "US-IA-169",
    "name": "Story"
  },
  {
    "code": "US-NH-017",
    "name": "Strafford"
  },
  {
    "code": "US-ND-093",
    "name": "Stutsman"
  },
  {
    "code": "US-WY-035",
    "name": "Sublette"
  },
  {
    "code": "US-NY-103",
    "name": "Suffolk"
  },
  {
    "code": "US-VA-800",
    "name": "Suffolk"
  },
  {
    "code": "US-MA-025",
    "name": "Suffolk"
  },
  {
    "code": "US-NH-019",
    "name": "Sullivan"
  },
  {
    "code": "US-IN-153",
    "name": "Sullivan"
  },
  {
    "code": "US-TN-163",
    "name": "Sullivan"
  },
  {
    "code": "US-MO-211",
    "name": "Sullivan"
  },
  {
    "code": "US-NY-105",
    "name": "Sullivan"
  },
  {
    "code": "US-PA-113",
    "name": "Sullivan"
  },
  {
    "code": "US-SD-119",
    "name": "Sully"
  },
  {
    "code": "US-WV-089",
    "name": "Summers"
  },
  {
    "code": "US-UT-043",
    "name": "Summit"
  },
  {
    "code": "US-OH-153",
    "name": "Summit"
  },
  {
    "code": "US-CO-117",
    "name": "Summit"
  },
  {
    "code": "US-KS-191",
    "name": "Sumner"
  },
  {
    "code": "US-TN-165",
    "name": "Sumner"
  },
  {
    "code": "US-SC-085",
    "name": "Sumter"
  },
  {
    "code": "US-GA-261",
    "name": "Sumter"
  },
  {
    "code": "US-FL-119",
    "name": "Sumter"
  },
  {
    "code": "US-AL-119",
    "name": "Sumter"
  },
  {
    "code": "US-MS-133",
    "name": "Sunflower"
  },
  {
    "code": "US-VA-181",
    "name": "Surry"
  },
  {
    "code": "US-NC-171",
    "name": "Surry"
  },
  {
    "code": "US-PA-115",
    "name": "Susquehanna"
  },
  {
    "code": "US-VA-183",
    "name": "Sussex"
  },
  {
    "code": "US-DE-005",
    "name": "Sussex"
  },
  {
    "code": "US-NJ-037",
    "name": "Sussex"
  },
  {
    "code": "US-CA-101",
    "name": "Sutter"
  },
  {
    "code": "US-TX-435",
    "name": "Sutton"
  },
  {
    "code": "US-FL-121",
    "name": "Suwannee"
  },
  {
    "code": "US-NC-173",
    "name": "Swain"
  },
  {
    "code": "US-MT-097",
    "name": "Sweet Grass"
  },
  {
    "code": "US-WY-037",
    "name": "Sweetwater"
  },
  {
    "code": "US-MN-151",
    "name": "Swift"
  },
  {
    "code": "US-TX-437",
    "name": "Swisher"
  },
  {
    "code": "US-IN-155",
    "name": "Switzerland"
  },
  {
    "code": "US-GA-263",
    "name": "Talbot"
  },
  {
    "code": "US-MD-041",
    "name": "Talbot"
  },
  {
    "code": "US-GA-265",
    "name": "Taliaferro"
  },
  {
    "code": "US-AL-121",
    "name": "Talladega"
  },
  {
    "code": "US-MS-135",
    "name": "Tallahatchie"
  },
  {
    "code": "US-AL-123",
    "name": "Tallapoosa"
  },
  {
    "code": "US-IA-171",
    "name": "Tama"
  },
  {
    "code": "US-MO-213",
    "name": "Taney"
  },
  {
    "code": "US-LA-105",
    "name": "Tangipahoa"
  },
  {
    "code": "US-NM-055",
    "name": "Taos"
  },
  {
    "code": "US-TX-439",
    "name": "Tarrant"
  },
  {
    "code": "US-MS-137",
    "name": "Tate"
  },
  {
    "code": "US-GA-267",
    "name": "Tattnall"
  },
  {
    "code": "US-GA-269",
    "name": "Taylor"
  },
  {
    "code": "US-FL-123",
    "name": "Taylor"
  },
  {
    "code": "US-WV-091",
    "name": "Taylor"
  },
  {
    "code": "US-KY-217",
    "name": "Taylor"
  },
  {
    "code": "US-TX-441",
    "name": "Taylor"
  },
  {
    "code": "US-IA-173",
    "name": "Taylor"
  },
  {
    "code": "US-WI-119",
    "name": "Taylor"
  },
  {
    "code": "US-VA-185",
    "name": "Tazewell"
  },
  {
    "code": "US-IL-179",
    "name": "Tazewell"
  },
  {
    "code": "US-CA-103",
    "name": "Tehama"
  },
  {
    "code": "US-GA-271",
    "name": "Telfair"
  },
  {
    "code": "US-CO-119",
    "name": "Teller"
  },
  {
    "code": "US-LA-107",
    "name": "Tensas"
  },
  {
    "code": "US-LA-109",
    "name": "Terrebonne"
  },
  {
    "code": "US-GA-273",
    "name": "Terrell"
  },
  {
    "code": "US-TX-443",
    "name": "Terrell"
  },
  {
    "code": "US-TX-445",
    "name": "Terry"
  },
  {
    "code": "US-WY-039",
    "name": "Teton"
  },
  {
    "code": "US-ID-081",
    "name": "Teton"
  },
  {
    "code": "US-MT-099",
    "name": "Teton"
  },
  {
    "code": "US-OK-139",
    "name": "Texas"
  },
  {
    "code": "US-MO-215",
    "name": "Texas"
  },
  {
    "code": "US-NE-169",
    "name": "Thayer"
  },
  {
    "code": "US-KS-193",
    "name": "Thomas"
  },
  {
    "code": "US-NE-171",
    "name": "Thomas"
  },
  {
    "code": "US-GA-275",
    "name": "Thomas"
  },
  {
    "code": "US-TX-447",
    "name": "Throckmorton"
  },
  {
    "code": "US-NE-173",
    "name": "Thurston"
  },
  {
    "code": "US-WA-067",
    "name": "Thurston"
  },
  {
    "code": "US-GA-277",
    "name": "Tift"
  },
  {
    "code": "US-OR-057",
    "name": "Tillamook"
  },
  {
    "code": "US-OK-141",
    "name": "Tillman"
  },
  {
    "code": "US-NY-107",
    "name": "Tioga"
  },
  {
    "code": "US-PA-117",
    "name": "Tioga"
  },
  {
    "code": "US-MS-139",
    "name": "Tippah"
  },
  {
    "code": "US-IN-157",
    "name": "Tippecanoe"
  },
  {
    "code": "US-IN-159",
    "name": "Tipton"
  },
  {
    "code": "US-TN-167",
    "name": "Tipton"
  },
  {
    "code": "US-MS-141",
    "name": "Tishomingo"
  },
  {
    "code": "US-TX-449",
    "name": "Titus"
  },
  {
    "code": "US-MN-153",
    "name": "Todd"
  },
  {
    "code": "US-KY-219",
    "name": "Todd"
  },
  {
    "code": "US-SD-121",
    "name": "Todd"
  },
  {
    "code": "US-CT-013",
    "name": "Tolland"
  },
  {
    "code": "US-TX-451",
    "name": "Tom Green"
  },
  {
    "code": "US-NY-109",
    "name": "Tompkins"
  },
  {
    "code": "US-UT-045",
    "name": "Tooele"
  },
  {
    "code": "US-MT-101",
    "name": "Toole"
  },
  {
    "code": "US-GA-279",
    "name": "Toombs"
  },
  {
    "code": "US-NM-057",
    "name": "Torrance"
  },
  {
    "code": "US-ND-095",
    "name": "Towner"
  },
  {
    "code": "US-GA-281",
    "name": "Towns"
  },
  {
    "code": "US-ND-097",
    "name": "Traill"
  },
  {
    "code": "US-NC-175",
    "name": "Transylvania"
  },
  {
    "code": "US-MN-155",
    "name": "Traverse"
  },
  {
    "code": "US-TX-453",
    "name": "Travis"
  },
  {
    "code": "US-MT-103",
    "name": "Treasure"
  },
  {
    "code": "US-KS-195",
    "name": "Trego"
  },
  {
    "code": "US-WI-121",
    "name": "Trempealeau"
  },
  {
    "code": "US-GA-283",
    "name": "Treutlen"
  },
  {
    "code": "US-KY-221",
    "name": "Trigg"
  },
  {
    "code": "US-KY-223",
    "name": "Trimble"
  },
  {
    "code": "US-CA-105",
    "name": "Trinity"
  },
  {
    "code": "US-TX-455",
    "name": "Trinity"
  },
  {
    "code": "US-SD-123",
    "name": "Tripp"
  },
  {
    "code": "US-GA-285",
    "name": "Troup"
  },
  {
    "code": "US-TN-169",
    "name": "Trousdale"
  },
  {
    "code": "US-OH-155",
    "name": "Trumbull"
  },
  {
    "code": "US-WV-093",
    "name": "Tucker"
  },
  {
    "code": "US-CA-107",
    "name": "Tulare"
  },
  {
    "code": "US-OK-143",
    "name": "Tulsa"
  },
  {
    "code": "US-MS-143",
    "name": "Tunica"
  },
  {
    "code": "US-CA-109",
    "name": "Tuolumne"
  },
  {
    "code": "US-GA-287",
    "name": "Turner"
  },
  {
    "code": "US-SD-125",
    "name": "Turner"
  },
  {
    "code": "US-AL-125",
    "name": "Tuscaloosa"
  },
  {
    "code": "US-OH-157",
    "name": "Tuscarawas"
  },
  {
    "code": "US-MI-157",
    "name": "Tuscola"
  },
  {
    "code": "US-GA-289",
    "name": "Twiggs"
  },
  {
    "code": "US-ID-083",
    "name": "Twin Falls"
  },
  {
    "code": "US-WV-095",
    "name": "Tyler"
  },
  {
    "code": "US-TX-457",
    "name": "Tyler"
  },
  {
    "code": "US-NC-177",
    "name": "Tyrrell"
  },
  {
    "code": "US-WY-041",
    "name": "Uinta"
  },
  {
    "code": "US-UT-047",
    "name": "Uintah"
  },
  {
    "code": "US-NY-111",
    "name": "Ulster"
  },
  {
    "code": "US-OR-059",
    "name": "Umatilla"
  },
  {
    "code": "US-TN-171",
    "name": "Unicoi"
  },
  {
    "code": "US-IN-161",
    "name": "Union"
  },
  {
    "code": "US-OR-061",
    "name": "Union"
  },
  {
    "code": "US-SC-087",
    "name": "Union"
  },
  {
    "code": "US-AR-139",
    "name": "Union"
  },
  {
    "code": "US-GA-291",
    "name": "Union"
  },
  {
    "code": "US-FL-125",
    "name": "Union"
  },
  {
    "code": "US-TN-173",
    "name": "Union"
  },
  {
    "code": "US-NM-059",
    "name": "Union"
  },
  {
    "code": "US-PA-119",
    "name": "Union"
  },
  {
    "code": "US-KY-225",
    "name": "Union"
  },
  {
    "code": "US-LA-111",
    "name": "Union"
  },
  {
    "code": "US-NC-179",
    "name": "Union"
  },
  {
    "code": "US-IL-181",
    "name": "Union"
  },
  {
    "code": "US-NJ-039",
    "name": "Union"
  },
  {
    "code": "US-MS-145",
    "name": "Union"
  },
  {
    "code": "US-IA-175",
    "name": "Union"
  },
  {
    "code": "US-SD-127",
    "name": "Union"
  },
  {
    "code": "US-OH-159",
    "name": "Union"
  },
  {
    "code": "US-WV-097",
    "name": "Upshur"
  },
  {
    "code": "US-TX-459",
    "name": "Upshur"
  },
  {
    "code": "US-GA-293",
    "name": "Upson"
  },
  {
    "code": "US-TX-461",
    "name": "Upton"
  },
  {
    "code": "US-UT-049",
    "name": "Utah"
  },
  {
    "code": "US-TX-463",
    "name": "Uvalde"
  },
  {
    "code": "US-TX-465",
    "name": "Val Verde"
  },
  {
    "code": "US-NM-061",
    "name": "Valencia"
  },
  {
    "code": "US-NE-175",
    "name": "Valley"
  },
  {
    "code": "US-ID-085",
    "name": "Valley"
  },
  {
    "code": "US-MT-105",
    "name": "Valley"
  },
  {
    "code": "US-AR-141",
    "name": "Van Buren"
  },
  {
    "code": "US-TN-175",
    "name": "Van Buren"
  },
  {
    "code": "US-IA-177",
    "name": "Van Buren"
  },
  {
    "code": "US-MI-159",
    "name": "Van Buren"
  },
  {
    "code": "US-OH-161",
    "name": "Van Wert"
  },
  {
    "code": "US-TX-467",
    "name": "Van Zandt"
  },
  {
    "code": "US-NC-181",
    "name": "Vance"
  },
  {
    "code": "US-IN-163",
    "name": "Vanderburgh"
  },
  {
    "code": "US-PA-121",
    "name": "Venango"
  },
  {
    "code": "US-CA-111",
    "name": "Ventura"
  },
  {
    "code": "US-LA-113",
    "name": "Vermilion"
  },
  {
    "code": "US-IL-183",
    "name": "Vermilion"
  },
  {
    "code": "US-IN-165",
    "name": "Vermillion"
  },
  {
    "code": "US-MO-217",
    "name": "Vernon"
  },
  {
    "code": "US-LA-115",
    "name": "Vernon"
  },
  {
    "code": "US-WI-123",
    "name": "Vernon"
  },
  {
    "code": "US-TX-469",
    "name": "Victoria"
  },
  {
    "code": "US-IN-167",
    "name": "Vigo"
  },
  {
    "code": "US-WI-125",
    "name": "Vilas"
  },
  {
    "code": "US-OH-163",
    "name": "Vinton"
  },
  {
    "code": "US-VA-810",
    "name": "Virginia Beach"
  },
  {
    "code": "US-FL-127",
    "name": "Volusia"
  },
  {
    "code": "US-IN-169",
    "name": "Wabash"
  },
  {
    "code": "US-IL-185",
    "name": "Wabash"
  },
  {
    "code": "US-MN-157",
    "name": "Wabasha"
  },
  {
    "code": "US-KS-197",
    "name": "Wabaunsee"
  },
  {
    "code": "US-MN-159",
    "name": "Wadena"
  },
  {
    "code": "US-OK-145",
    "name": "Wagoner"
  },
  {
    "code": "US-WA-069",
    "name": "Wahkiakum"
  },
  {
    "code": "US-NC-183",
    "name": "Wake"
  },
  {
    "code": "US-FL-129",
    "name": "Wakulla"
  },
  {
    "code": "US-ME-027",
    "name": "Waldo"
  },
  {
    "code": "US-GA-295",
    "name": "Walker"
  },
  {
    "code": "US-TX-471",
    "name": "Walker"
  },
  {
    "code": "US-AL-127",
    "name": "Walker"
  },
  {
    "code": "US-WA-071",
    "name": "Walla Walla"
  },
  {
    "code": "US-KS-199",
    "name": "Wallace"
  },
  {
    "code": "US-TX-473",
    "name": "Waller"
  },
  {
    "code": "US-OR-063",
    "name": "Wallowa"
  },
  {
    "code": "US-ND-099",
    "name": "Walsh"
  },
  {
    "code": "US-MS-147",
    "name": "Walthall"
  },
  {
    "code": "US-GA-297",
    "name": "Walton"
  },
  {
    "code": "US-FL-131",
    "name": "Walton"
  },
  {
    "code": "US-SD-129",
    "name": "Walworth"
  },
  {
    "code": "US-WI-127",
    "name": "Walworth"
  },
  {
    "code": "US-IA-179",
    "name": "Wapello"
  },
  {
    "code": "US-TX-475",
    "name": "Ward"
  },
  {
    "code": "US-ND-101",
    "name": "Ward"
  },
  {
    "code": "US-GA-299",
    "name": "Ware"
  },
  {
    "code": "US-IN-171",
    "name": "Warren"
  },
  {
    "code": "US-VA-187",
    "name": "Warren"
  },
  {
    "code": "US-GA-301",
    "name": "Warren"
  },
  {
    "code": "US-TN-177",
    "name": "Warren"
  },
  {
    "code": "US-MO-219",
    "name": "Warren"
  },
  {
    "code": "US-NY-113",
    "name": "Warren"
  },
  {
    "code": "US-PA-123",
    "name": "Warren"
  },
  {
    "code": "US-KY-227",
    "name": "Warren"
  },
  {
    "code": "US-NC-185",
    "name": "Warren"
  },
  {
    "code": "US-IL-187",
    "name": "Warren"
  },
  {
    "code": "US-NJ-041",
    "name": "Warren"
  },
  {
    "code": "US-MS-149",
    "name": "Warren"
  },
  {
    "code": "US-IA-181",
    "name": "Warren"
  },
  {
    "code": "US-OH-165",
    "name": "Warren"
  },
  {
    "code": "US-IN-173",
    "name": "Warrick"
  },
  {
    "code": "US-UT-051",
    "name": "Wasatch"
  },
  {
    "code": "US-OR-065",
    "name": "Wasco"
  },
  {
    "code": "US-MN-161",
    "name": "Waseca"
  },
  {
    "code": "US-WY-043",
    "name": "Washakie"
  },
  {
    "code": "US-WI-129",
    "name": "Washburn"
  },
  {
    "code": "US-OK-147",
    "name": "Washington"
  },
  {
    "code": "US-IN-175",
    "name": "Washington"
  },
  {
    "code": "US-OR-067",
    "name": "Washington"
  },
  {
    "code": "US-ME-029",
    "name": "Washington"
  },
  {
    "code": "US-KS-201",
    "name": "Washington"
  },
  {
    "code": "US-AR-143",
    "name": "Washington"
  },
  {
    "code": "US-NE-177",
    "name": "Washington"
  },
  {
    "code": "US-VA-191",
    "name": "Washington"
  },
  {
    "code": "US-GA-303",
    "name": "Washington"
  },
  {
    "code": "US-FL-133",
    "name": "Washington"
  },
  {
    "code": "US-MN-163",
    "name": "Washington"
  },
  {
    "code": "US-TN-179",
    "name": "Washington"
  },
  {
    "code": "US-MO-221",
    "name": "Washington"
  },
  {
    "code": "US-UT-053",
    "name": "Washington"
  },
  {
    "code": "US-NY-115",
    "name": "Washington"
  },
  {
    "code": "US-PA-125",
    "name": "Washington"
  },
  {
    "code": "US-ID-087",
    "name": "Washington"
  },
  {
    "code": "US-TX-477",
    "name": "Washington"
  },
  {
    "code": "US-VT-023",
    "name": "Washington"
  },
  {
    "code": "US-KY-229",
    "name": "Washington"
  },
  {
    "code": "US-LA-117",
    "name": "Washington"
  },
  {
    "code": "US-RI-009",
    "name": "Washington"
  },
  {
    "code": "US-NC-187",
    "name": "Washington"
  },
  {
    "code": "US-IL-189",
    "name": "Washington"
  },
  {
    "code": "US-MS-151",
    "name": "Washington"
  },
  {
    "code": "US-IA-183",
    "name": "Washington"
  },
  {
    "code": "US-AL-129",
    "name": "Washington"
  },
  {
    "code": "US-OH-167",
    "name": "Washington"
  },
  {
    "code": "US-WI-131",
    "name": "Washington"
  },
  {
    "code": "US-MD-043",
    "name": "Washington"
  },
  {
    "code": "US-CO-121",
    "name": "Washington"
  },
  {
    "code": "US-OK-149",
    "name": "Washita"
  },
  {
    "code": "US-NV-031",
    "name": "Washoe"
  },
  {
    "code": "US-MI-161",
    "name": "Washtenaw"
  },
  {
    "code": "US-NC-189",
    "name": "Watauga"
  },
  {
    "code": "US-MN-165",
    "name": "Watonwan"
  },
  {
    "code": "US-WI-133",
    "name": "Waukesha"
  },
  {
    "code": "US-WI-135",
    "name": "Waupaca"
  },
  {
    "code": "US-WI-137",
    "name": "Waushara"
  },
  {
    "code": "US-IN-177",
    "name": "Wayne"
  },
  {
    "code": "US-NE-179",
    "name": "Wayne"
  },
  {
    "code": "US-GA-305",
    "name": "Wayne"
  },
  {
    "code": "US-WV-099",
    "name": "Wayne"
  },
  {
    "code": "US-TN-181",
    "name": "Wayne"
  },
  {
    "code": "US-MO-223",
    "name": "Wayne"
  },
  {
    "code": "US-UT-055",
    "name": "Wayne"
  },
  {
    "code": "US-NY-117",
    "name": "Wayne"
  },
  {
    "code": "US-PA-127",
    "name": "Wayne"
  },
  {
    "code": "US-KY-231",
    "name": "Wayne"
  },
  {
    "code": "US-NC-191",
    "name": "Wayne"
  },
  {
    "code": "US-IL-191",
    "name": "Wayne"
  },
  {
    "code": "US-MS-153",
    "name": "Wayne"
  },
  {
    "code": "US-IA-185",
    "name": "Wayne"
  },
  {
    "code": "US-OH-169",
    "name": "Wayne"
  },
  {
    "code": "US-MI-163",
    "name": "Wayne"
  },
  {
    "code": "US-VA-820",
    "name": "Waynesboro"
  },
  {
    "code": "US-TN-183",
    "name": "Weakley"
  },
  {
    "code": "US-TX-479",
    "name": "Webb"
  },
  {
    "code": "US-UT-057",
    "name": "Weber"
  },
  {
    "code": "US-NE-181",
    "name": "Webster"
  },
  {
    "code": "US-WV-101",
    "name": "Webster"
  },
  {
    "code": "US-GA-307",
    "name": "Webster"
  },
  {
    "code": "US-MO-225",
    "name": "Webster"
  },
  {
    "code": "US-LA-119",
    "name": "Webster"
  },
  {
    "code": "US-KY-233",
    "name": "Webster"
  },
  {
    "code": "US-MS-155",
    "name": "Webster"
  },
  {
    "code": "US-IA-187",
    "name": "Webster"
  },
  {
    "code": "US-CO-123",
    "name": "Weld"
  },
  {
    "code": "US-IN-179",
    "name": "Wells"
  },
  {
    "code": "US-ND-103",
    "name": "Wells"
  },
  {
    "code": "US-LA-121",
    "name": "West Baton Rouge"
  },
  {
    "code": "US-LA-123",
    "name": "West Carroll"
  },
  {
    "code": "US-LA-125",
    "name": "West Feliciana"
  },
  {
    "code": "US-NY-119",
    "name": "Westchester"
  },
  {
    "code": "US-VA-193",
    "name": "Westmoreland"
  },
  {
    "code": "US-PA-129",
    "name": "Westmoreland"
  },
  {
    "code": "US-WY-045",
    "name": "Weston"
  },
  {
    "code": "US-WV-103",
    "name": "Wetzel"
  },
  {
    "code": "US-MI-165",
    "name": "Wexford"
  },
  {
    "code": "US-TX-481",
    "name": "Wharton"
  },
  {
    "code": "US-WA-073",
    "name": "Whatcom"
  },
  {
    "code": "US-MT-107",
    "name": "Wheatland"
  },
  {
    "code": "US-OR-069",
    "name": "Wheeler"
  },
  {
    "code": "US-NE-183",
    "name": "Wheeler"
  },
  {
    "code": "US-GA-309",
    "name": "Wheeler"
  },
  {
    "code": "US-TX-483",
    "name": "Wheeler"
  },
  {
    "code": "US-IN-181",
    "name": "White"
  },
  {
    "code": "US-AR-145",
    "name": "White"
  },
  {
    "code": "US-GA-311",
    "name": "White"
  },
  {
    "code": "US-TN-185",
    "name": "White"
  },
  {
    "code": "US-IL-193",
    "name": "White"
  },
  {
    "code": "US-NV-033",
    "name": "White Pine"
  },
  {
    "code": "US-IL-195",
    "name": "Whiteside"
  },
  {
    "code": "US-GA-313",
    "name": "Whitfield"
  },
  {
    "code": "US-IN-183",
    "name": "Whitley"
  },
  {
    "code": "US-KY-235",
    "name": "Whitley"
  },
  {
    "code": "US-WA-075",
    "name": "Whitman"
  },
  {
    "code": "US-MT-109",
    "name": "Wibaux"
  },
  {
    "code": "US-KS-203",
    "name": "Wichita"
  },
  {
    "code": "US-TX-485",
    "name": "Wichita"
  },
  {
    "code": "US-MD-045",
    "name": "Wicomico"
  },
  {
    "code": "US-TX-487",
    "name": "Wilbarger"
  },
  {
    "code": "US-GA-315",
    "name": "Wilcox"
  },
  {
    "code": "US-AL-131",
    "name": "Wilcox"
  },
  {
    "code": "US-GA-317",
    "name": "Wilkes"
  },
  {
    "code": "US-NC-193",
    "name": "Wilkes"
  },
  {
    "code": "US-MN-167",
    "name": "Wilkin"
  },
  {
    "code": "US-GA-319",
    "name": "Wilkinson"
  },
  {
    "code": "US-MS-157",
    "name": "Wilkinson"
  },
  {
    "code": "US-IL-197",
    "name": "Will"
  },
  {
    "code": "US-TX-489",
    "name": "Willacy"
  },
  {
    "code": "US-OH-171",
    "name": "Williams"
  },
  {
    "code": "US-ND-105",
    "name": "Williams"
  },
  {
    "code": "US-SC-089",
    "name": "Williamsburg"
  },
  {
    "code": "US-VA-830",
    "name": "Williamsburg"
  },
  {
    "code": "US-TN-187",
    "name": "Williamson"
  },
  {
    "code": "US-TX-491",
    "name": "Williamson"
  },
  {
    "code": "US-IL-199",
    "name": "Williamson"
  },
  {
    "code": "US-KS-205",
    "name": "Wilson"
  },
  {
    "code": "US-TN-189",
    "name": "Wilson"
  },
  {
    "code": "US-TX-493",
    "name": "Wilson"
  },
  {
    "code": "US-NC-195",
    "name": "Wilson"
  },
  {
    "code": "US-VA-840",
    "name": "Winchester"
  },
  {
    "code": "US-CT-015",
    "name": "Windham"
  },
  {
    "code": "US-VT-025",
    "name": "Windham"
  },
  {
    "code": "US-VT-027",
    "name": "Windsor"
  },
  {
    "code": "US-TX-495",
    "name": "Winkler"
  },
  {
    "code": "US-LA-127",
    "name": "Winn"
  },
  {
    "code": "US-IA-189",
    "name": "Winnebago"
  },
  {
    "code": "US-WI-139",
    "name": "Winnebago"
  },
  {
    "code": "US-IL-201",
    "name": "Winnebago"
  },
  {
    "code": "US-IA-191",
    "name": "Winneshiek"
  },
  {
    "code": "US-MN-169",
    "name": "Winona"
  },
  {
    "code": "US-MS-159",
    "name": "Winston"
  },
  {
    "code": "US-AL-133",
    "name": "Winston"
  },
  {
    "code": "US-WV-105",
    "name": "Wirt"
  },
  {
    "code": "US-VA-195",
    "name": "Wise"
  },
  {
    "code": "US-TX-497",
    "name": "Wise"
  },
  {
    "code": "US-KY-237",
    "name": "Wolfe"
  },
  {
    "code": "US-WV-107",
    "name": "Wood"
  },
  {
    "code": "US-TX-499",
    "name": "Wood"
  },
  {
    "code": "US-WI-141",
    "name": "Wood"
  },
  {
    "code": "US-OH-173",
    "name": "Wood"
  },
  {
    "code": "US-IA-193",
    "name": "Woodbury"
  },
  {
    "code": "US-KY-239",
    "name": "Woodford"
  },
  {
    "code": "US-IL-203",
    "name": "Woodford"
  },
  {
    "code": "US-AR-147",
    "name": "Woodruff"
  },
  {
    "code": "US-OK-151",
    "name": "Woods"
  },
  {
    "code": "US-KS-207",
    "name": "Woodson"
  },
  {
    "code": "US-OK-153",
    "name": "Woodward"
  },
  {
    "code": "US-MD-047",
    "name": "Worcester"
  },
  {
    "code": "US-MA-027",
    "name": "Worcester"
  },
  {
    "code": "US-GA-321",
    "name": "Worth"
  },
  {
    "code": "US-MO-227",
    "name": "Worth"
  },
  {
    "code": "US-IA-195",
    "name": "Worth"
  },
  {
    "code": "US-AK-275",
    "name": "Wrangell City and Borough"
  },
  {
    "code": "US-MN-171",
    "name": "Wright"
  },
  {
    "code": "US-MO-229",
    "name": "Wright"
  },
  {
    "code": "US-IA-197",
    "name": "Wright"
  },
  {
    "code": "US-OH-175",
    "name": "Wyandot"
  },
  {
    "code": "US-KS-209",
    "name": "Wyandotte"
  },
  {
    "code": "US-WV-109",
    "name": "Wyoming"
  },
  {
    "code": "US-NY-121",
    "name": "Wyoming"
  },
  {
    "code": "US-PA-131",
    "name": "Wyoming"
  },
  {
    "code": "US-VA-197",
    "name": "Wythe"
  },
  {
    "code": "US-NC-197",
    "name": "Yadkin"
  },
  {
    "code": "US-WA-077",
    "name": "Yakima"
  },
  {
    "code": "US-AK-282",
    "name": "Yakutat City and Borough"
  },
  {
    "code": "US-MS-161",
    "name": "Yalobusha"
  },
  {
    "code": "US-OR-071",
    "name": "Yamhill"
  },
  {
    "code": "US-NC-199",
    "name": "Yancey"
  },
  {
    "code": "US-SD-135",
    "name": "Yankton"
  },
  {
    "code": "US-NY-123",
    "name": "Yates"
  },
  {
    "code": "US-AZ-025",
    "name": "Yavapai"
  },
  {
    "code": "US-MS-163",
    "name": "Yazoo"
  },
  {
    "code": "US-AR-149",
    "name": "Yell"
  },
  {
    "code": "US-MN-173",
    "name": "Yellow Medicine"
  },
  {
    "code": "US-MT-111",
    "name": "Yellowstone"
  },
  {
    "code": "US-TX-501",
    "name": "Yoakum"
  },
  {
    "code": "US-CA-113",
    "name": "Yolo"
  },
  {
    "code": "US-ME-031",
    "name": "York"
  },
  {
    "code": "US-SC-091",
    "name": "York"
  },
  {
    "code": "US-NE-185",
    "name": "York"
  },
  {
    "code": "US-VA-199",
    "name": "York"
  },
  {
    "code": "US-PA-133",
    "name": "York"
  },
  {
    "code": "US-TX-503",
    "name": "Young"
  },
  {
    "code": "US-CA-115",
    "name": "Yuba"
  },
  {
    "code": "US-AK-290",
    "name": "Yukon-Koyukuk Census Area"
  },
  {
    "code": "US-AZ-027",
    "name": "Yuma"
  },
  {
    "code": "US-CO-125",
    "name": "Yuma"
  },
  {
    "code": "US-TX-505",
    "name": "Zapata"
  },
  {
    "code": "US-TX-507",
    "name": "Zavala"
  },
  {
    "code": "US-SD-137",
    "name": "Ziebach"
  }
]